export default {
  translation: {
    common: {
      confirm: 'تأیید',
      back: 'بازگشت',
      noResults: 'نتیجه‌ای یافت نشد',
      selectPlaceholder: 'یک مقدار انتخاب کنید',
      selectAll: 'انتخاب همه',
      delete: 'حذف',
      deleteModalTitle: 'آیا از حذف آن مطمئن هستید؟',
      deleteThem: 'آیا از حذف آن‌ها مطمئن هستید؟',
      removeModalTitle: 'آیا از حذف کردن آن مطمئن هستید؟',
      ok: 'تأیید',
      cancel: 'انصراف',
      yes: 'بله',
      no: 'خیر',
      total: 'مجموع',
      top: '{{top}} مورد برتر',
      rename: 'تغییر نام',
      name: 'نام',
      save: 'ذخیره',
      stop: 'توقف',
      resume: 'ادامه',
      namePlaceholder: 'لطفاً نام را وارد کنید',
      nameSlashError: 'نام نمی‌تواند شامل «/» باشد',
      descriptionPlaceholder: 'توضیحات را وارد کنید',
      descriptionMaxLength: 'توضیحات باید حداکثر {{max}} کاراکتر باشد.',
      next: 'بعدی',
      create: 'ایجاد',
      edit: 'ویرایش',
      upload: 'بارگذاری',
      english: 'انگلیسی',
      portugueseBr: 'پرتغالی (برزیل)',
      chinese: 'چینی ساده‌شده',
      traditionalChinese: 'چینی سنتی',
      russian: 'روسی',
      indonesian: 'اندونزیایی',
      indonesia: 'اندونزیایی',
      spanish: 'اسپانیایی',
      vietnamese: 'ویتنامی',
      japanese: 'ژاپنی',
      german: 'آلمانی',
      french: 'فرانسوی',
      italian: 'ایتالیایی',
      bulgarian: 'بلغاری',
      arabic: 'عربی',
      persian: 'فارسی',
      turkish: 'ترکی',
      dutch: 'هلندی',
      language: 'زبان',
      languageMessage: 'لطفاً زبان خود را وارد کنید!',
      languagePlaceholder: 'زبان خود را انتخاب کنید',
      copy: 'کپی',
      copied: 'کپی شد',
      viewMore: 'مشاهده بیشتر',
      viewLess: 'مشاهده کمتر',
      comingSoon: 'به‌زودی',
      download: 'دانلود',
      figure: 'شکل',
      close: 'بستن',
      preview: 'پیش‌نمایش',
      move: 'انتقال',
      warn: 'هشدار',
      action: 'عملیات',
      s: 'ث',
      pleaseSelect: 'لطفاً انتخاب کنید',
      pleaseInput: 'لطفاً وارد کنید',
      modelUnavailable:
        'مدلی که قبلاً انتخاب شده بود حذف شده است، لطفاً مدل دیگری انتخاب کنید',
      submit: 'ثبت',
      clear: 'پاک کردن',
      embedIntoSite: 'جاسازی در صفحه وب',
      openInNewTab: 'باز کردن در برگه جدید',
      previousPage: 'قبلی',
      nextPage: 'بعدی',
      previous: 'قبلی',
      add: 'افزودن',
      remove: 'حذف',
      search: 'جستجو',
      reset: 'بازنشانی',
      noDataFound: 'داده‌ای یافت نشد.',
      searchOrEnterToAdd: 'برای افزودن جستجو یا وارد کنید',
      noData: 'داده‌ای موجود نیست',
      promptPlaceholder: `لطفاً وارد کنید یا با / متغیرها را سریع درج کنید.`,
      mcp: {
        namePlaceholder: 'سرور MCP من',
        nameRequired:
          'باید بین ۱ تا ۶۴ کاراکتر باشد و فقط می‌تواند شامل حروف، اعداد، خط تیره و زیرخط باشد.',
        urlPlaceholder: 'https://api.example.com/v1/mcp',
        tokenPlaceholder: 'مثال: eyJhbGciOiJIUzI1Ni...',
      },
      selected: 'انتخاب‌شده',
      seeAll: 'مشاهده همه',
      bulkOperate: 'عملیات گروهی',
      owner: 'مالک',
      running: 'در حال اجرا...',
    },
    login: {
      loginTitle: 'به حساب خود وارد شوید',
      signUpTitle: 'ایجاد حساب کاربری',
      login: 'ورود',
      signUp: 'ثبت‌نام',
      loginDescription: 'از دیدن دوباره شما بسیار خوشحالیم!',
      registerDescription: 'خوشحالیم که به ما پیوستید!',
      emailLabel: 'ایمیل',
      emailPlaceholder: 'لطفاً ایمیل را وارد کنید',
      passwordLabel: 'رمز عبور',
      passwordPlaceholder: 'لطفاً رمز عبور را وارد کنید',
      rememberMe: 'مرا به خاطر بسپار',
      signInTip: 'حساب کاربری ندارید؟',
      signUpTip: 'قبلاً حساب کاربری دارید؟',
      nicknameLabel: 'نام مستعار',
      nicknamePlaceholder: 'لطفاً نام مستعار را وارد کنید',
      register: 'ایجاد حساب کاربری',
      continue: 'ادامه',
      title: 'یک موتور RAG پیشرفته برای پردازش و بازیابی اطلاعات در مدل‌های زبانی بزرگ',
      start: 'بیایید شروع کنیم',
      description:
        'رایگان ثبت‌نام کنید و فناوری RAG را برای پردازش و بازیابی اطلاعات تجربه کنید. مجموعه‌داده و هوش مصنوعی بسازید تا کسب‌وکارتان قوی‌تر شود.',
      review: 'از بیش از ۵۰۰ نظر',
      seeAll: 'مشاهده همه',
    },
    header: {
      knowledgeBase: 'مجموعه‌داده',
      chat: 'گفتگو',
      register: 'ثبت‌نام',
      signin: 'ورود',
      home: 'خانه',
      setting: 'تنظیمات کاربر',
      logout: 'خروج',
      fileManager: 'فایل',
      skills: 'مهارت‌ها',
      flow: 'عامل',
      search: 'جستجو',
      welcome: 'خوش آمدید به',
      dataset: 'مجموعه‌داده',
      memories: 'حافظه',
      discord: 'دیسکورد',
      github: 'گیت‌هاب',
      help: 'راهنماها',
    },
    skills: {
      title: 'مهارت‌ها',
      selectSpace: 'برای شروع یک فضای مهارت انتخاب کنید',
      spacePlaceholder: 'نام فضا را وارد کنید',
      createSpace: 'ایجاد فضای مهارت',
      createSpaceTitle: 'ایجاد فضای مهارت جدید',
      createSpaceDescription:
        'یک فضای جدید برای سازماندهی و مدیریت مهارت‌های خود ایجاد کنید.',
      spaceName: 'نام فضا',
      spaceNamePlaceholder: 'مثال: my-space',
      spaceNameRequired: 'لطفاً نام فضا را وارد کنید',
      noSpaces: 'هنوز فضای مهارتی وجود ندارد. اولین فضای خود را بسازید!',
      enterSpace: 'ورود',
      spaceCreated: 'فضای مهارت با موفقیت ایجاد شد',
      spaceDeleted: 'فضای مهارت با موفقیت حذف شد',
      fetchError: 'دریافت مهارت‌ها ناموفق بود',
      deleteSpaceTitle: 'حذف فضای مهارت',
      deleteSpaceDescription:
        'آیا از حذف این فضای مهارت مطمئن هستید؟ این عمل قابل بازگشت نیست و همه مهارت‌های این فضا برای همیشه حذف خواهند شد.',
      deleteSpaceName: 'نام فضا',
      uploadSuccess: 'مهارت با موفقیت بارگذاری شد',
      uploadError: 'بارگذاری مهارت ناموفق بود',
      deleteSuccess: 'مهارت با موفقیت حذف شد',
      deleteError: 'حذف مهارت ناموفق بود',
      skillExists:
        'مهارتی با این نام از قبل وجود دارد. لطفاً ابتدا آن را حذف کنید یا از نام دیگری استفاده کنید.',
      uploadSkill: 'بارگذاری مهارت',
      searchPlaceholder: 'جستجوی مهارت‌ها...',
      noSkills: 'هنوز مهارتی وجود ندارد. اولین مهارت خود را بارگذاری کنید.',
      noSearchResults: 'هیچ مهارتی مطابق با جستجوی شما یافت نشد',
      filesCount: '{{count}} فایل',
      foldersCount: '{{count}} پوشه',
      pageInfo: 'صفحه {{current}} از {{total}}',
      totalSkills: 'مجموعاً {{total}} مهارت',
      backToSkills: 'بازگشت به مهارت‌ها',
      selectFileToView: 'یک فایل برای مشاهده انتخاب کنید',
      skillName: 'نام مهارت',
      skillNamePlaceholder: 'مثال: my-awesome-skill',
      skillNameHelp: 'فقط حروف، اعداد، خط تیره و زیرخط مجاز است',
      source: 'منبع',
      version: 'نسخه',
      skillVersion: 'نسخه',
      skillVersionPlaceholder: 'مثال: 1.0.0',
      versionFormatHelp: 'نسخه باید در قالب semver باشد (مثال: 1.0.0)',
      versionRequired: 'نسخه الزامی است',
      selectFilesOrFolder: 'انتخاب فایل‌ها یا پوشه',
      uploadDescription:
        'فایل‌های مهارت را بارگذاری کنید. می‌توانید فایل‌ها را بکشید و رها کنید یا یک پوشه انتخاب کنید.',
      selectFolder: 'انتخاب پوشه',
      dragFilesHint: 'یا فایل‌ها را در زیر بکشید',
      dragFilesTitle: 'پوشه مهارت را اینجا بکشید',
      dragFilesDescription:
        'یک پوشه مهارت را اینجا بکشید و رها کنید، یا از دکمه «انتخاب پوشه» در زیر استفاده کنید.',
      filesSelected: '{{count}} فایل انتخاب شد',
      uploading: 'در حال بارگذاری...',
      files: 'فایل‌ها',
      noFiles: 'فایلی وجود ندارد',
      versionHistory: 'تاریخچه نسخه‌ها',
      selectVersion: 'نسخه‌ای برای پیش‌نمایش انتخاب کنید',
      latest: 'آخرین',
      metadata: {
        basic: 'اطلاعات پایه',
        emoji: 'ایموجی',
        skillKey: 'کلید مهارت',
        always: 'همیشه فعال',
        primaryEnv: 'متغیر محیطی اصلی',
        requires: 'پیش‌نیازها',
        requiredBins: 'باینری‌های موردنیاز',
        requiredEnv: 'متغیرهای محیطی موردنیاز',
        anyBins: 'حداقل یکی موردنیاز است',
        install: 'وابستگی‌ها',
        links: 'پیوندها',
        homepage: 'صفحه اصلی',
        repository: 'مخزن',
        documentation: 'مستندات',
      },
      validation: {
        missing_skill_md:
          'مهارت نامعتبر: SKILL.md یافت نشد. لطفاً مطمئن شوید که پوشه مهارت شما شامل یک فایل معتبر SKILL.md است.',
        invalid_frontmatter:
          'مهارت نامعتبر: SKILL.md باید frontmatter معتبر داشته باشد (با --- شروع و پایان یابد).',
        missing_name:
          'مهارت نامعتبر: frontmatter در SKILL.md باید شامل فیلد «name» باشد.',
        invalid_name_format:
          'مهارت نامعتبر: «name» باید با حروف کوچک و ایمن برای URL باشد (فقط حروف، اعداد و خط تیره).',
        invalid_version:
          'مهارت نامعتبر: «version» باید semver معتبر باشد (مثال: 1.0.0).',
        invalid_metadata: 'مهارت نامعتبر: فراداده شامل فیلدهای نامعتبر است.',
        invalid_file_type: 'مهارت نامعتبر: فقط فایل‌های متنی مجاز هستند.',
        invalid_path: 'مهارت نامعتبر: مسیر فایل شامل کاراکترهای نامعتبر است.',
        file_too_large:
          'مهارت نامعتبر: اندازه هر فایل از محدودیت ۵ مگابایت فراتر رفته است.',
        total_size_exceeded:
          'مهارت نامعتبر: اندازه کل بسته از محدودیت ۵۰ مگابایت فراتر رفته است.',
        no_files: 'هیچ فایلی انتخاب نشده است. لطفاً یک پوشه مهارت انتخاب کنید.',
        noValidFiles: 'هیچ فایل معتبری یافت نشد. لطفاً انتخاب خود را بررسی کنید.',
        junkFilesFound:
          'فایل‌های موقت شناسایی شد (مثال: .DS_Store). لطفاً قبل از بارگذاری آن‌ها را حذف کنید.',
        read_failed: 'مهارت نامعتبر: خواندن فایل SKILL.md ناموفق بود.',
        invalid: 'قالب مهارت نامعتبر است.',
        valid: 'قالب مهارت معتبر است. آماده بارگذاری.',
        versionExists:
          'این نسخه از قبل وجود دارد. لطفاً از شماره نسخه دیگری استفاده کنید.',
        error: 'اعتبارسنجی ناموفق بود',
      },
      parsedMetadata: 'استخراج‌شده از SKILL.md:',
      addSkill: 'افزودن مهارت',
      upload: 'بارگذاری',
      importFromGit: 'وارد کردن از Git',
      gitPlatform: 'پلتفرم',
      repoUrl: 'نشانی مخزن',
      repoUrlHelp: 'از نشانی مخزن به همراه مسیر اختیاری پشتیبانی می‌کند',
      accessToken: 'توکن دسترسی',
      githubTokenHelp:
        'برای مخازن خصوصی یا محدودیت نرخ بالاتر (۵۰۰۰ درخواست در ساعت)',
      giteeTokenHelp:
        'برای مخازن خصوصی یا محدودیت نرخ بالاتر (۲۰۰۰ درخواست در ساعت)',
      rateLimitInfo: 'اطلاعات محدودیت نرخ',
      githubRateLimit:
        'مخازن عمومی: ۶۰ درخواست در ساعت به ازای هر IP. برای ۵۰۰۰ درخواست در ساعت از توکن استفاده کنید.',
      giteeRateLimit:
        'مخازن عمومی: ۱۰۰۰ درخواست در ساعت به ازای هر IP. برای ۲۰۰۰ درخواست در ساعت از توکن استفاده کنید.',
      import: 'وارد کردن',
      importing: 'در حال وارد کردن...',
      configureSearch: 'پیکربندی جستجو',
    },
    skillSearch: {
      configTitle: 'پیکربندی جستجوی مهارت',
      configDesc: 'نحوه نمایه‌سازی و جستجوی مهارت‌ها را پیکربندی کنید',
      embeddingModel: 'مدل جاسازی',
      embeddingModelPlaceholder: 'یک مدل جاسازی انتخاب کنید',
      vectorSimilarityWeight: 'وزن شباهت برداری',
      similarityThreshold: 'آستانه شباهت',
      topK: 'K نتیجه برتر',
      indexFields: 'فیلدهای نمایه',
      indexFieldsDesc: 'انتخاب کنید کدام فیلدها در نمایه جستجو گنجانده شوند',
      fieldName: 'نام',
      fieldNameDesc: 'نام مهارت',
      fieldTags: 'برچسب‌ها',
      fieldTagsDesc: 'برچسب‌های مهارت',
      fieldDescription: 'توضیحات',
      fieldDescriptionDesc: 'توضیحات مهارت',
      fieldContent: 'محتوا',
      fieldContentDesc: 'محتوای مهارت (مثال: README)',
      weight: 'وزن',
      pureVector: 'فقط برداری',
      hybrid: 'ترکیبی',
      keyword: 'کلیدواژه',
      vector: 'برداری',
      keywordOnly: 'فقط کلیدواژه',
      balanced: 'متعادل',
      vectorOnly: 'فقط برداری',
      reindex: 'نمایه‌سازی مجدد همه',
      reindexing: 'در حال نمایه‌سازی مجدد...',
      reindexSuccess: 'نمایه‌سازی مجدد با موفقیت انجام شد',
      pleaseSelectEmbeddingModel: 'لطفاً یک مدل جاسازی انتخاب کنید',
      saveSuccess: 'با موفقیت ذخیره شد',
      saveError: 'ذخیره ناموفق بود',
      semanticSearchPlaceholder: 'جستجوی مهارت‌ها بر اساس معنا...',
      switchToSemantic: 'تغییر به جستجوی معنایی',
      switchToLocal: 'تغییر به جستجوی محلی',
    },
    memories: {
      llmTooltip:
        'محتوای گفتگو را تحلیل می‌کند، اطلاعات کلیدی را استخراج می‌کند و خلاصه‌های حافظه ساختاریافته تولید می‌کند.',
      embeddingModelTooltip:
        'متن را برای جستجوی شباهت معنایی و بازیابی حافظه به بردارهای عددی تبدیل می‌کند.',
      embeddingModelError:
        'نوع حافظه الزامی است و «raw» قابل حذف نیست.',
      memoryTypeTooltip: `Raw: محتوای خام گفتگو بین کاربر و عامل (به‌طور پیش‌فرض الزامی).
حافظه معنایی: دانش عمومی و حقایق درباره کاربر و جهان.
حافظه رویدادی: سوابق زمان‌دار رویدادها و تجربیات خاص.
حافظه رویه‌ای: مهارت‌ها، عادت‌ها و رویه‌های خودکار آموخته‌شده.`,
      raw: 'خام',
      semantic: 'معنایی',
      episodic: 'رویدادی',
      procedural: 'رویه‌ای',
      editName: 'ویرایش نام',
      memory: 'حافظه',
      createMemory: 'ایجاد حافظه',
      name: 'نام',
      memoryNamePlaceholder: 'نام حافظه',
      memoryType: 'نوع حافظه',
      embeddingModel: 'مدل جاسازی',
      selectModel: 'انتخاب مدل',
      llm: 'مدل زبانی',
      delMemoryWarn: `پس از حذف، همه پیام‌های این حافظه حذف می‌شوند و توسط عامل‌ها قابل بازیابی نخواهند بود.`,
    },
    memory: {
      taskLogDialog: {
        title: 'حافظه',
        startTime: 'زمان شروع',
        status: 'وضعیت',
        details: 'جزئیات',

        success: 'موفق',
        running: 'در حال اجرا',
        failed: 'ناموفق',
      },

      messages: {
        forget: 'فراموش کردن',
        forgetMessageTip: 'آیا مطمئن هستید که می‌خواهید فراموش کنید؟',
        messageDescription:
          'استخراج حافظه با پرامپت‌ها و دما از تنظیمات پیشرفته پیکربندی می‌شود.',
        copied: 'کپی شد!',
        contentEmbed: 'جاسازی محتوا',
        content: 'محتوا',
        delMessageWarn: `پس از فراموش کردن، این پیام توسط عامل‌ها بازیابی نخواهد شد.`,
        forgetMessage: 'فراموش کردن پیام',
        sessionId: 'شناسه نشست',
        agent: 'عامل',
        type: 'نوع',
        validDate: 'تاریخ اعتبار',
        forgetAt: 'فراموشی در',
        source: 'منبع',
        enable: 'فعال‌سازی',
        action: 'عملیات',
      },
      config: {
        titleDescription:
          'پیکربندی حافظه خود را اینجا به‌روزرسانی کنید، به‌ویژه مدل زبانی و پرامپت‌ها.',
        descriptionPlaceholder: 'حافظه خود را توصیف کنید',
        memorySizeTooltip: `محتوای هر پیام + بردار جاسازی آن را محاسبه می‌کند (تقریباً محتوا + ابعاد × ۸ بایت).
مثال: یک پیام ۱ کیلوبایتی با جاسازی ۱۰۲۴ بُعدی حدود ۹ کیلوبایت مصرف می‌کند. محدودیت پیش‌فرض ۵ مگابایتی حدود ۵۰۰ پیام از این دست را نگه می‌دارد.`,
        avatar: 'آواتار',
        description: 'توضیحات',
        memorySize: 'اندازه حافظه',
        advancedSettings: 'تنظیمات پیشرفته',
        permission: 'دسترسی',
        onlyMe: 'فقط من',
        team: 'تیم',
        storageType: 'نوع ذخیره‌سازی',
        storageTypePlaceholder: 'لطفاً نوع ذخیره‌سازی را انتخاب کنید',
        forgetPolicy: 'سیاست فراموشی',
        temperature: 'دما',
        systemPrompt: 'پرامپت سیستمی',
        systemPromptPlaceholder: 'لطفاً پرامپت سیستمی را وارد کنید',
        userPrompt: 'پرامپت کاربر',
        userPromptPlaceholder: 'لطفاً پرامپت کاربر را وارد کنید',
      },
      sideBar: {
        messages: 'پیام‌ها',
        configuration: 'پیکربندی',
      },
    },
    knowledgeList: {
      welcome: 'خوش برگشتید',
      description: 'امروز از کدام مجموعه‌داده‌ها استفاده می‌کنید؟',
      createKnowledgeBase: 'ایجاد مجموعه‌داده',
      name: 'نام',
      namePlaceholder: 'لطفاً نام را وارد کنید.',
      doc: 'اسناد',
      searchKnowledgePlaceholder: 'جستجو',
      noMoreData: `همین بود. چیز دیگری نیست.`,
      parserRequired: 'روش تکه‌بندی الزامی است',
      dataFlowRequired: 'جریان داده الزامی است',
    },
    knowledgeDetails: {
      metadata: {
        fields: 'فیلدها',
        selectFiles: '{{count}} فایل انتخاب شد',
        fieldNameInvalid: 'نام فیلد فقط می‌تواند شامل حروف یا زیرخط باشد.',
        builtIn: 'داخلی',
        generation: 'تولید',
        toMetadataSetting: 'تنظیمات تولید',
        toMetadataSettingTip: 'فراداده خودکار را در پیکربندی تنظیم کنید.',
        descriptionTip:
          'توضیحات یا مثال‌هایی ارائه دهید تا مدل زبانی را در استخراج مقادیر این فیلد راهنمایی کند. اگر خالی بماند، به نام فیلد تکیه خواهد کرد.',
        restrictDefinedValuesTip:
          'حالت شمارشی: استخراج مدل زبانی را فقط به تطبیق با مقادیر از پیش تعیین‌شده محدود می‌کند. مقادیر را در زیر تعریف کنید.',
        valueExists:
          'مقدار از قبل وجود دارد. برای ادغام موارد تکراری و ترکیب همه فایل‌های مرتبط تأیید کنید.',
        fieldNameExists:
          'نام فیلد از قبل وجود دارد. برای ادغام موارد تکراری و ترکیب همه فایل‌های مرتبط تأیید کنید.',
        valueSingleExists:
          'مقدار از قبل وجود دارد. برای ادغام موارد تکراری تأیید کنید.',
        fieldSingleNameExists:
          'نام فیلد از قبل وجود دارد. برای ادغام موارد تکراری تأیید کنید.',
        fieldExists: 'فیلد از قبل وجود دارد.',
        fieldSetting: 'تنظیمات فیلد',
        changesAffectNewParses: 'تغییرات فقط بر تجزیه‌های جدید اثر می‌گذارند.',
        // editMetadataForDataset: 'View and edit metadata for ',
        restrictDefinedValues: 'محدود به مقادیر تعریف‌شده',
        metadataGenerationSettings: 'تنظیمات تولید فراداده',
        // manageMetadataForDataset: 'Manage metadata for this dataset',
        manageMetadata: 'مدیریت فراداده',
        metadata: 'فراداده',
        values: 'مقادیر',
        value: 'مقدار',
        action: 'عملیات',
        field: 'فیلد',
        type: 'نوع',
        description: 'توضیحات',
        fieldName: 'نام فیلد',
        editMetadata: 'ویرایش فراداده',
        addMetadata: 'افزودن فراداده',
        deleteWarn: 'این {{field}} از همه فایل‌های مرتبط حذف خواهد شد',
        deleteManageFieldAllWarn:
          'این فیلد و همه مقادیر متناظر آن از همه فایل‌های مرتبط حذف خواهند شد.',
        deleteManageValueAllWarn:
          'این مقدار از همه فایل‌های مرتبط حذف خواهد شد.',
        deleteManageFieldSingleWarn:
          'این فیلد و همه مقادیر متناظر آن از این فایل حذف خواهند شد.',
        deleteManageValueSingleWarn:
          'این مقدار از این فایل حذف خواهد شد.',
        deleteSettingFieldWarn: `این فیلد حذف خواهد شد؛ فراداده موجود تحت تأثیر قرار نمی‌گیرد.`,
        deleteSettingValueWarn: `این مقدار حذف خواهد شد؛ فراداده موجود تحت تأثیر قرار نمی‌گیرد.`,
      },
      redoAll: 'پاک کردن تکه‌های موجود',
      applyAutoMetadataSettings: 'اعمال تنظیمات سراسری فراداده خودکار',
      parseFileTip: 'آیا از تجزیه مطمئن هستید؟',
      parseFile: 'تجزیه فایل',
      emptyMetadata: 'فراداده‌ای وجود ندارد',
      metadataField: 'فیلد فراداده',
      systemAttribute: 'ویژگی سیستمی',
      localUpload: 'بارگذاری محلی',
      fileSize: 'اندازه فایل',
      fileType: 'نوع فایل',
      uploadedBy: 'بارگذاری‌شده توسط',
      notGenerated: 'تولید نشده',
      generatedOn: 'تولیدشده در ',
      subbarFiles: 'فایل‌ها',
      generateKnowledgeGraph:
        'این کار موجودیت‌ها و روابط را از همه اسناد شما در این مجموعه‌داده استخراج می‌کند. این فرایند ممکن است مدتی طول بکشد.',
      generateRaptor:
        'خوشه‌بندی و خلاصه‌سازی بازگشتی تکه‌های سند را برای ساخت یک ساختار درختی سلسله‌مراتبی انجام می‌دهد و امکان بازیابی آگاه‌تر از زمینه در اسناد طولانی را فراهم می‌کند.',
      generateArtifact:
        'صفحات آرتیفکت (ویکی موجودیت / مفهوم / موضوع) را از هر سندی که با یک الگوی گردآوری دانش پیکربندی شده است، گردآوری می‌کند. در هر اجرا فقط تکه‌های تازه‌افزوده‌شده پردازش می‌شوند.',
      generateToSkills:
        'یک درخت مهارت سلسله‌مراتبی از این مجموعه‌داده می‌سازد و صفحات مهارت تولیدشده را برای جستجو و استفاده مجدد ذخیره می‌کند.',
      raptor: 'RAPTOR',
      artifact: 'آرتیفکت',
      toSkills: 'به مهارت‌ها',
      processingType: 'نوع پردازش',
      dataPipeline: 'خط لوله دریافت را تغییر داده یا پیکربندی کنید.',
      dataPipelineTitle: 'خط لوله دریافت',
      operations: 'عملیات‌ها',
      taskId: 'شناسه وظیفه',
      duration: 'مدت',
      details: 'جزئیات',
      status: 'وضعیت',
      task: 'وظیفه',
      startDate: 'تاریخ شروع',
      source: 'منبع',
      fileName: 'نام فایل',
      datasetLogs: 'مجموعه‌داده',
      fileLogs: 'فایل',
      overview: 'گزارش‌ها',
      success: 'موفق',
      failed: 'ناموفق',
      completed: 'تکمیل‌شده',
      datasetLog: 'گزارش مجموعه‌داده',
      created: 'ایجادشده',
      learnMore: 'معرفی خط لوله داخلی',
      general: 'عمومی',
      chunkMethodTab: 'روش تکه‌بندی',
      testResults: 'نتایج',
      testSetting: 'تنظیمات',
      retrievalTesting: 'آزمون بازیابی',
      retrievalTestingDescription:
        'یک آزمون بازیابی انجام دهید تا بررسی شود آیا DOCFLOW می‌تواند محتوای موردنظر را برای مدل زبانی بازیابی کند.',
      Parse: 'تجزیه',
      dataset: 'مجموعه‌داده',
      testing: 'آزمون بازیابی',
      files: 'فایل‌ها',
      configuration: 'پیکربندی',
      nextConfiguration: 'پیکربندی مجموعه‌داده',
      knowledgeGraph: 'گراف دانش',
      compilation: 'گردآوری',
      name: 'نام',
      namePlaceholder: 'لطفاً نام را وارد کنید!',
      doc: 'اسناد',
      datasetDescription:
        'لطفاً پیش از شروع گفتگوی مبتنی بر هوش مصنوعی، صبر کنید تا تجزیه فایل‌های شما به پایان برسد.',
      addFile: 'افزودن فایل',
      searchFiles: 'فایل‌های خود را جستجو کنید',
      localFiles: 'فایل‌های محلی',
      emptyFiles: 'ایجاد فایل خالی',
      webCrawl: 'خزش وب',
      chunkNumber: 'تکه‌ها',
      uploadDate: 'تاریخ بارگذاری',
      chunkMethod: 'روش تکه‌بندی',
      enabled: 'فعال',
      disabled: 'غیرفعال',
      action: 'عملیات',
      parsingStatus: 'وضعیت تجزیه',
      parsingStatusTip:
        'زمان تجزیه سند بر اساس چندین عامل متفاوت است. فعال‌سازی قابلیت‌هایی مانند گراف دانش، RAPTOR، استخراج خودکار سؤال یا استخراج خودکار کلیدواژه، زمان پردازش را به‌طور قابل توجهی افزایش می‌دهد. اگر نوار پیشرفت متوقف شد، لطفاً به این دو پرسش متداول مراجعه کنید: https://DOCFLOW.io/docs/dev/faq#why-does-my-document-parsing-stall-at-under-one-percent.',
      processBeginAt: 'شروع در',
      processDuration: 'مدت',
      progressMsg: 'پیشرفت',
      noTestResultsForRuned:
        'نتیجه مرتبطی یافت نشد. سعی کنید پرسمان یا پارامترهای خود را تنظیم کنید.',
      noTestResultsForNotRuned:
        'هنوز هیچ آزمونی اجرا نشده است. نتایج اینجا نمایش داده خواهند شد.',
      testingDescription:
        'یک آزمون بازیابی انجام دهید تا بررسی شود آیا DOCFLOW می‌تواند محتوای موردنظر را برای مدل زبانی بازیابی کند. اگر تنظیمات پیش‌فرض، مانند وزن شباهت کلیدواژه یا آستانه شباهت، را برای دستیابی به بهترین نتایج تغییر داده‌اید، توجه داشته باشید که این تغییرات به‌طور خودکار ذخیره نمی‌شوند. باید آن‌ها را در تنظیمات دستیار گفتگو یا تنظیمات مؤلفه عامل بازیابی اعمال کنید.',
      similarityThreshold: 'آستانه شباهت',
      similarityThresholdTip:
        'DOCFLOW در حین بازیابی از ترکیب شباهت وزنی کلیدواژه و شباهت کسینوسی برداری وزنی، یا ترکیب شباهت وزنی کلیدواژه و امتیاز رتبه‌بندی مجدد وزنی استفاده می‌کند. این پارامتر آستانه شباهت‌ها بین پرسمان کاربر و تکه‌ها را تعیین می‌کند. هر تکه با امتیاز شباهت کمتر از این آستانه از نتایج حذف خواهد شد. به‌طور پیش‌فرض، آستانه روی ۲۰ تنظیم شده است. این یعنی فقط تکه‌هایی با امتیاز شباهت ترکیبی ۲۰ یا بالاتر بازیابی می‌شوند.',
      vectorSimilarityWeight: 'وزن شباهت برداری',
      vectorSimilarityWeightTip:
        'این وزن شباهت کلیدواژه را در امتیاز شباهت ترکیبی تعیین می‌کند که یا با شباهت کسینوسی برداری یا با امتیاز رتبه‌بندی مجدد استفاده می‌شود. مجموع دو وزن باید برابر ۱٫۰ باشد.',
      keywordSimilarityWeight: 'وزن شباهت کلیدواژه',
      keywordSimilarityWeightTip:
        'این وزن شباهت کلیدواژه را در امتیاز شباهت ترکیبی تعیین می‌کند که یا با شباهت کسینوسی برداری یا با امتیاز رتبه‌بندی مجدد استفاده می‌شود. مجموع دو وزن باید برابر ۱٫۰ باشد.',
      testText: 'متن آزمون',
      testTextPlaceholder: 'سؤال خود را اینجا وارد کنید!',
      testingLabel: 'اجرا',
      similarity: 'شباهت ترکیبی',
      termSimilarity: 'شباهت واژه',
      vectorSimilarity: 'شباهت برداری',
      hits: 'موارد یافت‌شده',
      view: 'مشاهده',
      filesSelected: 'فایل‌های انتخاب‌شده',
      upload: 'بارگذاری',
      run: 'تجزیه',
      runningStatus0: 'در انتظار',
      runningStatus1: 'در حال تجزیه',
      runningStatus2: 'لغوشده',
      runningStatus3: 'موفق',
      runningStatus4: 'ناموفق',
      pageRanges: 'محدوده صفحات',
      pageRangesTip:
        'محدوده صفحاتی که باید تجزیه شوند؛ صفحات خارج از این محدوده پردازش نخواهند شد.',
      fromPlaceholder: 'از',
      fromMessage: 'شماره صفحه شروع وارد نشده است',
      toPlaceholder: 'تا',
      toMessage: 'شماره صفحه پایان وارد نشده است (به‌جز خود آن)',
      pageRangeFromInvalid: 'صفحه شروع باید عددی صحیح و بزرگ‌تر از ۰ باشد',
      pageRangeToInvalid:
        'صفحه پایان باید عددی صحیح و کمتر از صفحه شروع نباشد',
      layoutRecognize: 'تجزیه‌کننده PDF',
      layoutRecognizeTip:
        'از یک مدل بصری برای تحلیل چیدمان PDF استفاده کنید تا عنوان‌های سند، بلوک‌های متن، تصاویر و جدول‌ها به‌طور مؤثری مکان‌یابی شوند. اگر گزینه ساده انتخاب شود، فقط متن ساده موجود در PDF بازیابی خواهد شد. لطفاً توجه داشته باشید که این گزینه در حال حاضر فقط برای اسناد PDF کار می‌کند.',
      taskPageSize: 'اندازه صفحه وظیفه',
      taskPageSizeMessage: 'لطفاً اندازه صفحه وظیفه خود را وارد کنید!',
      taskPageSizeTip: `در حین تشخیص چیدمان، یک فایل PDF به تکه‌هایی تقسیم و به‌صورت موازی پردازش می‌شود تا سرعت پردازش افزایش یابد. این پارامتر اندازه هر تکه را تعیین می‌کند. اندازه تکه بزرگ‌تر احتمال تقسیم متن پیوسته بین صفحات را کاهش می‌دهد.`,
      addPage: 'افزودن صفحه',
      greaterThan: 'مقدار فعلی باید بزرگ‌تر از «تا» باشد!',
      greaterThanPrevious:
        'مقدار فعلی باید بزرگ‌تر از «تا»ی قبلی باشد!',
      selectFiles: 'انتخاب فایل‌ها',
      changeSpecificCategory: 'تغییر دسته خاص',
      uploadTitle: 'فایل خود را برای بارگذاری اینجا بکشید و رها کنید',
      uploadDescription:
        'از بارگذاری تکی یا گروهی فایل پشتیبانی می‌کند. برای DOCFLOW مستقرشده به‌صورت محلی: محدودیت کل اندازه فایل در هر بارگذاری ۱ گیگابایت است، با محدودیت بارگذاری گروهی ۳۲ فایل. سقفی برای تعداد کل فایل‌ها در هر حساب وجود ندارد. برای cloud.DOCFLOW.io، محدودیت کل اندازه فایل در هر بارگذاری ۱۰ مگابایت است، هر فایل نباید از ۱۰ مگابایت فراتر رود و حداکثر ۱۲۸ فایل در هر حساب مجاز است.',
      chunk: 'تکه',
      bulk: 'گروهی',
      cancel: 'انصراف',
      close: 'بستن',
      rerankModel: 'مدل رتبه‌بندی مجدد',
      rerankPlaceholder: 'یک مقدار انتخاب کنید',
      rerankTip: `اختیاری. اگر خالی بماند، DOCFLOW از ترکیب شباهت وزنی کلیدواژه و شباهت کسینوسی برداری وزنی استفاده می‌کند؛ اگر یک مدل رتبه‌بندی مجدد انتخاب شود، امتیاز رتبه‌بندی مجدد وزنی جایگزین شباهت کسینوسی برداری وزنی می‌شود. لطفاً توجه داشته باشید که استفاده از مدل رتبه‌بندی مجدد زمان پاسخ‌دهی سیستم را به‌طور قابل توجهی افزایش می‌دهد. اگر می‌خواهید از مدل رتبه‌بندی مجدد استفاده کنید، مطمئن شوید از یک رتبه‌بند SaaS استفاده می‌کنید؛ اگر مدل رتبه‌بندی مجدد مستقرشده به‌صورت محلی را ترجیح می‌دهید، مطمئن شوید DOCFLOW را با docker-compose-gpu.yml اجرا می‌کنید.`,
      topK: 'Top-K',
      topKTip: `همراه با مدل رتبه‌بندی مجدد استفاده می‌شود؛ این تنظیم تعداد تکه‌های متنی را که باید به مدل رتبه‌بندی مجدد مشخص‌شده ارسال شوند، تعیین می‌کند.`,
      delimiter: `جداکننده متن`,
      delimiterTip:
        'یک رشته جداکننده به فهرستی از جداکننده‌ها تجزیه می‌شود. بک‌تیک‌ها (` `) جداکننده‌ی جداکننده‌ها هستند: هر جفت بک‌تیک متناظر، کاراکترهای درون خود را در یک جداکننده چندکاراکتری می‌پیچد؛ هر کاراکتر خارج از بک‌تیک‌ها خودش یک جداکننده است. جداکننده‌ها ابتدا بر اساس طولانی‌ترین تطبیق می‌یابند. مثال: \\n`##`; به سه جداکننده تجزیه می‌شود — خط جدید (\\n)، دو علامت درصد (##)، نقطه‌ویرگول (;) — و متن شما در هر یک از آن‌ها تقسیم خواهد شد. جداکننده‌های تک‌کاراکتری (مثلاً !?; ← !، ?، ;) به بک‌تیک نیاز ندارند؛ جداکننده‌های چندکاراکتری (مثلاً ##، END) باید در بک‌تیک پیچیده شوند.',
      enableChildrenDelimiter: 'تکه‌های فرزند برای بازیابی استفاده می‌شوند',
      childrenDelimiter: 'جداکننده متن',
      childrenDelimiterTip:
        'یک رشته جداکننده به فهرستی از جداکننده‌ها تجزیه می‌شود. بک‌تیک‌ها (` `) جداکننده‌ی جداکننده‌ها هستند: هر جفت بک‌تیک متناظر، کاراکترهای درون خود را در یک جداکننده چندکاراکتری می‌پیچد؛ هر کاراکتر خارج از بک‌تیک‌ها خودش یک جداکننده است. جداکننده‌ها ابتدا بر اساس طولانی‌ترین تطبیق می‌یابند. مثال: \\n`##`; به سه جداکننده تجزیه می‌شود — خط جدید (\\n)، دو علامت درصد (##)، نقطه‌ویرگول (;) — و متن شما در هر یک از آن‌ها تقسیم خواهد شد. جداکننده‌های تک‌کاراکتری (مثلاً !?; ← !، ?، ;) به بک‌تیک نیاز ندارند؛ جداکننده‌های چندکاراکتری (مثلاً ##، END) باید در بک‌تیک پیچیده شوند.',
      delimiterPreviewLabel: 'تقسیم در:',
      delimiterPreviewEmpty:
        'جداکننده‌ای وجود ندارد — متن فقط بر اساس اندازه تکه‌بندی می‌شود.',
      delimiterPreviewCount: '({{count}})',

      html4excel: 'اکسل به HTML',
      html4excelTip: `همراه با روش تکه‌بندی عمومی استفاده می‌شود. وقتی غیرفعال باشد، صفحه‌گسترده‌ها (XLSX یا XLS(Excel 97-2003)) در مجموعه‌داده به جفت‌های کلید-مقدار تجزیه می‌شوند. وقتی فعال باشد، به جدول‌های HTML تجزیه می‌شوند و اگر جدول اصلی بیش از ۱۲ ردیف داشته باشد، در هر ۱۲ ردیف تقسیم می‌شوند. برای جزئیات به https://DOCFLOW.io/docs/dataset_configuration#other-format-processing-configuration مراجعه کنید.`,
      autoKeywords: 'کلیدواژه خودکار',
      autoKeywordsTip: `به‌طور خودکار برای هر تکه N کلیدواژه استخراج می‌کند تا رتبه آن‌ها را برای پرسمان‌های حاوی آن کلیدواژه‌ها افزایش دهد. توجه داشته باشید که توکن‌های اضافی توسط مدل نمایه‌سازی مشخص‌شده در «پیکربندی» مصرف خواهد شد. می‌توانید کلیدواژه‌های افزوده‌شده برای یک تکه را از فهرست تکه‌ها بررسی یا به‌روزرسانی کنید. برای جزئیات به https://DOCFLOW.io/docs/dev/autokeyword_autoquestion مراجعه کنید.`,
      autoQuestions: 'سؤال خودکار',
      autoQuestionsTip: `به‌طور خودکار برای هر تکه N سؤال استخراج می‌کند تا رتبه آن‌ها را برای پرسمان‌های حاوی آن سؤالات افزایش دهد. می‌توانید سؤالات افزوده‌شده برای یک تکه را از فهرست تکه‌ها بررسی یا به‌روزرسانی کنید. در صورت بروز خطا، این قابلیت فرایند تکه‌بندی را مختل نمی‌کند، جز اینکه ممکن است یک نتیجه خالی به تکه اصلی اضافه کند. توجه داشته باشید که توکن‌های اضافی توسط مدل نمایه‌سازی مشخص‌شده در «پیکربندی» مصرف خواهد شد. برای جزئیات به https://DOCFLOW.io/docs/dev/autokeyword_autoquestion مراجعه کنید.`,
      autoTags: 'برچسب‌های خودکار',
      redo: 'آیا می‌خواهید {{chunkNum}} تکه موجود را پاک کنید؟',
      setMetaData: 'تنظیم فراداده',
      pleaseInputJson: 'لطفاً JSON را وارد کنید',
      documentMetaTips: `<p>فراداده در قالب Json است (قابل جستجو نیست). اگر هر یک از تکه‌های این سند در پرامپت گنجانده شود، به پرامپت مدل زبانی افزوده خواهد شد.</p>
<p>مثال‌ها:</p>
<b>فراداده این است:</b><br>
<code>
  {
      "Author": "Alex Dowson",
      "Date": "2024-11-12"
  }
</code><br>
<b>پرامپت این خواهد بود:</b><br>
<p>سند: the_name_of_document</p>
<p>Author: Alex Dowson</p>
<p>Date: 2024-11-12</p>
<p>قطعات مرتبط به شرح زیر:</p>
<ul>
<li>  محتوای تکه اینجاست....</li>
<li>  محتوای تکه اینجاست....</li>
</ul>
`,
      metaData: 'فراداده',
      deleteDocumentConfirmContent:
        'این سند با گراف دانش مرتبط است. پس از حذف، اطلاعات گره و روابط مرتبط حذف خواهند شد، اما گراف بلافاصله به‌روزرسانی نمی‌شود. عمل به‌روزرسانی گراف در حین فرایند تجزیه سند جدیدی که وظیفه استخراج گراف دانش را دارد، انجام می‌شود.',
      plainText: 'ساده',
      reRankModelWaring: 'مدل رتبه‌بندی مجدد بسیار زمان‌بر است.',
    },
    knowledgeConfiguration: {
      randomSeedTip:
        'Seed نقطه آغاز یک الگوریتم شبه‌تصادفی است که تکرارپذیری خروجی یکسان در اجراهای مختلف را تضمین می‌کند.',
      datasetDescription: 'مجموعه‌داده خود را توصیف کنید',
      overlappedPercentTip: 'درصد هم‌پوشانی بین دو تکه مجاور',
      globalIndexModelTip:
        'برای تولید فراداده خودکار، کلیدواژه خودکار و سؤال خودکار استفاده می‌شود. عملکرد مدل بر کیفیت تولید تأثیر می‌گذارد.',
      globalIndexModel: 'مدل نمایه‌سازی',
      settings: 'تنظیمات',
      autoMetadataTip: `به‌طور خودکار فراداده تولید می‌کند. در حین تجزیه بر فایل‌های جدید اعمال می‌شود. فایل‌های موجود برای به‌روزرسانی نیاز به تجزیه مجدد دارند (تکه‌ها حفظ می‌شوند). توجه داشته باشید که توکن‌های اضافی توسط مدل نمایه‌سازی مشخص‌شده در «پیکربندی» مصرف خواهد شد.`,
      imageTableContextWindow: 'پنجره زمینه تصویر و جدول',
      imageTableContextWindowTip:
        'N توکن متن بالا و پایین تصویر و جدول را ثبت می‌کند تا زمینه پس‌زمینه غنی‌تری فراهم شود.',
      autoMetadata: 'فراداده خودکار',
      mineruOptions: 'گزینه‌های MinerU',
      mineruParseMethod: 'روش تجزیه',
      mineruParseMethodTip:
        'روش تجزیه PDF: auto (تشخیص خودکار)، txt (استخراج متن)، ocr (تشخیص نویسه نوری)',
      mineruFormulaEnable: 'تشخیص فرمول',
      mineruFormulaEnableTip:
        'تشخیص فرمول را فعال کنید. توجه: این ممکن است برای اسناد سیریلیک به‌درستی کار نکند.',
      mineruTableEnable: 'تشخیص جدول',
      mineruTableEnableTip: 'تشخیص و استخراج جدول را فعال کنید.',
      paddleocrOptions: 'گزینه‌های PaddleOCR',
      paddleocrApiUrl: 'نشانی API PaddleOCR',
      paddleocrApiUrlTip: 'نشانی نقطه پایانی API برای سرویس PaddleOCR',
      paddleocrApiUrlPlaceholder:
        'مثال: https://paddleocr-server.com/layout-parsing',
      paddleocrAccessToken: 'توکن دسترسی AI Studio',
      paddleocrAccessTokenTip: 'توکن دسترسی برای API پادل‌اواسیآر (اختیاری)',
      paddleocrAccessTokenPlaceholder: 'توکن AI Studio شما (اختیاری)',
      paddleocrAlgorithm: 'الگوریتم PaddleOCR',
      paddleocrAlgorithmTip: 'الگوریتم مورد استفاده برای تجزیه PaddleOCR',
      paddleocrSelectAlgorithm: 'انتخاب الگوریتم',
      paddleocrModelNamePlaceholder: 'مثال: paddleocr-from-env-1',
      overlappedPercent: 'درصد هم‌پوشانی (٪)',
      generationScopeTip:
        'تعیین می‌کند که آیا RAPTOR برای کل مجموعه‌داده تولید شود یا برای یک فایل واحد.',
      scopeDataset: 'مجموعه‌داده',
      generationScope: 'دامنه تولید',
      scopeSingleFile: 'فایل واحد',
      autoParse: 'تجزیه خودکار',
      rebuildTip:
        'فایل‌ها را از منبع داده پیوندشده دوباره دانلود و دوباره تجزیه می‌کند.',
      baseInfo: 'پایه',
      globalIndex: 'نمایه سراسری',
      dataSource: 'منبع داده',
      linkSourceSetTip: 'مدیریت پیوند منبع داده با این مجموعه‌داده',
      linkDataSource: 'پیوند منبع داده',
      deleteGenerateModalContent: `
        <p>حذف نتایج <strong class='text-text-primary'>{{type}}</strong> تولیدشده
        همه موجودیت‌ها و روابط مشتق‌شده را از این مجموعه‌داده حذف خواهد کرد.
        فایل‌های اصلی شما دست‌نخورده باقی می‌مانند.<p>
        <br/>
        آیا می‌خواهید ادامه دهید؟
      `,
      extractRaptor: 'استخراج Raptor',
      extractKnowledgeGraph: 'استخراج گراف دانش',
      filterPlaceholder: 'لطفاً فیلتر را وارد کنید',
      fileFilterTip: '',
      fileFilter: 'فیلتر فایل',
      setDefaultTip: '',
      setDefault: 'تنظیم به‌عنوان پیش‌فرض',
      editLinkDataPipeline: 'ویرایش خط لوله دریافت',
      linkPipelineSetTip: 'مدیریت پیوند خط لوله دریافت با این مجموعه‌داده',
      default: 'پیش‌فرض',
      dataPipeline: 'خط لوله دریافت را تغییر داده یا پیکربندی کنید.',
      linkDataPipeline: 'پیوند خط لوله دریافت',
      enableAutoGenerate: 'فعال‌سازی تولید خودکار',
      teamPlaceholder: 'لطفاً یک تیم انتخاب کنید.',
      dataFlowPlaceholder: 'لطفاً یک خط لوله انتخاب کنید.',
      buildItFromScratch: 'از ابتدا بسازید',
      dataFlow: 'خط لوله',
      parseType: 'نوع تجزیه',
      manualSetup: 'خط لوله',
      builtIn: 'داخلی',
      titleDescription:
        'پیکربندی مجموعه‌داده خود را اینجا به‌روزرسانی کنید، به‌ویژه مدل زبانی و پرامپت‌ها.',
      name: 'نام مجموعه‌داده',
      photo: 'تصویر مجموعه‌داده',
      photoTip: 'می‌توانید تصویری تا حداکثر ۴ مگابایت بارگذاری کنید.',
      description: 'توضیحات',
      language: 'زبان سند',
      languageMessage: 'لطفاً زبان خود را وارد کنید!',
      languagePlaceholder: 'لطفاً زبان خود را وارد کنید!',
      permissions: 'دسترسی‌ها',
      embeddingModel: 'مدل جاسازی',
      chunkTokenNumber: 'اندازه پیشنهادی تکه',
      chunkTokenNumberMessage: 'تعداد توکن تکه برای متن الزامی است',
      embeddingModelTip:
        'مدل جاسازی پیش‌فرضی که توسط مجموعه‌داده استفاده می‌شود. وقتی مجموعه‌داده تکه داشته باشد، هنگام تغییر مدل جاسازی، سیستم به‌صورت تصادفی چند تکه را برای بررسی سازگاری نمونه‌گیری می‌کند، آن‌ها را با مدل جاسازی جدید دوباره جاسازی می‌کند و شباهت کسینوسی بین بردارهای جدید و قدیمی را محاسبه می‌کند. تغییر فقط زمانی مجاز است که میانگین شباهت نمونه ≥ ۰٫۹ باشد. در غیر این صورت، باید پیش از تغییر آن، همه تکه‌های مجموعه‌داده را حذف کنید.',
      permissionsTip:
        'اگر روی «تیم» تنظیم شود، همه اعضای تیم شما می‌توانند مجموعه‌داده را مدیریت کنند.',
      chunkTokenNumberTip:
        'این تا حدی آستانه توکن برای ایجاد یک تکه را تعیین می‌کند. قطعه‌ای با توکن‌های کمتر از این آستانه با قطعات بعدی ترکیب می‌شود تا زمانی که تعداد توکن‌ها از آستانه فراتر رود، در آن نقطه یک تکه ایجاد می‌شود. مگر اینکه یک جداکننده مشاهده شود، تکه جدیدی ایجاد نمی‌شود، حتی اگر از آستانه فراتر رفته باشد.',
      chunkMethod: 'روش تکه‌بندی',
      chunkMethodTip: 'راهنمایی‌ها را در سمت راست مشاهده کنید.',
      upload: 'بارگذاری',
      english: 'انگلیسی',
      chinese: 'چینی',
      portugueseBr: 'پرتغالی (برزیل)',
      embeddingModelPlaceholder: 'لطفاً یک مدل جاسازی انتخاب کنید.',
      chunkMethodPlaceholder: 'لطفاً یک روش تکه‌بندی انتخاب کنید.',
      tableColumnMode: 'حالت ستون',
      tableColumnModeAuto: 'خودکار',
      tableColumnModeManual: 'دستی',
      tableColumnModeAutoDescription:
        'همه ستون‌ها در متن تکه گنجانده و به‌عنوان فراداده ذخیره می‌شوند (پیش‌فرض DOCFLOW).',
      tableColumnRoles: 'نقش‌های ستون',
      tableColumnRolesTip:
        'انتخاب کنید کدام ستون‌ها در متن تکه گنجانده شوند (برای جستجوی برداری و تمام‌متن نمایه شوند)، فقط در فراداده (قابل فیلتر)، یا هر دو. تغییرات بر تجزیه‌های جدید اعمال می‌شوند؛ برای اعمال نقش‌ها، اسناد موجود را دوباره تجزیه کنید.',
      tableColumnRoleIndexing: 'نمایه‌سازی',
      tableColumnRoleMetadata: 'فراداده',
      tableColumnRoleBoth: 'هر دو',
      tableColumnRolesEmpty:
        'برای شروع پیکربندی نقش‌های ستون، یک فایل CSV یا اکسل بارگذاری و تجزیه کنید.',
      tableColumnRolesReparseTip:
        'برای اعمال نقش‌های جدید ستون، اسناد موجود را دوباره تجزیه کنید.',
      parserLabel: {
        naive: 'عمومی',
        general: 'عمومی',
        qa: 'پرسش و پاسخ',
        resume: 'رزومه',
        manual: 'راهنما',
        table: 'جدول',
        paper: 'مقاله',
        book: 'کتاب',
        laws: 'قوانین',
        presentation: 'ارائه',
        picture: 'تصویر',
        one: 'یگانه',
        audio: 'صوت',
        email: 'ایمیل',
        tag: 'برچسب',
      },
      save: 'ذخیره',
      me: 'فقط من',
      team: 'تیم',
      cancel: 'انصراف',
      methodTitle: 'توضیح روش تکه‌بندی',
      methodExamples: 'مثال‌ها',
      methodExamplesDescription:
        'تصاویر زیر برای شفاف‌سازی ارائه شده‌اند.',
      dialogueExamplesTitle: 'مشاهده',
      methodEmpty:
        'این یک توضیح بصری از دسته‌های مجموعه‌داده نمایش خواهد داد',
      audio: `<p>قالب‌های فایل پشتیبانی‌شده <b>WAV, MP3, AAC, FLAC, OGG</b> و دیگر قالب‌های صوتی رایج هستند.</p>
<p>این روش فایل‌های صوتی را با استفاده از یک مدل گفتار به متن، به متن رونویسی می‌کند.</p>`,
      email: `<p>قالب‌های فایل پشتیبانی‌شده <b>EML</b> و <b>MSG</b> هستند.</p>
<p>این روش فایل‌های ایمیل را تجزیه می‌کند و فیلدهای سرآیند (مانند From، To، CC، Subject و Date)، محتوای متن و پیوست‌ها را استخراج می‌کند.</p>`,
      knowledgeCompiler: `<p>این خط لوله فایل‌ها را تجزیه و تکه‌بندی می‌کند، سپس تکه‌ها را از طریق مؤلفه گردآورنده دانش به واحدهای دانش ساختاریافته (گراف دانش، ویکی، RAPTOR، نقشه ذهنی یا ناوبری مجموعه‌داده) گردآوری می‌کند.</p>
<p>واحدهای دانش گردآوری‌شده به‌عنوان تکه‌هایی که در جریان تکه‌ها ادغام شده‌اند منتشر می‌شوند، که آن را برای ساخت یک لایه دانش قابل بازیابی روی اسناد تکه‌بندی‌شده ایده‌آل می‌کند.</p>`,
      book: `<p>قالب‌های فایل پشتیبانی‌شده <b>DOCX</b>، <b>PDF</b>، <b>TXT</b> هستند.</p><p>
      برای هر کتاب در قالب PDF، لطفاً <i>محدوده صفحات</i> را تنظیم کنید تا اطلاعات ناخواسته حذف و زمان تحلیل کاهش یابد.</p>`,
      laws: `<p>قالب‌های فایل پشتیبانی‌شده <b>DOCX</b>، <b>PDF</b>، <b>TXT</b> هستند.</p><p>
      اسناد حقوقی معمولاً از یک قالب نگارشی دقیق پیروی می‌کنند. ما از ویژگی متن برای شناسایی نقطه تقسیم استفاده می‌کنیم.
      </p><p>
      تکه دارای دانه‌بندی سازگار با «ماده» است و اطمینان می‌دهد که تمام متن سطح بالاتر در تکه گنجانده شود.
      </p>`,
      manual: `<p>فقط <b>PDF</b> پشتیبانی می‌شود.</p><p>
      فرض می‌کنیم راهنما دارای ساختار بخش سلسله‌مراتبی است و از پایین‌ترین عنوان‌های بخش به‌عنوان واحد پایه برای تکه‌بندی اسناد استفاده می‌کنیم. بنابراین، شکل‌ها و جدول‌های همان بخش جدا نخواهند شد، که ممکن است منجر به اندازه‌های تکه بزرگ‌تر شود.
      </p>`,
      naive: `<p>قالب‌های فایل پشتیبانی‌شده <b>MD, MDX, DOCX, XLSX, XLS (Excel 97-2003), PPTX, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b> هستند.</p>
      <p>این روش فایل‌ها را با یک روش «ساده» تکه‌بندی می‌کند: </p>
      <p>
      <ul>
      <li>از مدل تشخیص بصری برای تقسیم متن‌ها به قطعات کوچک‌تر استفاده می‌کند.</li>
      <li>سپس قطعات مجاور را ترکیب می‌کند تا زمانی که تعداد توکن‌ها از آستانه مشخص‌شده توسط «تعداد توکن تکه برای متن» فراتر رود، در آن نقطه یک تکه ایجاد می‌شود.</li></ul></p>`,
      paper: `<p>فقط فایل <b>PDF</b> پشتیبانی می‌شود.</p><p>
      مقالات بر اساس بخش تقسیم می‌شوند، مانند <i>چکیده، ۱٫۱، ۱٫۲</i>. </p><p>
      این رویکرد به مدل زبانی امکان می‌دهد مقاله را مؤثرتر خلاصه کند و پاسخ‌های جامع‌تر و قابل فهم‌تری ارائه دهد.
      با این حال، زمینه گفتگوهای هوش مصنوعی را نیز افزایش می‌دهد و به هزینه محاسباتی مدل زبانی می‌افزاید. بنابراین در حین گفتگو، کاهش مقدار «<b>topN</b>» را در نظر بگیرید.</p>`,
      presentation: `<p>قالب‌های فایل پشتیبانی‌شده <b>PDF</b>، <b>PPTX</b> هستند.</p><p>
      هر صفحه در اسلایدها به‌عنوان یک تکه در نظر گرفته می‌شود و تصویر بندانگشتی آن ذخیره می‌شود.</p><p>
      <i>این روش تکه‌بندی به‌طور خودکار بر همه فایل‌های PPT بارگذاری‌شده اعمال می‌شود، بنابراین نیازی به تعیین دستی آن ندارید.</i></p>`,
      qa: `
      <p>
      این روش تکه‌بندی از قالب‌های فایل <b>XLSX</b> و <b>CSV/TXT</b> پشتیبانی می‌کند.
    </p>
    <ul>
    <li>
      اگر فایلی در قالب <b>XLSX</b> یا <b>XLS (Excel 97-2003)</b> باشد، باید شامل دو ستون بدون سرآیند باشد: یکی برای سؤالات و دیگری برای پاسخ‌ها، به‌طوری‌که ستون سؤال پیش از ستون پاسخ قرار گیرد. چند برگه (sheet) نیز
      قابل قبول است، مشروط بر اینکه ستون‌ها به‌درستی ساختاربندی شده باشند.
    </li>
    <li>
      اگر فایلی در قالب <b>CSV/TXT</b> باشد، باید با کدگذاری UTF-8 و با TAB به‌عنوان جداکننده برای تفکیک سؤالات و پاسخ‌ها باشد.
    </li>
    </ul>
    <p>
      <i>
        خطوطی از متن که از قوانین بالا پیروی نکنند نادیده گرفته می‌شوند و
        هر جفت پرسش و پاسخ یک تکه مجزا در نظر گرفته می‌شود.
      </i>
    </p>
      `,
      resume: `<p>قالب‌های فایل پشتیبانی‌شده <b>DOCX</b>، <b>PDF</b>، <b>TXT</b> هستند.
      </p><p>
      رزومه‌های گوناگون تجزیه و به داده‌های ساختاریافته سازماندهی می‌شوند تا جستجوی نامزدها برای استخدام‌کنندگان تسهیل شود.
      </p>
      `,
      table: `<p>قالب‌های فایل پشتیبانی‌شده <b>XLSX</b> و <b>CSV/TXT</b> هستند.</p><p>
      در اینجا برخی پیش‌نیازها و نکات آورده شده است:
      <ul>
    <li>برای فایل CSV یا TXT، جداکننده بین ستون‌ها باید <em><b>TAB</b></em> باشد.</li>
    <li>ردیف اول باید سرآیند ستون‌ها باشد.</li>
    <li>سرآیند ستون‌ها باید اصطلاحاتی معنادار باشند تا به درک مدل زبانی شما کمک کنند.
    توصیه می‌شود مترادف‌ها را با یک اسلش <i>«/»</i> کنار هم قرار دهید و مقادیر را با پرانتز فهرست کنید، برای مثال: <i>«Gender/Sex (male, female)»</i>.<p>
    در اینجا چند مثال از سرآیندها آورده شده است:<ol>
        <li>supplier/vendor<b>'TAB'</b>Color (Yellow, Blue, Brown)<b>'TAB'</b>Sex/Gender (male, female)<b>'TAB'</b>size (M, L, XL, XXL)</li>
        </ol>
        </p>
    </li>
    <li>هر ردیف در جدول به‌عنوان یک تکه در نظر گرفته می‌شود.</li>
    </ul>`,
      picture: `
    <p>فایل‌های تصویری پشتیبانی می‌شوند و پشتیبانی از ویدیو به‌زودی افزوده می‌شود.</p><p>
    این روش از یک مدل OCR برای استخراج متن‌ها از تصاویر استفاده می‌کند.
    </p><p>
    اگر متن استخراج‌شده توسط مدل OCR ناکافی تشخیص داده شود، از یک مدل زبانی بصری مشخص‌شده برای ارائه توصیفی از تصویر استفاده می‌شود.
    </p>`,
      one: `
    <p>قالب‌های فایل پشتیبانی‌شده <b>DOCX, XLSX, XLS (Excel 97-2003), PDF, TXT</b> هستند.
    </p><p>
    این روش هر سند را در کلیت خود به‌عنوان یک تکه در نظر می‌گیرد.
    </p><p>
    زمانی کاربرد دارد که نیاز دارید مدل زبانی کل سند را خلاصه کند، مشروط بر اینکه بتواند آن مقدار طول زمینه را مدیریت کند.
    </p>`,
      knowledgeGraph: `<p>قالب‌های فایل پشتیبانی‌شده <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>

<p>این رویکرد فایل‌ها را با روش «ساده»/«عمومی» تکه‌بندی می‌کند. یک سند را به قطعات تقسیم می‌کند و سپس قطعات مجاور را ترکیب می‌کند تا زمانی که تعداد توکن‌ها از آستانه مشخص‌شده توسط «تعداد توکن تکه برای متن» فراتر رود، در آن نقطه یک تکه ایجاد می‌شود.</p>
<p>سپس تکه‌ها به مدل زبانی داده می‌شوند تا موجودیت‌ها و روابط برای یک گراف دانش و یک نقشه ذهنی استخراج شوند.</p>
<p>مطمئن شوید که <b>انواع موجودیت</b> را تنظیم کرده‌اید.</p>`,
      tag: `<p>مجموعه‌داده‌ای که از روش تکه‌بندی «برچسب» استفاده می‌کند به‌عنوان یک مجموعه برچسب عمل می‌کند. مجموعه‌داده‌های دیگر از آن برای برچسب‌گذاری تکه‌های خود استفاده می‌کنند و پرسمان‌ها به این مجموعه‌داده‌ها نیز با استفاده از این مجموعه برچسب برچسب‌گذاری می‌شوند.</p>
<p>یک مجموعه برچسب به‌طور مستقیم در فرایند تولید افزوده‌شده با بازیابی (RAG) دخیل <b>نخواهد</b> شد.</p>
<p>هر تکه در این مجموعه‌داده یک جفت مستقل توصیف-برچسب است.</p>
<p>قالب‌های فایل پشتیبانی‌شده شامل <b>XLSX</b> و <b>CSV/TXT</b> هستند:</p>
<p>اگر فایلی در قالب <b>XLSX</b> باشد، باید شامل دو ستون بدون سرآیند باشد: یکی برای توصیف برچسب‌ها و دیگری برای نام برچسب‌ها، به‌طوری‌که ستون توصیف پیش از ستون برچسب قرار گیرد. چند برگه نیز قابل قبول است، مشروط بر اینکه ستون‌ها به‌درستی ساختاربندی شده باشند.</p>
<p>اگر فایلی در قالب <b>CSV/TXT</b> باشد، باید با کدگذاری UTF-8 و با TAB به‌عنوان جداکننده برای تفکیک توصیف‌ها و برچسب‌ها باشد.</p>
<p>در یک ستون برچسب، از <b>ویرگول</b> برای جداسازی برچسب‌ها استفاده می‌شود.</p>
<i>خطوطی از متن که از قوانین بالا پیروی نکنند نادیده گرفته می‌شوند.</i>
`,
      useRaptor: 'RAPTOR',
      useRaptorTip:
        'RAPTOR می‌تواند برای وظایف پرسش و پاسخ چندپرشی استفاده شود. به صفحه فایل‌ها بروید، روی تولید > RAPTOR کلیک کنید تا فعال شود. برای جزئیات به https://DOCFLOW.io/docs/dev/enable_raptor مراجعه کنید.',
      prompt: 'پرامپت',
      promptTip:
        'از پرامپت سیستمی برای توصیف وظیفه به مدل زبانی، تعیین نحوه پاسخ‌دهی و بیان دیگر الزامات متفرقه استفاده کنید. پرامپت سیستمی اغلب همراه با کلیدها (متغیرها) استفاده می‌شود که به‌عنوان ورودی‌های داده گوناگون برای مدل زبانی عمل می‌کنند. برای نمایش کلیدهای قابل استفاده، از اسلش رو به جلو `/` یا دکمه (x) استفاده کنید.',
      promptMessage: 'پرامپت الزامی است',
      promptText: `پاراگراف‌های زیر را بدون ساختن حقایق یا تغییر اعداد خلاصه کنید.
دقیقاً دو بخش را به همان زبان منبع خروجی دهید:
۱. خط اول: فقط یک عنوان مختصر.
۲. خطوط بعدی: خلاصه‌ای مختصر از محتوا.
هیچ برچسب، عنوان Markdown، فهرست نقطه‌ای یا هرگونه توضیح دیگری خروجی ندهید.

پاراگراف‌ها:
{cluster_content}`,
      maxToken: 'حداکثر توکن',
      maxTokenTip: 'حداکثر تعداد توکن در هر تکه خلاصه تولیدشده.',
      maxTokenMessage: 'حداکثر توکن الزامی است',
      threshold: 'آستانه',
      thresholdTip:
        'در RAPTOR، تکه‌ها بر اساس شباهت معنایی‌شان خوشه‌بندی می‌شوند. پارامتر آستانه حداقل شباهت لازم برای گروه‌بندی تکه‌ها با یکدیگر را تعیین می‌کند. آستانه بالاتر یعنی تکه‌های کمتر در هر خوشه، و آستانه پایین‌تر یعنی تکه‌های بیشتر.',
      thresholdMessage: 'آستانه الزامی است',
      clusteringMethod: 'روش خوشه‌بندی',
      clusteringMethodTip:
        'روش خوشه‌بندی RAPTOR را انتخاب کنید. AHC می‌تواند از مقدار حداکثر خوشه بزرگ‌تری استفاده کند، اما ممکن است روی ورودی‌های بزرگ به حافظه بیشتری نیاز داشته باشد.',
      clusteringMethodGmm: 'GMM',
      clusteringMethodAhc: 'AHC',
      maxCluster: 'حداکثر خوشه',
      maxClusterTip: 'حداکثر تعداد خوشه‌هایی که باید ایجاد شوند.',
      maxClusterMessage: 'حداکثر خوشه الزامی است',
      randomSeed: 'بذر تصادفی',
      randomSeedMessage: 'بذر تصادفی الزامی است',
      entityTypes: 'انواع موجودیت',
      compilationTemplate: 'عملگر',
      compilationTemplateRequired: 'لطفاً یک عملگر انتخاب کنید',
      createTemplate: 'ایجاد الگو',
      scopeFile: 'فایل',
      vietnamese: 'ویتنامی',
      pageRank: 'رتبه صفحه',
      pageRankTip: `می‌توانید در حین بازیابی به مجموعه‌داده‌های خاص امتیاز PageRank بالاتری اختصاص دهید. امتیاز متناظر به امتیازهای شباهت ترکیبی تکه‌های بازیابی‌شده از این مجموعه‌داده‌ها افزوده می‌شود و رتبه آن‌ها را افزایش می‌دهد. برای جزئیات به https://DOCFLOW.io/docs/dataset_configuration#basic-information مراجعه کنید.`,
      tagName: 'برچسب',
      frequency: 'فراوانی',
      searchTags: 'جستجوی برچسب‌ها',
      tagCloud: 'ابر',
      tagTable: 'جدول',
      tagSet: 'مجموعه‌های برچسب',
      tagSetTip: `
     <p> یک یا چند مجموعه‌داده برچسب انتخاب کنید تا تکه‌های مجموعه‌داده شما به‌طور خودکار برچسب‌گذاری شوند. برای جزئیات به https://DOCFLOW.io/docs/dataset_configuration#basic-information مراجعه کنید.</p>
<p>پرسمان کاربر نیز به‌طور خودکار برچسب‌گذاری خواهد شد.</p>
این قابلیت برچسب‌گذاری خودکار با افزودن لایه‌ای دیگر از دانش تخصصی حوزه به مجموعه‌داده موجود، بازیابی را بهبود می‌بخشد.
<p>تفاوت بین برچسب خودکار و کلیدواژه خودکار:</p>
<ul>
  <li>مجموعه‌داده برچسب یک مجموعه بسته تعریف‌شده توسط کاربر است، در حالی که کلیدواژه‌های استخراج‌شده توسط مدل زبانی را می‌توان یک مجموعه باز در نظر گرفت.</li>
  <li>پیش از اجرای قابلیت برچسب خودکار، باید مجموعه‌های برچسب را در قالب‌های مشخص‌شده بارگذاری کنید.</li>
  <li>قابلیت کلیدواژه خودکار به مدل زبانی وابسته است و تعداد قابل توجهی توکن مصرف می‌کند.</li>
</ul>
      `,
      topnTags: 'برچسب‌های Top-N',
      tags: 'برچسب‌ها',
      addTag: 'افزودن برچسب',
      useGraphRag: 'گراف دانش',
      useGraphRagTip:
        'یک گراف دانش روی تکه‌های فایل مجموعه‌داده فعلی بسازید تا پرسش و پاسخ چندپرشی شامل منطق تودرتو بهبود یابد. برای جزئیات به https://DOCFLOW.io/docs/dev/construct_knowledge_graph مراجعه کنید.',
      graphRagMethod: 'روش',
      graphRagMethodTip: `
      Light: (پیش‌فرض) از پرامپت‌های ارائه‌شده توسط github.com/HKUDS/LightRAG برای استخراج موجودیت‌ها و روابط استفاده می‌کند. این گزینه توکن، حافظه و منابع محاسباتی کمتری مصرف می‌کند.</br>
      General: از پرامپت‌های ارائه‌شده توسط github.com/microsoft/graphrag برای استخراج موجودیت‌ها و روابط استفاده می‌کند.</br>
      NER: از NER کتابخانه spaCy و استخراج کلیدواژه مبتنی بر قاعده برای استخراج موجودیت‌ها و روابط استفاده می‌کند. برای خود استخراج به مدل زبانی نیاز نیست، که آن را سریع و کم‌مصرف می‌کند.`,
      graphRagBatchChunkTokenSize: 'اندازه توکن تکه دسته‌ای',
      graphRagBatchChunkTokenSizeTip:
        'محدودیت توکن برای هر دسته از تکه‌هایی که برای استخراج موجودیت و رابطه گراف دانش به مدل زبانی ارسال می‌شوند. برای NER اعمال نمی‌شود.',
      resolution: 'تفکیک موجودیت',
      resolutionTip: `یک کلید حذف تکرار موجودیت. وقتی فعال باشد، مدل زبانی موجودیت‌های مشابه را ترکیب می‌کند - مثلاً «2025» و «سال 2025»، یا «IT» و «فناوری اطلاعات» - تا گرافی دقیق‌تر بسازد`,
      community: 'گزارش‌های اجتماع',
      communityTip:
        'در یک گراف دانش، یک اجتماع خوشه‌ای از موجودیت‌های مرتبط با روابط است. می‌توانید از مدل زبانی بخواهید برای هر اجتماع یک چکیده تولید کند که به آن گزارش اجتماع می‌گویند. برای اطلاعات بیشتر اینجا را ببینید: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
      theDocumentBeingParsedCannotBeDeleted:
        'سندی که در حال تجزیه است قابل حذف نیست',
      lastWeek: 'نسبت به هفته گذشته',
      top: 'برتر',
    },
    chunk: {
      type: 'نوع',
      docType: {
        image: 'تصویر',
        table: 'جدول',
        text: 'متن',
      },
      size: 'اندازه',
      uploadedTime: 'زمان بارگذاری',
      chunk: 'تکه',
      createChunk: 'ایجاد تکه',
      editChunk: 'ویرایش تکه',
      bulk: 'گروهی',
      selectAll: 'انتخاب صفحه',
      enabledSelected: 'فعال‌سازی موارد انتخاب‌شده',
      disabledSelected: 'غیرفعال‌سازی موارد انتخاب‌شده',
      deleteSelected: 'حذف موارد انتخاب‌شده',
      all: 'همه',
      enabled: 'فعال',
      disabled: 'غیرفعال',
      keyword: 'کلیدواژه',
      image: 'تصویر',
      imageUploaderTitle: 'برای به‌روزرسانی این تکه تصویری، یک تصویر جدید بارگذاری کنید',
      function: 'عملکرد',
      chunkMessage: 'لطفاً مقدار را وارد کنید!',
      full: 'متن کامل',
      ellipse: 'بیضی',
      graph: 'گراف دانش',
      mind: 'نقشه ذهنی',
      question: 'سؤال',
      questionTip: `اگر سؤالاتی داده شده باشد، جاسازی تکه بر اساس آن‌ها خواهد بود.`,
      chunkResult: 'نتیجه تکه‌بندی',
      chunkResultTip: `قطعات تکه‌بندی‌شده مورد استفاده برای جاسازی و بازیابی را مشاهده کنید.`,
      representation: 'بازنمایی',
      representationKinds: {
        knowledge_graph: 'گراف دانش',
        mind_map: 'نقشه ذهنی',
        page_index: 'نمایه صفحه',
        timeline: 'خط زمانی',
        tree: 'درخت',
        raptor: 'RAPTOR',
      },
      enable: 'فعال‌سازی',
      disable: 'غیرفعال‌سازی',
      delete: 'حذف',
    },
    chat: {
      chatSupport: 'پشتیبانی گفتگو',
      replyInstantly: 'ما معمولاً فوری پاسخ می‌دهیم',
      typeYourMessage: 'پیام خود را بنویسید...',
      messagePlaceholder: 'پیام خود را اینجا بنویسید...',
      exit: 'خروج',
      multipleModels: 'چند مدل',
      applyModelConfigs: 'اعمال پیکربندی‌های مدل',
      conversations: 'گفتگوها',
      chatApps: 'اپلیکیشن‌های گفتگو',
      newConversation: 'گفتگوی جدید',
      createAssistant: 'ایجاد یک دستیار',
      assistantSetting: 'تنظیمات دستیار',
      promptEngine: 'موتور پرامپت',
      modelSetting: 'تنظیمات مدل',
      chat: 'گفتگو',
      newChat: 'گفتگوی جدید',
      send: 'ارسال',
      sendPlaceholder: 'به دستیار پیام دهید...',
      chatConfiguration: 'پیکربندی گفتگو',
      chatConfigurationDescription:
        ' اینجا یک دستیار گفتگو برای مجموعه‌داده‌های انتخابی خود راه‌اندازی کنید! 💕',
      assistantName: 'نام دستیار',
      assistantNameMessage: 'نام دستیار الزامی است',
      namePlaceholder: 'مثال: جارویس رزومه',
      assistantAvatar: 'آواتار دستیار',
      language: 'زبان',
      emptyResponse: 'پاسخ خالی',
      emptyResponseTip: `اگر هیچ نتیجه‌ای برای پرسمان شما از مجموعه‌داده‌ها بازیابی نشد، این را به‌عنوان پاسخ تنظیم کنید، یا این فیلد را خالی بگذارید تا مدل زبانی هنگام یافت‌نشدن چیزی بداهه‌پردازی کند. این تنظیم فقط زمانی اثر می‌کند که حالت تفکر روی «ساده» تنظیم شده باشد.`,
      emptyResponseMessage: `پاسخ خالی زمانی فعال می‌شود که چیز مرتبطی از مجموعه‌داده‌ها بازیابی نشود. اگر هیچ مجموعه‌داده‌ای انتخاب نشده باشد، باید فیلد «پاسخ خالی» را پاک کنید.`,
      emptyResponsePlaceholder:
        'پاسخی که به دنبال آن هستید در مجموعه‌داده یافت نشد!',
      setAnOpener: 'پیام خوش‌آمدگویی',
      setAnOpenerInitial: `سلام! من دستیار شما هستم. چه کاری می‌توانم برایتان انجام دهم؟`,
      setAnOpenerTip: 'یک پیام خوش‌آمدگویی برای کاربران تنظیم کنید.',
      knowledgeBases: 'مجموعه‌داده‌ها',
      knowledgeBasesPlaceholder: 'یک مقدار انتخاب کنید',
      knowledgeBasesMessage: 'لطفاً انتخاب کنید',
      datasetUnavailable:
        'پایگاه دانش انتخاب‌شده در دسترس نیست (حذف شده یا تکه‌ای ندارد)، لطفاً دوباره انتخاب کنید',
      knowledgeBasesTip:
        'مجموعه‌داده‌هایی را که می‌خواهید با این دستیار گفتگو مرتبط شوند انتخاب کنید. یک مجموعه‌داده خالی در فهرست کشویی نمایش داده نمی‌شود.',
      system: 'پرامپت سیستمی',
      systemPlaceholder: `شما یک دستیار هوشمند هستید. وظیفه اصلی شما پاسخ به سؤالات صرفاً بر اساس پایگاه دانش ارائه‌شده است.

**قوانین اساسی:**
  - پاسخ شما باید **صرفاً** از این مجموعه‌داده مشتق شود: {knowledge}.
  - **وقتی اطلاعات در دسترس است**: محتوا را خلاصه کنید تا پاسخی مفصل ارائه دهید.
  - **وقتی اطلاعات در دسترس نیست**: پاسخ شما باید دقیقاً شامل این جمله باشد: «پاسخی که به دنبال آن هستید در پایگاه دانش یافت نشد!»
  - **همیشه** کل تاریخچه گفتگو را در نظر بگیرید.`,
      systemInitialValue: `شما یک دستیار هوشمند هستید. وظیفه اصلی شما پاسخ به سؤالات صرفاً بر اساس پایگاه دانش ارائه‌شده است.

      **قوانین اساسی:**
        - پاسخ شما باید **صرفاً** از این مجموعه‌داده مشتق شود: \`{knowledge}\`.
        - **وقتی اطلاعات در دسترس است**: محتوا را خلاصه کنید تا پاسخی مفصل ارائه دهید.
        - **وقتی اطلاعات در دسترس نیست**: پاسخ شما باید دقیقاً شامل این جمله باشد: «پاسخی که به دنبال آن هستید در مجموعه‌داده یافت نشد!»
        - **همیشه** کل تاریخچه گفتگو را در نظر بگیرید.`,
      systemMessage: 'لطفاً وارد کنید!',
      knowledgePlaceholderMessage:
        'مجموعه‌داده‌ها انتخاب شده‌اند اما جای‌نمای {knowledge} در پرامپت سیستمی وجود ندارد، بنابراین محتوای بازیابی‌شده قابل تزریق نیست. {knowledge} را به پرامپت سیستمی اضافه کنید یا مجموعه‌داده‌ها را حذف کنید.',
      systemTip:
        'پرامپت‌ها یا دستورالعمل‌های شما برای مدل زبانی، شامل اما نه محدود به نقش آن، طول، لحن و زبان مطلوب پاسخ‌هایش. اگر مدل شما پشتیبانی بومی از استدلال دارد، می‌توانید //no_thinking را به پرامپت اضافه کنید تا استدلال متوقف شود.',
      topN: 'Top N',
      topNTip: `همه تکه‌هایی که امتیاز شباهت بالای «آستانه شباهت» دارند به مدل زبانی ارسال نمی‌شوند. این «N مورد برتر» را از میان تکه‌های بازیابی‌شده انتخاب می‌کند.`,
      rerankCandidatesCount: 'نامزدهای رتبه‌بندی مجدد',
      rerankCandidatesCountTip:
        'تعداد تکه‌های نامزد بازیابی‌شده برای رتبه‌بندی مجدد.',
      rerankCandidatesCountValidation:
        'نامزدهای رتبه‌بندی مجدد باید بزرگ‌تر یا مساوی Top N باشند.',
      variable: 'متغیر',
      variableTip: `همراه با APIهای مدیریت دستیار گفتگوی DOCFLOW استفاده می‌شود؛ متغیرها می‌توانند به توسعه راهبردهای انعطاف‌پذیرتر پرامپت سیستمی کمک کنند. متغیرهای تعریف‌شده توسط «پرامپت سیستمی» به‌عنوان بخشی از پرامپت‌های مدل زبانی استفاده می‌شوند. {knowledge} یک متغیر ویژه رزروشده است که نمایانگر تکه‌های بازیابی‌شده از مجموعه‌داده(های) مشخص‌شده است، و همه متغیرها باید در «پرامپت سیستمی» درون آکولاد {} قرار گیرند. برای جزئیات به https://DOCFLOW.io/docs/chat_configuration#system-prompt مراجعه کنید.`,
      add: 'افزودن',
      key: 'کلید',
      variableKeyMessage: 'لطفاً کلید متغیر را وارد کنید',
      optional: 'اختیاری',
      operation: 'عملیات',
      model: 'مدل',
      modelTip: 'مدل زبانی بزرگ گفتگو',
      modelMessage: 'لطفاً انتخاب کنید!',
      modelEnabledTools: 'ابزارهای فعال',
      modelEnabledToolsTip:
        'لطفاً یک یا چند ابزار برای استفاده مدل گفتگو انتخاب کنید. برای مدل‌هایی که از فراخوانی ابزار پشتیبانی نمی‌کنند اثری ندارد.',
      freedom: 'خلاقیت',
      improvise: 'بداهه',
      precise: 'دقیق',
      balance: 'متعادل',
      custom: 'سفارشی',
      freedomTip: `میان‌بری به تنظیمات «دما»، «Top P»، «جریمه حضور» و «جریمه فراوانی» که سطح آزادی مدل را نشان می‌دهد. این پارامتر سه گزینه دارد: «بداهه» را برای تولید پاسخ‌های خلاقانه‌تر انتخاب کنید؛ «دقیق» (پیش‌فرض) را برای تولید پاسخ‌های محافظه‌کارانه‌تر انتخاب کنید؛ «متعادل» حد وسط بین «بداهه» و «دقیق» است.`,
      temperature: 'دما',
      temperatureMessage: 'دما الزامی است',
      temperatureTip: `این پارامتر تصادفی‌بودن پیش‌بینی‌های مدل را کنترل می‌کند. دمای پایین‌تر منجر به پاسخ‌های محافظه‌کارانه‌تر می‌شود، در حالی که دمای بالاتر پاسخ‌های خلاقانه‌تر و متنوع‌تری تولید می‌کند.`,
      topP: 'Top P',
      topPMessage: 'Top P الزامی است',
      topPTip:
        'همچنین با نام «نمونه‌گیری هسته‌ای» شناخته می‌شود؛ این پارامتر آستانه‌ای برای انتخاب مجموعه کوچک‌تری از محتمل‌ترین کلمات جهت نمونه‌گیری تعیین می‌کند و کلمات کم‌احتمال‌تر را کنار می‌گذارد.',
      presencePenalty: 'جریمه حضور',
      presencePenaltyMessage: 'جریمه حضور الزامی است',
      presencePenaltyTip:
        'این با جریمه‌کردن کلماتی که پیش‌تر در گفتگو ظاهر شده‌اند، مدل را از تکرار اطلاعات یکسان بازمی‌دارد.',
      frequencyPenalty: 'جریمه فراوانی',
      frequencyPenaltyMessage: 'جریمه فراوانی الزامی است',
      frequencyPenaltyTip:
        'مشابه جریمه حضور، این تمایل مدل به تکرار مکرر کلمات یکسان را کاهش می‌دهد.',
      maxTokens: 'حداکثر توکن',
      maxTokensMessage: 'حداکثر توکن الزامی است',
      maxTokensTip: `حداکثر اندازه زمینه مدل؛ مقدار نامعتبر یا نادرست باعث خطا می‌شود. پیش‌فرض ۵۱۲ است.`,
      maxTokensInvalidMessage: 'لطفاً یک عدد معتبر برای حداکثر توکن وارد کنید.',
      maxTokensMinMessage: 'حداکثر توکن نمی‌تواند کمتر از ۰ باشد.',
      thinking: 'تفکر',
      thinkingMode: 'تفکر',
      thought: 'اندیشه',
      thinkingDefault: 'پیش‌فرض سیستم',
      thinkingEnabled: 'فعال',
      thinkingDisabled: 'غیرفعال',
      thinkingLevelNone: 'ساده',
      thinkingLevelLow: 'کم',
      thinkingLevelLowDescription: 'پاسخ‌های سریع',
      thinkingLevelMedium: 'متوسط',
      thinkingLevelMediumDescription: 'تعادل سرعت و عمق',
      thinkingLevelHigh: 'زیاد',
      thinkingLevelHighDescription: 'استدلال عمیق',
      thinkingLevelUltra: 'فوق‌العاده',
      thinkingLevelUltraDescription: 'حداکثر تلاش شناختی',
      thinkingTip:
        'فقط حالت تفکر را برای ارائه‌دهندگان رسمی مدل Qwen، Kimi و GLM کنترل می‌کند. پیش‌فرض سیستم تفکر Qwen را غیرفعال می‌کند تا از وظایف طولانی‌مدت جلوگیری شود.',
      quote: 'نمایش نقل‌قول',
      quoteTip: 'اینکه آیا متن اصلی به‌عنوان مرجع نمایش داده شود.',
      selfRag: 'Self-RAG',
      selfRagTip: 'لطفاً مراجعه کنید به: https://huggingface.co/papers/2310.11511',
      overview: 'شناسه گفتگو',
      pv: 'تعداد پیام‌ها',
      uv: 'تعداد کاربران فعال',
      speed: 'سرعت خروجی توکن',
      tokens: 'تعداد توکن مصرف‌شده',
      round: 'تعداد تعامل نشست',
      thumbUp: 'رضایت مشتری',
      preview: 'پیش‌نمایش',
      embedded: 'جاسازی‌شده',
      serviceApiEndpoint: 'نقطه پایانی API سرویس',
      apiKey: 'کلید API',
      apiReference: 'مستندات API',
      dateRange: 'محدوده تاریخ:',
      backendServiceApi: 'سرور API',
      createNewKey: 'ایجاد کلید جدید',
      created: 'ایجادشده',
      action: 'عملیات',
      embedModalTitle: 'جاسازی در صفحه وب',
      embedUserIdPlaceholder: 'مثال: user-001',
      embedUserIdTooltip:
        'یک شناسه متنی ساده (تا ۲۵۵ کاراکتر) برای کاربر نهایی صفحه جاسازی‌شده. این شناسه به‌عنوان پارامتر userId به نشانی جاسازی افزوده می‌شود.',
      published: 'منتشرشده',
      publishedTooltip:
        'برای این جاسازی از نسخه منتشرشده استفاده کنید. وقتی فعال باشد، نشانی تولیدشده شامل release=true می‌شود.',
      embedType: 'نوع جاسازی',
      fullscreenChat: 'گفتگوی تمام‌صفحه (iframe سنتی)',
      floatingWidget: 'ابزارک شناور (به سبک Intercom)',
      theme: 'پوسته',
      light: 'روشن',
      dark: 'تیره',
      enableStreaming: 'فعال‌سازی پاسخ‌های جریانی',
      muteWidget: 'بی‌صدا کردن صداهای ابزارک',
      comingSoon: 'به‌زودی',
      fullScreenTitle: 'جاسازی کامل',
      fullScreenDescription:
        'iframe زیر را در مکان دلخواه در وب‌سایت خود جاسازی کنید',
      partialTitle: 'جاسازی جزئی',
      extensionTitle: 'افزونه کروم',
      tokenError: 'لطفاً ابتدا کلید API ایجاد کنید.',
      betaError:
        'لطفاً ابتدا از صفحه تنظیمات سیستم یک کلید API از DOCFLOW دریافت کنید.',
      searching: 'در حال جستجو...',
      parsing: 'در حال تجزیه',
      uploading: 'در حال بارگذاری',
      uploadFailed: 'بارگذاری ناموفق بود',
      regenerate: 'تولید مجدد',
      read: 'خواندن محتوا',
      tts: 'تبدیل متن به گفتار',
      ttsTip:
        'پیش از فعال‌کردن این کلید برای پخش متن به‌صورت صوت، مطمئن شوید یک مدل TTS را در صفحه تنظیمات انتخاب کرده‌اید.',
      relatedQuestion: 'سؤال مرتبط',
      answerTitle: 'پ',
      multiTurn: 'بهینه‌سازی چندمرحله‌ای',
      multiTurnTip:
        'این پرسمان‌های کاربر را با استفاده از زمینه در یک گفتگوی چندمرحله‌ای بهینه می‌کند. وقتی فعال باشد، توکن‌های اضافی مدل زبانی مصرف خواهد کرد.',
      howUseId: 'چگونه از شناسه گفتگو استفاده کنیم؟',
      description: 'توضیحات دستیار',
      descriptionPlaceholder: 'من یک دستیار گفتگو هستم.',
      useKnowledgeGraph: 'استفاده از گراف دانش',
      useKnowledgeGraphTip:
        'اینکه آیا در حین بازیابی از گراف(های) دانش در مجموعه‌داده(های) مشخص‌شده برای پرسش و پاسخ چندپرشی استفاده شود. وقتی فعال باشد، این شامل جستجوهای تکراری در تکه‌های موجودیت، رابطه و گزارش اجتماع می‌شود که زمان بازیابی را به‌شدت افزایش می‌دهد.',
      keyword: 'تحلیل کلیدواژه',
      keywordTip: `از مدل زبانی برای تحلیل سؤالات کاربر و استخراج کلیدواژه‌هایی استفاده کنید که در حین محاسبه ارتباط برجسته خواهند شد. با پرسمان‌های طولانی خوب کار می‌کند اما زمان پاسخ‌دهی را افزایش می‌دهد.`,
      languageTip:
        'امکان بازنویسی جمله با زبان مشخص‌شده را می‌دهد یا در صورت عدم انتخاب، به‌طور پیش‌فرض به آخرین سؤال بازمی‌گردد.',
      avatarHidden: 'پنهان‌کردن آواتار',
      locale: 'زبان',
      selectLanguage: 'یک زبان انتخاب کنید',
      reasoning: 'استدلال',
      reasoningTip: `اینکه آیا یک گردش‌کار استدلال در حین پرسش و پاسخ فعال شود، همان‌طور که در مدل‌هایی مانند Deepseek-R1 دیده می‌شود. وقتی فعال باشد، به مدل امکان می‌دهد به دانش خارجی دسترسی پیدا کند و با استفاده از فنونی مانند استدلال زنجیره‌ای، سؤالات پیچیده را گام‌به‌گام حل کند. این رویکرد با تجزیه مسائل به گام‌های قابل مدیریت، توانایی مدل در ارائه پاسخ‌های دقیق را افزایش می‌دهد و عملکرد را در وظایفی که به استدلال منطقی و تفکر چندمرحله‌ای نیاز دارند بهبود می‌بخشد.`,
      tavilyApiKeyTip:
        'اگر کلید API اینجا به‌درستی تنظیم شود، جستجوهای وب مبتنی بر Tavily برای تکمیل بازیابی از مجموعه‌داده استفاده خواهند شد.',
      tavilyApiKeyMessage: 'لطفاً کلید API Tavily خود را وارد کنید',
      webSearch: 'جستجوی وب',
      webSearchProvider: 'ارائه‌دهنده جستجوی وب',
      webSearchProviderTip:
        'سرویسی را که هنگام فعال‌بودن جستجوی اینترنتی استفاده می‌شود انتخاب کنید.',
      webSearchProviderPlaceholder: 'یک ارائه‌دهنده جستجوی وب انتخاب کنید',
      queritApiKeyTip:
        'وقتی Querit انتخاب شود، نتایج جستجوی وب آن بازیابی از مجموعه‌داده را تکمیل می‌کند.',
      queritApiKeyMessage: 'لطفاً کلید API Querit خود را وارد کنید',
      serplyApiKeyTip:
        'وقتی Serply انتخاب شود، نتایج جستجوی وب آن بازیابی از مجموعه‌داده را تکمیل می‌کند.',
      serplyApiKeyMessage: 'لطفاً کلید API Serply خود را وارد کنید',
      youcomApiKeyTip:
        'اختیاری. You.com بدون کلید روی نقطه پایانی با محدودیت نرخ کار می‌کند؛ برای رفع این محدودیت‌ها یک کلید اضافه کنید.',
      youcomApiKeyMessage: 'اختیاری — برای استفاده از سطح رایگان خالی بگذارید',
      tavilyApiKeyHelp: 'چگونه آن را دریافت کنیم؟',
      crossLanguage: 'جستجوی بین‌زبانی',
      crossLanguagePlaceholder: 'یک مقدار انتخاب کنید',
      crossLanguageTip: `یک یا چند زبان برای جستجوی بین‌زبانی انتخاب کنید. اگر هیچ زبانی انتخاب نشود، سیستم با پرسمان اصلی جستجو می‌کند.`,
      createChat: 'ایجاد گفتگو',
      metadata: 'فراداده',
      metadataTip:
        'فیلترکردن فراداده فرایند استفاده از ویژگی‌های فراداده (مانند برچسب‌ها، دسته‌ها یا مجوزهای دسترسی) برای پالایش و کنترل بازیابی اطلاعات مرتبط در یک سیستم است.',
      conditions: 'شرایط',
      metadataKeys: 'موارد قابل فیلتر',
      addCondition: 'افزودن شرط',
      meta: {
        disabled: 'غیرفعال',
        auto: 'خودکار',
        manual: 'دستی',
        semi_auto: 'نیمه‌خودکار',
      },
      cancel: 'انصراف',
      chatSetting: 'تنظیمات گفتگو',
      tocEnhance: 'نمایه صفحه',
      tocEnhanceTip: `در حین تجزیه سند، اطلاعات فهرست مطالب تولید شد (گزینه «فعال‌سازی استخراج فهرست مطالب» را در روش عمومی ببینید). این به مدل بزرگ امکان می‌دهد موارد فهرست مطالب مرتبط با پرسمان کاربر را بازگرداند و از این موارد برای بازیابی تکه‌های مرتبط و اعمال وزن‌دهی به این تکه‌ها در حین فرایند مرتب‌سازی استفاده کند. این رویکرد رفتار جستجوی اطلاعات انسان در کتاب‌ها را تقلید می‌کند.`,
      batchDeleteSessions: 'حذف گروهی',
      deleteSelectedConfirm: 'آیا {{count}} نشست انتخاب‌شده حذف شود؟',
      showChunkMetadata: 'نمایش فراداده تکه',
      showChunkMetadataTip:
        'فراداده سند (مثلاً عنوان، شماره صفحه، تاریخ بارگذاری) را در کنار تکه‌های متنی بازیابی‌شده نمایش می‌دهد',
      metadataFields: 'فیلدهای فراداده',
      metadataFieldsTip:
        'انتخاب کنید کدام فیلدهای فراداده با هر تکه نمایش داده شوند',
    },
    setting: {
      Verify: 'راستی‌آزمایی',
      keyValid: 'کلید API شما معتبر است.',
      keyInvalid: 'کلید API شما نامعتبر است.',
      enableToolCall: 'فعال‌سازی فراخوانی ابزار',
      enableToolCallTip:
        'به این مدل اجازه می‌دهد وقتی نوع مدل انتخاب‌شده از فراخوانی ابزار پشتیبانی می‌کند، ابزارها را فراخوانی کند.',
      deleteModel: 'حذف مدل',
      bedrockCredentialsHint:
        'نکته: برای استفاده از احراز هویت AWS IAM، ACCESS KEY / SECRET KEY را خالی بگذارید.',
      awsAuthModeAccessKeySecret: 'ACCESS KEY',
      awsAuthModeIamRole: 'نقش IAM',
      awsAuthModeAssumeRole: 'Assume Role',
      awsAccessKeyId: 'AWS ACCESS KEY ID',
      awsSecretAccessKey: 'AWS SECRET ACCESS KEY',
      awsRoleArn: 'AWS Role ARN',
      awsRoleArnMessage: 'لطفاً AWS Role ARN را وارد کنید',
      awsAssumeRoleTip:
        'اگر این حالت را انتخاب کنید، نمونه Amazon EC2 نقش موجود خود را برای دسترسی به سرویس‌های AWS بر عهده می‌گیرد. به اطلاعات ورود اضافی نیازی نیست.',
      modelEmptyTip:
        'هیچ مدلی در دسترس نیست. <br>لطفاً مدل‌ها را از پنل سمت راست اضافه کنید.',
      sourceEmptyTip: 'هنوز هیچ منبع داده‌ای افزوده نشده است. برای اتصال یکی را از زیر انتخاب کنید.',
      seconds: 'ثانیه',
      minutes: 'دقیقه',
      edit: 'ویرایش',
      cropTip:
        'ناحیه انتخاب را بکشید تا موقعیت برش تصویر را انتخاب کنید و برای بزرگ‌نمایی/کوچک‌نمایی اسکرول کنید',
      cropImage: 'برش تصویر',
      selectModelPlaceholder: 'انتخاب مدل',
      configureModelTitle: 'پیکربندی مدل',
      connectorNameTip: 'یک نام توصیفی برای رابط',
      syncDeletedFiles: 'همگام‌سازی فایل‌های حذف‌شده',
      // Data source form field labels
      dataSourceFieldName: 'نام',
      dataSourceFieldSource: 'منبع',
      dataSourceFieldTenantId: 'شناسه Tenant',
      dataSourceFieldClientId: 'شناسه Client',
      dataSourceFieldClientSecret: 'Client Secret',
      dataSourceFieldFolderPathOptional: 'مسیر پوشه (اختیاری)',
      dataSourceFieldBatchSize: 'اندازه دسته',
      dataSourceFieldMailFolder: 'پوشه ایمیل',
      dataSourceFieldMailboxUserIds: 'شناسه‌های کاربری صندوق پستی (اختیاری)',
      dataSourceFieldInstanceUrl: 'نشانی نمونه',
      dataSourceFieldObjects: 'اشیاء',
      dataSourceFieldApiVersion: 'نسخه API',
      dataSourceFieldAuthMode: 'حالت احراز هویت',
      dataSourceFieldAccountName: 'نام حساب',
      dataSourceFieldAccountKey: 'کلید حساب',
      dataSourceFieldConnectionString: 'رشته اتصال',
      dataSourceFieldContainerUrl: 'نشانی Container',
      dataSourceFieldSasToken: 'توکن SAS',
      dataSourceFieldContainerName: 'نام Container',
      dataSourceFieldPrefixOptional: 'پیشوند (اختیاری)',
      dataSourceFieldFeedUrl: 'نشانی Feed',
      dataSourceFieldGcsAccessKeyId: 'GCS Access Key ID',
      dataSourceFieldGcsSecretAccessKey: 'GCS Secret Access Key',
      dataSourceFieldBucketName: 'نام Bucket',
      dataSourceFieldOciNamespace: 'فضای نام OCI',
      dataSourceFieldOciRegion: 'منطقه OCI',
      dataSourceFieldOciAccessKeyId: 'OCI Access Key ID',
      dataSourceFieldOciSecretAccessKey: 'OCI Secret Access Key',
      dataSourceFieldR2AccountId: 'شناسه حساب R2',
      dataSourceFieldR2AccessKeyId: 'R2 Access Key ID',
      dataSourceFieldR2SecretAccessKey: 'R2 Secret Access Key',
      dataSourceFieldNotionIntegrationToken: 'توکن یکپارچه‌سازی Notion',
      dataSourceFieldRootPageId: 'شناسه صفحه ریشه',
      dataSourceFieldDiscordBotToken: 'توکن ربات Discord',
      dataSourceFieldServerIds: 'شناسه‌های سرور',
      dataSourceFieldChannels: 'کانال‌ها',
      dataSourceFieldXquikApiKey: 'کلید API Xquik',
      dataSourceFieldXquikQuery: 'پرسمان جستجوی X',
      dataSourceFieldXquikQueryType: 'ترتیب نتایج',
      dataSourceFieldXquikPageSize: 'تعداد پست در هر صفحه',
      dataSourceFieldPrimaryAdminEmail: 'ایمیل مدیر اصلی',
      dataSourceFieldOauthTokenJson: 'OAuth Token JSON',
      dataSourceFieldMyDriveEmails: 'ایمیل‌های My Drive',
      dataSourceFieldSharedFolderUrls: 'نشانی‌های پوشه اشتراکی',
      dataSourceFieldMoodleUrl: 'نشانی Moodle',
      dataSourceFieldApiToken: 'توکن API',
      dataSourceFieldSlackBotToken: 'توکن ربات Slack',
      dataSourceFieldSiteUrl: 'نشانی سایت',
      dataSourceFieldWebdavServerUrl: 'نشانی سرور WebDAV',
      dataSourceFieldUsername: 'نام کاربری',
      dataSourceFieldPassword: 'رمز عبور',
      dataSourceFieldRemotePath: 'مسیر راه دور',
      dataSourceFieldAccessToken: 'توکن دسترسی',
      dataSourceFieldBoxOauthConfiguration: 'پیکربندی OAuth Box',
      dataSourceFieldFolderId: 'شناسه پوشه',
      dataSourceFieldBaseId: 'شناسه Base',
      dataSourceFieldTableNameOrId: 'نام یا شناسه جدول',
      dataSourceFieldOperatorId: 'شناسه اپراتور',
      dataSourceFieldProjectOwner: 'مالک پروژه',
      dataSourceFieldProjectName: 'نام پروژه',
      dataSourceFieldGitlabPersonalAccessToken: 'توکن دسترسی شخصی GitLab',
      dataSourceFieldGitlabUrl: 'نشانی GitLab',
      dataSourceFieldIncludeIssues: 'گنجاندن Issueها',
      dataSourceFieldWorkspaceId: 'شناسه فضای کاری',
      dataSourceFieldProjectIds: 'شناسه‌های پروژه',
      dataSourceFieldTeamId: 'شناسه تیم',
      dataSourceFieldRepositoryOwner: 'مالک مخزن',
      dataSourceFieldRepositoryName: 'نام مخزن',
      dataSourceFieldGithubAccessToken: 'توکن دسترسی GitHub',
      dataSourceFieldHost: 'میزبان',
      dataSourceFieldPort: 'درگاه',
      dataSourceFieldMailboxes: 'صندوق‌های پستی',
      dataSourceFieldPollRange: 'بازه واکشی',
      dataSourceFieldZendeskDomain: 'دامنه Zendesk',
      dataSourceFieldZendeskEmail: 'ایمیل Zendesk',
      dataSourceFieldZendeskToken: 'توکن Zendesk',
      dataSourceFieldContent: 'محتوا',
      dataSourceFieldDatabase: 'پایگاه داده',
      dataSourceFieldSqlQuery: 'پرسمان SQL',
      dataSourceFieldContentColumns: 'ستون‌های محتوا',
      dataSourceFieldMetadataColumns: 'ستون‌های فراداده',
      dataSourceFieldIdColumn: 'ستون شناسه',
      dataSourceFieldTimestampColumn: 'ستون مُهر زمانی',
      dataSourceFieldProjectId: 'شناسه پروژه',
      dataSourceFieldLocation: 'مکان',
      dataSourceFieldServiceAccountJson: 'Service Account JSON',
      dataSourceFieldDatasetId: 'شناسه Dataset',
      dataSourceFieldTableId: 'شناسه جدول',
      dataSourceFieldMaxBytesBilled: 'حداکثر بایت محاسبه‌شده',
      dataSourceFieldJobTimeout: 'مهلت زمانی کار (میلی‌ثانیه)',
      dataSourceFieldPageSize: 'اندازه صفحه',
      dataSourceFieldUseQueryCache: 'استفاده از حافظه پنهان پرسمان',
      dataSourceFieldBaseUrl: 'نشانی پایه',
      dataSourceFieldHttpMethod: 'روش HTTP',
      dataSourceFieldQueryParameters: 'پارامترهای پرسمان',
      dataSourceFieldItemsPath: 'مسیر اقلام',
      dataSourceFieldIdField: 'فیلد شناسه',
      dataSourceFieldAuthType: 'نوع احراز هویت',
      dataSourceFieldApiKeyHeaderName: 'نام سرآیند کلید API',
      dataSourceFieldApiKeyValue: 'مقدار کلید API',
      dataSourceFieldBearerToken: 'توکن Bearer',
      dataSourceFieldContentFields: 'فیلدهای محتوا',
      dataSourceFieldMetadataFields: 'فیلدهای فراداده',
      dataSourceFieldPaginationType: 'نوع صفحه‌بندی',
      dataSourceFieldStartPage: 'صفحه شروع',
      dataSourceFieldOffsetParam: 'پارامتر Offset',
      dataSourceFieldStartOffset: 'Offset شروع',
      dataSourceFieldCursorParam: 'پارامتر Cursor',
      dataSourceFieldNextCursorJsonpath: 'Next Cursor JSONPath',
      dataSourceFieldAdvancedSettings: 'تنظیمات پیشرفته',
      dataSourceFieldCustomHeaders: 'سرآیندهای سفارشی (JSON)',
      dataSourceFieldLimitParam: 'پارامتر Limit',
      dataSourceFieldInitialCursor: 'Cursor اولیه',
      dataSourceFieldMaxPages: 'حداکثر صفحات',
      dataSourceFieldRequestDelay: 'تأخیر درخواست (ثانیه)',
      dataSourceFieldPollTimestampField: 'فیلد مُهر زمانی واکشی',
      dataSourceFieldRequestBody: 'بدنه درخواست (POST) JSON',
      dataSourceFieldConfluenceUsername: 'نام کاربری Confluence',
      dataSourceFieldConfluenceAccessToken: 'توکن دسترسی Confluence',
      dataSourceFieldWikiBaseUrl: 'نشانی پایه Wiki',
      dataSourceFieldIsCloud: 'ابری است',
      dataSourceFieldIndexMode: 'حالت نمایه‌سازی',
      dataSourceFieldAzureDevOpsPat: 'توکن دسترسی شخصی Azure DevOps',
      dataSourceFieldAzureDevOpsOrganization: 'سازمان Azure DevOps',
      dataSourceFieldAzureDevOpsRepositories: 'مخازن',
      dataSourceFieldAzureDevOpsContentTypes: 'انواع محتوا',
      dataSourceOptionOrganization: 'سازمان',
      dataSourceOptionCode: 'کد',
      dataSourceOptionPullRequests: 'Pull Requestها',
      dataSourceOptionBoth: 'هر دو',
      dataSourceFieldPageId: 'شناسه صفحه',
      dataSourceFieldSpaceKey: 'کلید Space',
      dataSourceFieldIndexRecursively: 'نمایه‌سازی بازگشتی',
      dataSourceFieldJiraUserEmail: 'ایمیل کاربر Jira',
      dataSourceFieldJiraUsername: 'نام کاربری Jira',
      dataSourceFieldJiraBaseUrl: 'نشانی پایه Jira',
      dataSourceFieldProjectKey: 'کلید پروژه',
      dataSourceFieldCustomJql: 'JQL سفارشی',
      dataSourceFieldAttachmentSizeLimit: 'محدودیت اندازه پیوست (بایت)',
      dataSourceFieldLabelsToSkip: 'برچسب‌هایی که باید نادیده گرفته شوند',
      dataSourceFieldCommentEmailBlacklist: 'فهرست سیاه ایمیل نظرات',
      dataSourceFieldIncludeComments: 'گنجاندن نظرات',
      dataSourceFieldIncludeAttachments: 'گنجاندن پیوست‌ها',
      dataSourceFieldMode: 'حالت',
      dataSourceFieldJiraApiToken: 'توکن API Jira',
      dataSourceFieldJiraPassword: 'رمز عبور Jira',
      dataSourceFieldUseScopedToken: 'استفاده از توکن محدوده‌دار',
      dataSourceFieldRegion: 'منطقه',
      dataSourceFieldPrefix: 'پیشوند',
      dataSourceFieldAuthentication: 'احراز هویت',
      dataSourceFieldAwsAccessKeyId: 'AWS Access Key ID',
      dataSourceFieldAwsSecretAccessKey: 'AWS Secret Access Key',
      dataSourceFieldRoleArn: 'Role ARN',
      dataSourceFieldAddressingStyle: 'سبک آدرس‌دهی',
      dataSourceFieldEndpointUrl: 'نشانی نقطه پایانی',
      dataSourceFieldSeafileServerUrl: 'نشانی سرور SeaFile',
      dataSourceFieldSyncScope: 'دامنه همگام‌سازی',
      dataSourceFieldAccountApiToken: 'توکن API حساب',
      dataSourceFieldIncludeSharedLibraries: 'گنجاندن کتابخانه‌های اشتراکی',
      dataSourceFieldLibraryToken: 'توکن کتابخانه',
      dataSourceFieldLibraryId: 'شناسه کتابخانه',
      dataSourceFieldDirectoryPath: 'مسیر دایرکتوری',
      dataSourceFieldBitbucketAccountEmail: 'ایمیل حساب Bitbucket',
      dataSourceFieldBitbucketApiToken: 'توکن API Bitbucket',
      dataSourceFieldWorkspace: 'فضای کاری',
      dataSourceFieldRepositorySlugs: 'اسلاگ‌های مخزن',
      dataSourceFieldProjects: 'پروژه‌ها',
      dataSourceIncludePullRequests: 'گنجاندن Pull Requestها',
      dataSourceIncludeMergeRequests: 'گنجاندن Merge Requestها',
      dataSourceIncludeIssues: 'گنجاندن Issueها',
      dataSourceIncludeCodeFiles: 'گنجاندن فایل‌های کد',
      // Data source form options
      dataSourceOptionAccountKey: 'کلید حساب',
      dataSourceOptionConnectionString: 'رشته اتصال',
      dataSourceOptionSasToken: 'توکن SAS',
      dataSourceOptionArticles: 'مقالات',
      dataSourceOptionTickets: 'تیکت‌ها',
      dataSourceOptionNone: 'هیچ‌کدام',
      dataSourceOptionApiKeyHeader: 'کلید API (سرآیند)',
      dataSourceOptionBearerToken: 'توکن Bearer',
      dataSourceOptionBasicAuth: 'احراز هویت پایه',
      dataSourceOptionPage: 'صفحه',
      dataSourceOptionOffset: 'Offset',
      dataSourceOptionCursor: 'Cursor',
      dataSourceOptionEverything: 'همه‌چیز',
      dataSourceOptionSpace: 'Space',
      dataSourceOptionCloud: 'ابری',
      dataSourceOptionServer: 'سرور',
      dataSourceOptionS3Compatible: 'سازگار با S3',
      dataSourceOptionAccessKey: 'کلید دسترسی',
      dataSourceOptionIamRole: 'نقش IAM',
      dataSourceOptionAssumeRole: 'Assume Role',
      dataSourceOptionVirtualHostedStyle: 'سبک Virtual Hosted',
      dataSourceOptionPathStyle: 'سبک مسیر',
      dataSourceOptionEntireAccount: 'کل حساب',
      dataSourceOptionSingleLibrary: 'یک کتابخانه',
      dataSourceOptionSpecificDirectory: 'دایرکتوری خاص',
      dataSourceOptionRepositories: 'مخازن',
      dataSourceOptionProjects: 'پروژه‌ها',
      dataSourceOptionWorkspace: 'فضای کاری',
      // Data source validation messages
      dataSourceValidationFieldRequired: '{{label}} الزامی است',
      dataSourceValidationMinOne: '{{label}} باید حداقل ۱ باشد',
      dataSourceConfluenceEverythingTip:
        'این انتخاب همه صفحاتی را که اطلاعات ورود ارائه‌شده به آن‌ها دسترسی دارد نمایه می‌کند.',
      dataSourceS3AssumeRoleTip:
        'به اطلاعات ورود نیازی نیست. از نقش پیش‌فرض محیط استفاده می‌کند.',
      dataSourceS3RoleArnTip:
        'این نقش توسط محیط زمان اجرا بر عهده گرفته می‌شود.',
      dataSourceS3RegionRequired: 'هنگام استفاده از کلید دسترسی، منطقه الزامی است',
      dataSourceAzureAccountNameRequired:
        'برای احراز هویت با کلید حساب، نام حساب الزامی است',
      dataSourceAzureAccountKeyRequired:
        'برای احراز هویت با کلید حساب، کلید حساب الزامی است',
      dataSourceAzureConnectionStringRequired:
        'برای احراز هویت با رشته اتصال، رشته اتصال الزامی است',
      dataSourceAzureContainerUrlRequired:
        'برای احراز هویت با توکن SAS، نشانی Container الزامی است',
      dataSourceAzureSasTokenRequired:
        'برای احراز هویت با توکن SAS، توکن SAS الزامی است',
      dataSourceAzureContainerNameRequired:
        'برای این حالت احراز هویت، نام Container الزامی است',
      dataSourceBigqueryDatasetIdRequired:
        'هنگام عدم استفاده از پرسمان SQL سفارشی، شناسه Dataset الزامی است',
      dataSourceBigqueryTableIdRequired:
        'هنگام عدم استفاده از پرسمان SQL سفارشی، شناسه جدول الزامی است',
      dataSourceBigqueryQueryRequired:
        'یک پرسمان SQL، یا هر دو شناسه Dataset و شناسه جدول را ارائه دهید',
      dataSourceSalesforceInstanceUrlInvalid:
        'باید یک دامنه معتبر Salesforce باشد (https://...salesforce.com)',
      dataSourceSalesforceApiVersionInvalid:
        'نسخه API باید با قالبی مانند v59.0 مطابقت داشته باشد',
      // Data source detail page labels
      dataSourcePruneFreq: 'فراوانی هرس',
      dataSourceRefreshFreq: 'فراوانی به‌روزرسانی',
      dataSourceTimeoutSecs: 'مهلت زمانی (ثانیه)',
      confluenceIsCloudTip:
        'اگر این یک نمونه Confluence Cloud است علامت بزنید، برای Confluence Server/Data Center علامت را بردارید',
      confluenceWikiBaseUrlTip:
        'نشانی پایه نمونه Confluence شما (مثلاً https://your-domain.atlassian.net/wiki)',
      confluenceSpaceKeyTip:
        'اختیاری: برای محدودکردن همگام‌سازی به یک Space خاص، یک کلید Space مشخص کنید. برای همگام‌سازی همه Spaceهای قابل دسترسی خالی بگذارید. برای چند Space، با ویرگول جدا کنید (مثلاً DEV,DOCS,HR)',
      s3PrefixTip: `مسیر پوشه‌ای را که می‌خواهید فایل‌ها از آن واکشی شوند در Bucket S3 خود مشخص کنید.
مثال: general/v2/`,
      S3CompatibleEndpointUrlTip: `برای Storage Box سازگار با S3 لازم است. نشانی نقطه پایانی سازگار با S3 را مشخص کنید.
مثال: https://fsn1.your-objectstorage.com`,
      S3CompatibleAddressingStyleTip: `برای Storage Box سازگار با S3 لازم است. سبک آدرس‌دهی سازگار با S3 را مشخص کنید.
مثال: Virtual Hosted Style`,
      addDataSourceModalTitle: 'رابط {{name}} خود را ایجاد کنید',
      deleteSourceModalTitle: 'حذف منبع داده',
      deleteSourceModalContent: `
      <p>آیا از حذف این پیوند منبع داده مطمئن هستید؟</p>`,
      deleteSourceModalConfirmText: 'تأیید',
      errorMsg: 'پیام خطا',
      newDocs: 'اسناد جدید',
      timeStarted: 'زمان شروع',
      log: 'گزارش',
      rssDescription:
        'به یک فید عمومی RSS یا Atom متصل شوید و ورودی‌های فید را با پایگاه دانش خود همگام کنید.',
      confluenceDescription:
        'فضای کاری Confluence خود را یکپارچه کنید تا مستندات را جستجو کنید.',
      s3Description:
        'به Bucket AWS S3 خود متصل شوید تا فایل‌های ذخیره‌شده را وارد و همگام کنید.',
      google_cloud_storageDescription:
        'Bucket Google Cloud Storage خود را متصل کنید تا فایل‌ها را وارد و همگام کنید.',
      r2Description:
        'Bucket Cloudflare R2 خود را متصل کنید تا فایل‌ها را وارد و همگام کنید.',
      oci_storageDescription:
        'Bucket فضای ذخیره‌سازی شیء Oracle Cloud خود را متصل کنید تا فایل‌ها را وارد و همگام کنید.',
      discordDescription:
        'سرور Discord خود را پیوند دهید تا به داده‌های گفتگو دسترسی داشته و آن‌ها را تحلیل کنید.',
      notionDescription:
        'صفحات و پایگاه‌های داده را از Notion برای بازیابی دانش همگام کنید.',
      google_driveDescription:
        'Google Drive خود را از طریق OAuth متصل کنید و پوشه‌ها یا درایوهای خاص را همگام کنید.',
      gmailDescription: 'Gmail خود را از طریق OAuth متصل کنید تا ایمیل‌ها را همگام کنید.',
      webdavDescription: 'به سرورهای WebDAV متصل شوید تا فایل‌ها را همگام کنید.',
      webdavRemotePathTip:
        'اختیاری: یک مسیر پوشه روی سرور WebDAV مشخص کنید (مثلاً /Documents). برای همگام‌سازی از ریشه خالی بگذارید.',
      webdavCaCertPathTip:
        'اختیاری: مسیر یک بسته گواهی CA که درون کانتینر DOCFLOW سوار شده است.',
      google_driveTokenTip:
        'فایل JSON توکن OAuth تولیدشده از دستیار OAuth یا Google Cloud Console را بارگذاری کنید. همچنین می‌توانید یک JSON از client_secret یک برنامه «installed» یا «web» بارگذاری کنید. اگر این اولین همگام‌سازی شماست، پنجره مرورگری برای تکمیل رضایت OAuth باز می‌شود. اگر JSON از قبل شامل یک توکن تازه‌سازی باشد، به‌طور خودکار دوباره استفاده می‌شود.',
      google_drivePrimaryAdminTip:
        'نشانی ایمیلی که به محتوای Drive در حال همگام‌سازی دسترسی دارد',
      zendeskDescription:
        'Zendesk خود را متصل کنید تا تیکت‌ها، مقالات و دیگر محتوا را همگام کنید.',
      google_driveMyDriveEmailsTip:
        'ایمیل‌های جداشده با ویرگول که محتوای «My Drive» آن‌ها باید نمایه شود (مدیر اصلی را نیز بگنجانید).',
      google_driveSharedFoldersTip:
        'پیوندهای پوشه Google Drive جداشده با ویرگول برای خزش.',
      gmailPrimaryAdminTip:
        'ایمیل مدیر اصلی با دسترسی Gmail / Workspace که برای شمارش کاربران دامنه و به‌عنوان حساب پیش‌فرض همگام‌سازی استفاده می‌شود.',
      gmailTokenTip:
        'JSON از OAuth تولیدشده از Google Console را بارگذاری کنید. اگر فقط شامل اطلاعات ورود Client است، یک‌بار راستی‌آزمایی مبتنی بر مرورگر را اجرا کنید تا توکن‌های تازه‌سازی بادوام ساخته شوند.',
      dropboxDescription:
        'Dropbox خود را متصل کنید تا فایل‌ها و پوشه‌ها را از یک حساب انتخاب‌شده همگام کنید.',
      teamsDescription:
        'Microsoft Teams را از طریق Microsoft Graph متصل کنید تا پست‌ها و پاسخ‌های کانال را همگام کنید.',
      teamsTenantIdTip:
        'شناسه Tenant در Azure AD. به برنامه‌ای با مجوزهای برنامه Team.ReadBasic.All و ChannelMessage.Read.All (رضایت مدیر) نیاز دارد.',
      slackDescription:
        'فضای کاری Slack خود را متصل کنید تا پیام‌ها و رشته‌های کانال را همگام کنید.',
      slackBotTokenTip:
        'توکن OAuth کاربر ربات Slack (با xoxb- شروع می‌شود). برنامه به محدوده‌های channels:read، channels:history و users:read نیاز دارد.',
      slackChannelsTip:
        'اختیاری: نام کانال‌هایی که باید همگام شوند (مثلاً general). برای همگام‌سازی همه کانال‌های قابل دسترسی خالی بگذارید.',
      sharepointDescription:
        'یک سایت SharePoint را از طریق Microsoft Graph متصل کنید تا کتابخانه‌های اسناد آن همگام شوند.',
      sharepointSiteUrlTip:
        'نشانی کامل سایت SharePoint برای نمایه‌سازی، مثلاً https://contoso.sharepoint.com/sites/MySite. به یک برنامه Azure AD با مجوزهای برنامه Sites.Read.All و Files.Read.All (رضایت مدیر) نیاز دارد.',
      azureDevOpsPatTip: 'یک توکن دسترسی شخصی با محدوده Code (Read).',
      azureDevOpsOrganizationTip:
        'نام سازمان (مثلاً «contoso»)، یا نشانی کامل مجموعه یک Azure DevOps Server خودمیزبان (مثلاً https://tfs.contoso.com/DefaultCollection).',
      azureDevOpsProjectsTip:
        'نام پروژه‌های تیمی جداشده با ویرگول. مثلاً Project1,Project2',
      azureDevOpsRepositoriesTip:
        'مخازن جداشده با ویرگول. برای رفع ابهام مخازنی که نام مشترک دارند از project/repo استفاده کنید.',
      azureDevOpsOrganizationScopeTip:
        'هر مخزنی که برای توکن در این سازمان قابل مشاهده باشد نمایه خواهد شد.',
      azureDevOpsContentTypesTip:
        'انتخاب کنید چه چیزی نمایه شود: فایل‌های منبع، Pull Requestها، یا هر دو.',
      azure_devopsDescription:
        'Azure DevOps را متصل کنید تا فایل‌های مخزن و Pull Requestها همگام شوند.',
      bitbucketDescription: 'Bitbucket را متصل کنید تا محتوای PR همگام شود.',
      bitbucketTopWorkspaceTip:
        'فضای کاری Bitbucket برای نمایه‌سازی (مثلاً «atlassian» از https://bitbucket.org/atlassian/workspace ).',
      bitbucketRepositorySlugsTip:
        'اسلاگ‌های مخزن جداشده با ویرگول. مثلاً repo-one,repo-two',
      bitbucketProjectsTip: 'کلیدهای پروژه جداشده با ویرگول. مثلاً PROJ1,PROJ2',
      bitbucketWorkspaceTip:
        'این رابط همه مخازن موجود در فضای کاری را نمایه خواهد کرد.',
      boxDescription: 'درایو Box خود را متصل کنید تا فایل‌ها و پوشه‌ها همگام شوند.',

      githubDescription:
        'GitHub را متصل کنید تا Pull Requestها و Issueها برای بازیابی همگام شوند.',
      airtableDescription:
        'به Airtable متصل شوید و فایل‌ها را از یک جدول مشخص در یک فضای کاری تعیین‌شده همگام کنید.',
      dingtalkAITableDescription:
        'به Dingtalk AI Table متصل شوید و رکوردها را از یک جدول مشخص همگام کنید.',
      gitlabDescription:
        'GitLab را متصل کنید تا مخازن، Issueها، Merge Requestها و مستندات مرتبط همگام شوند.',
      asanaDescription:
        'به Asana متصل شوید و فایل‌ها را از یک فضای کاری مشخص همگام کنید.',
      imapDescription:
        'به صندوق پستی IMAP خود متصل شوید تا ایمیل‌ها را برای بازیابی دانش همگام کنید.',
      dropboxAccessTokenTip:
        'یک توکن دسترسی بادوام در Dropbox App Console با محدوده‌های files.metadata.read، files.content.read و sharing.read تولید کنید.',
      moodleDescription:
        'به سامانه Moodle LMS خود متصل شوید تا محتوای دوره‌ها، انجمن‌ها و منابع همگام شوند.',
      moodleUrlTip:
        'نشانی پایه نمونه Moodle شما (مثلاً https://moodle.university.edu). /webservice یا /login را نگنجانید.',
      moodleTokenTip:
        'یک توکن وب‌سرویس در Moodle تولید کنید: به Site administration → Server → Web services → Manage tokens بروید. کاربر باید در دوره‌هایی که می‌خواهید همگام کنید ثبت‌نام شده باشد.',
      seafileDescription:
        'به سرور SeaFile خود متصل شوید تا فایل‌ها و اسناد را از کتابخانه‌های خود همگام کنید.',
      seafileUrlTip:
        'نشانی کامل سرور SeaFile شما شامل پروتکل. مثال: https://seafile.example.com - اسلش انتهایی یا هیچ مسیری پس از دامنه را نگنجانید.',
      seafileAccountScopeTip:
        'همه کتابخانه‌های قابل مشاهده برای توکن API حساب زیر را همگام می‌کند.',
      seafileTokenPanelHeading: 'یکی از این روش‌های احراز هویت را ارائه دهید:',
      seafileTokenPanelAccountBullet: '- به همه کتابخانه‌های شما دسترسی می‌دهد.',
      seafileTokenPanelLibraryBullet:
        '— فقط محدود به یک کتابخانه (امن‌تر).',
      seafileValidationAccountTokenRequired:
        'برای دامنه «کل حساب»، توکن API حساب الزامی است',
      seafileValidationTokenRequired:
        'یا یک توکن API حساب یا یک توکن کتابخانه ارائه دهید',
      seafileValidationLibraryIdRequired: 'شناسه کتابخانه الزامی است',
      seafileValidationDirectoryPathRequired: 'مسیر دایرکتوری الزامی است',
      seafileSyncScopeTip:
        'کنترل می‌کند چه چیزی همگام شود: ' +
        '(۱) کل حساب - همه کتابخانه‌هایی را که توکن شما به آن‌ها دسترسی دارد همگام می‌کند. به یک توکن API حساب نیاز دارد. ' +
        '(۲) یک کتابخانه - همه فایل‌های درون یک کتابخانه خاص را همگام می‌کند. به شناسه کتابخانه و یا یک توکن API حساب یا یک توکن API کتابخانه نیاز دارد. ' +
        '(۳) دایرکتوری خاص - فقط فایل‌های درون یک پوشه خاص در یک کتابخانه را همگام می‌کند. به شناسه کتابخانه، مسیر پوشه درون آن کتابخانه، و یا یک توکن API حساب یا یک توکن API کتابخانه نیاز دارد.',
      seafileTokenTip:
        'توکن API SeaFile در سطح حساب شما. ' +
        'به همه کتابخانه‌های قابل مشاهده برای حساب شما دسترسی می‌دهد. ' +
        'وقتی دامنه همگام‌سازی «کل حساب» است الزامی است. ' +
        'برای «یک کتابخانه» یا «دایرکتوری خاص» می‌توانید از این توکن یا به‌جای آن از یک توکن API کتابخانه استفاده کنید.',
      seafileRepoTokenTip:
        'یک توکن API محدود به کتابخانه که فقط به یک کتابخانه خاص دسترسی می‌دهد. ' +
        'می‌تواند به‌جای توکن API حساب برای دامنه‌های همگام‌سازی «یک کتابخانه» و «دایرکتوری خاص» استفاده شود.',
      seafileRepoIdTip:
        'شناسه یکتای (UUID) کتابخانه SeaFile که می‌خواهید همگام کنید. ' +
        'هنگام باز کردن کتابخانه در رابط وب SeaFile می‌توانید آن را در نوار نشانی مرورگر خود بیابید. ' +
        'مثال: 7a9e1b3c-4d5f-6a7b-8c9d-0e1f2a3b4c5d. ' +
        'وقتی دامنه همگام‌سازی «یک کتابخانه» یا «دایرکتوری خاص» است الزامی است.',
      seafileSyncPathTip:
        'مسیر مطلق پوشه‌ای که باید در کتابخانه مشخص‌شده با شناسه کتابخانه بالا همگام شود. ' +
        'باید با اسلش رو به جلو شروع شود. ' +
        'همه فایل‌ها و زیرپوشه‌های زیر این مسیر به‌صورت بازگشتی گنجانده می‌شوند. ' +
        'مثال: /Documents/Reports. ' +
        'مهم: پوشه باید درون کتابخانه مشخص‌شده وجود داشته باشد. ' +
        'مسیرهای خارج از کتابخانه پشتیبانی نمی‌شوند. ' +
        'فقط وقتی دامنه همگام‌سازی «دایرکتوری خاص» است استفاده می‌شود.',
      seafileIncludeSharedTip:
        'وقتی فعال باشد، کتابخانه‌هایی که کاربران دیگر با شما به اشتراک گذاشته‌اند در همگام‌سازی گنجانده می‌شوند. ' +
        'وقتی غیرفعال باشد، فقط کتابخانه‌های متعلق به حساب شما همگام می‌شوند. ' +
        'فقط وقتی دامنه همگام‌سازی «کل حساب» است اعمال می‌شود.',
      seafileBatchSizeTip:
        'تعداد اسنادی که در حین همگام‌سازی در هر دسته پردازش و بازگردانده می‌شوند. ' +
        'مقدار کوچک‌تر حافظه کمتری مصرف می‌کند اما ممکن است در مجموع کندتر باشد. ' +
        'پیش‌فرض: ۱۰۰.',
      jiraDescription:
        'فضای کاری Jira خود را متصل کنید تا Issueها، نظرات و پیوست‌ها همگام شوند.',
      jiraBaseUrlTip:
        'نشانی پایه سایت Jira شما (مثلاً https://your-domain.atlassian.net).',
      jiraProjectKeyTip:
        'اختیاری: همگام‌سازی را به یک کلید پروژه واحد محدود کنید (مثلاً ENG).',
      jiraJqlTip:
        'فیلتر JQL اختیاری. برای تکیه بر فیلترهای پروژه/زمان خالی بگذارید.',
      jiraBatchSizeTip:
        'حداکثر تعداد Issueهای درخواستی از Jira در هر دسته.',
      jiraCommentsTip:
        'نظرات Jira را در سند markdown تولیدشده بگنجانید.',
      jiraAttachmentsTip:
        'پیوست‌ها را در حین همگام‌سازی به‌عنوان اسناد جداگانه دانلود کنید.',
      jiraAttachmentSizeTip:
        'پیوست‌های بزرگ‌تر از این تعداد بایت نادیده گرفته می‌شوند.',
      jiraLabelsTip:
        'برچسب‌هایی که باید در حین نمایه‌سازی نادیده گرفته شوند (جداشده با ویرگول).',
      jiraBlacklistTip:
        'نظراتی که ایمیل نویسنده آن‌ها با این موارد مطابقت داشته باشد نادیده گرفته می‌شوند.',
      jiraScopedTokenTip:
        'هنگام استفاده از توکن‌های محدوده‌دار Atlassian (api.atlassian.com) این را فعال کنید.',
      jiraEmailTip: 'ایمیل مرتبط با حساب/توکن API Jira.',
      jiraTokenTip:
        'توکن API تولیدشده از https://id.atlassian.com/manage-profile/security/api-tokens.',
      jiraPasswordTip:
        'رمز عبور اختیاری برای محیط‌های Jira Server/Data Center.',
      mysqlDescription:
        'به پایگاه داده MySQL متصل شوید تا داده‌ها را با استفاده از پرسمان‌های SQL از جدول‌ها همگام کنید.',
      mysqlQueryTip:
        'پرسمان SQL برای استخراج داده از پایگاه داده شما (مثلاً SELECT * FROM products WHERE status = "active").',
      mysqlContentColumnsTip:
        'نام ستون‌های جداشده با ویرگول که مقادیرشان به‌عنوان محتوای سند برای برداری‌سازی ترکیب می‌شوند.',
      mysqlMetadataColumnsTip:
        'نام ستون‌های جداشده با ویرگول که باید به‌عنوان فراداده سند ذخیره شوند (برداری‌سازی نمی‌شوند اما قابل جستجو هستند).',
      mysqlIdColumnTip:
        'ستونی که به‌عنوان شناسه یکتای سند استفاده شود. اگر مشخص نشود، از یک درهم (hash) محتوا استفاده می‌شود.',
      mysqlTimestampColumnTip:
        'ستون تاریخ‌وزمان/مُهر زمانی برای همگام‌سازی افزایشی. فقط ردیف‌هایی که پس از آخرین همگام‌سازی تغییر کرده‌اند واکشی می‌شوند.',
      postgresqlDescription:
        'به پایگاه داده PostgreSQL متصل شوید تا داده‌ها را با استفاده از پرسمان‌های SQL از جدول‌ها همگام کنید.',
      postgresqlQueryTip:
        "پرسمان SQL برای استخراج داده از پایگاه داده شما (مثلاً SELECT * FROM products WHERE status = 'active').",
      postgresqlContentColumnsTip:
        'نام ستون‌های جداشده با ویرگول که مقادیرشان به‌عنوان محتوای سند برای برداری‌سازی ترکیب می‌شوند.',
      postgresqlMetadataColumnsTip:
        'نام ستون‌های جداشده با ویرگول که باید به‌عنوان فراداده سند ذخیره شوند (برداری‌سازی نمی‌شوند اما قابل جستجو هستند).',
      postgresqlIdColumnTip:
        'ستونی که به‌عنوان شناسه یکتای سند استفاده شود. اگر مشخص نشود، از یک درهم (hash) محتوا استفاده می‌شود.',
      postgresqlTimestampColumnTip:
        'ستون تاریخ‌وزمان/مُهر زمانی برای همگام‌سازی افزایشی. فقط ردیف‌هایی که پس از آخرین همگام‌سازی تغییر کرده‌اند واکشی می‌شوند.',
      bigqueryDescription:
        'به Google BigQuery متصل شوید تا ردیف‌ها را از یک جدول یا یک پرسمان سفارشی GoogleSQL همگام کنید.',
      bigqueryProjectIdTip:
        'پروژه GCP که مالک کارهای پرسمان است (مثلاً my-gcp-project).',
      bigqueryLocationTip:
        'مکان پیش‌فرض برای Client و کارهای پرسمان، مانند US یا EU. برای اینکه BigQuery آن را استنباط کند خالی بگذارید.',
      bigqueryServiceAccountJsonTip:
        'JSON کلید Service Account با دسترسی BigQuery. کل محتوای فایل کلید را جای‌گذاری کنید.',
      bigqueryDatasetIdTip:
        'شناسه Dataset برای حالت جدول. وقتی هیچ پرسمان SQL ارائه نشود، همراه با شناسه جدول الزامی است.',
      bigqueryTableIdTip:
        'شناسه جدول برای حالت جدول. وقتی هیچ پرسمان SQL ارائه نشود، همراه با شناسه Dataset الزامی است.',
      bigqueryQueryTip:
        'پرسمان سفارشی GoogleSQL. بر شناسه Dataset و شناسه جدول اولویت دارد. فقط SQL استاندارد.',
      bigqueryContentColumnsTip:
        'نام ستون‌های جداشده با ویرگول که مقادیرشان به‌عنوان محتوای سند برای برداری‌سازی ترکیب می‌شوند.',
      bigqueryMetadataColumnsTip:
        'نام ستون‌های جداشده با ویرگول که باید به‌عنوان فراداده سند ذخیره شوند (برداری‌سازی نمی‌شوند اما قابل جستجو هستند).',
      bigqueryIdColumnTip:
        'ستونی که به‌عنوان شناسه یکتای سند استفاده شود. اگر مشخص نشود، از یک درهم (hash) محتوا استفاده می‌شود.',
      bigqueryTimestampColumnTip:
        'ستون مُهر زمانی، تاریخ‌وزمان، تاریخ یا عددی برای همگام‌سازی افزایشی. فقط ردیف‌های جدیدتر از آخرین همگام‌سازی واکشی می‌شوند.',
      bigqueryMaximumBytesBilledTip:
        'محافظ سختگیرانه هزینه که به هر کار پرسمان اعمال می‌شود، بر حسب بایت. پیش‌فرض ۱ گیبی‌بایت.',
      bigqueryJobTimeoutMsTip:
        'مهلت زمانی اختیاری هر کار پرسمان بر حسب میلی‌ثانیه.',
      rest_apiDescription:
        'هر نقطه پایانی REST API را با استفاده از یک رابط انعطاف‌پذیر و مبتنی بر پیکربندی به‌عنوان منبع داده متصل کنید.',
      xquikDescription:
        'پست‌های X را با Xquik جستجو کنید و پست‌های منطبق را با یک پایگاه دانش همگام کنید.',
      xquikApiKeyTip:
        'یک کلید API Xquik ایجاد کنید و آن را فقط در این فیلد رمز عبور ذخیره کنید.',
      xquikQueryTip:
        'از کلیدواژه‌ها، هشتگ‌ها، یا عملگرهای جستجوی X مانند from:username استفاده کنید.',
      xquikPageSizeTip:
        'حداکثر پست‌های درخواستی در هر صفحه API. هر پست بازگردانده‌شده ۱ اعتبار Xquik مصرف می‌کند.',
      xquikMaxPagesTip:
        'برای محدودکردن مصرف API، هر همگام‌سازی را پس از این تعداد صفحه متوقف کنید.',
      xquikPageSizeValidation: 'تعداد پست در هر صفحه باید بین ۱ تا ۱۰۰۰۰ باشد.',
      xquikMaxPagesValidation: 'حداکثر صفحات باید بین ۱ تا ۱۰۰۰ باشد.',
      onedriveDescription:
        'OneDrive یا OneDrive for Business را متصل کنید تا فایل‌ها و پوشه‌ها از طریق پرسمان‌های delta در Microsoft Graph نمایه شوند.',
      onedriveTenantIdTip:
        'شناسه Tenant در Azure Active Directory (شناسه Directory) سازمان Microsoft 365.',
      onedriveClientIdTip:
        'شناسه برنامه (Client) ثبت برنامه Azure AD با مجوز Files.Read.All.',
      onedriveClientSecretTip:
        'مقدار Client Secret تولیدشده در ثبت برنامه Azure AD.',
      onedriveFolderPathTip:
        'مسیر زیرپوشه اختیاری برای محدودکردن نمایه‌سازی (مثلاً /Documents/Reports). برای نمایه‌سازی کل درایو خالی بگذارید.',
      outlookDescription:
        'صندوق‌های پستی Outlook / Microsoft 365 را متصل کنید و پیام‌ها را از طریق پرسمان‌های delta در Microsoft Graph نمایه کنید.',
      outlookTenantIdTip:
        'شناسه Tenant در Azure Active Directory (شناسه Directory) سازمان Microsoft 365.',
      outlookClientIdTip:
        'شناسه برنامه (Client) ثبت برنامه Azure AD با مجوز Mail.Read.',
      outlookClientSecretTip:
        'مقدار Client Secret تولیدشده در ثبت برنامه Azure AD.',
      outlookFolderTip:
        'پوشه ایمیل برای همگام‌سازی (مثلاً inbox، sentitems، archive). پیش‌فرض inbox است.',
      outlookUserIdsTip:
        'UPNها یا شناسه‌های شیء صندوق‌های پستی جداشده با ویرگول برای همگام‌سازی. برای همگام‌سازی همه صندوق‌های پستی در Tenant خالی بگذارید (به User.Read.All نیاز دارد).',
      salesforceDescription:
        'یک سازمان Salesforce را متصل کنید و رکوردهای CRM (حساب‌ها، مخاطبین، فرصت‌ها، پرونده‌ها، مقالات دانش) را از طریق SOQL با همگام‌سازی افزایشی نمایه کنید.',
      salesforceInstanceUrlTip:
        'نشانی سازمان Salesforce، مثلاً https://your-domain.my.salesforce.com (بدون اسلش انتهایی).',
      salesforceClientIdTip:
        'Consumer Key یک Connected App با فعال‌بودن Client Credentials Flow و محدوده api.',
      salesforceClientSecretTip:
        'Consumer Secret مربوط به Connected App که برای احراز هویت client-credentials استفاده می‌شود.',
      salesforceObjectsTip:
        'نام‌های API SObject جداشده با ویرگول برای نمایه‌سازی. پیش‌فرض Account، Contact، Opportunity، Case، Knowledge__kav.',
      salesforceApiVersionTip:
        'نسخه REST API در Salesforce (مثلاً v59.0). از نسخه‌ای که سازمان شما پشتیبانی می‌کند استفاده کنید.',
      azure_blobDescription:
        'بلاب‌ها را از یک Container در Azure Blob Storage به یک پایگاه دانش نمایه کنید. از احراز هویت account-key، connection-string و SAS-token پشتیبانی می‌کند. بلاب‌های بدون تغییر از طریق اثرانگشت ETag نادیده گرفته می‌شوند.',
      azureBlobAuthModeTip:
        'روش احراز هویت را انتخاب کنید. Account Key و Connection String به container_name نیاز دارند؛ SAS Token به container_url + sas_token نیاز دارد.',
      azureBlobAccountNameTip:
        'نام حساب ذخیره‌سازی Azure (مثلاً mystorageaccount). برای احراز هویت account-key الزامی است.',
      azureBlobAccountKeyTip:
        'کلید دسترسی حساب ذخیره‌سازی (کدگذاری‌شده با Base64). برای احراز هویت account-key الزامی است.',
      azureBlobConnectionStringTip:
        'رشته اتصال کامل Azure Storage (DefaultEndpointsProtocol=https;AccountName=...;...). برای احراز هویت connection-string الزامی است.',
      azureBlobContainerUrlTip:
        'نشانی کامل HTTPS مربوط به Container (مثلاً https://account.blob.core.windows.net/container). برای احراز هویت SAS-token الزامی است.',
      azureBlobSasTokenTip:
        'رشته پرسمان SAS (بدون «?» ابتدایی). برای احراز هویت SAS-token الزامی است.',
      azureBlobContainerNameTip:
        'نام Container برای نمایه‌سازی. برای احراز هویت account-key و connection-string الزامی است.',
      azureBlobPrefixTip:
        'پیشوند نام بلاب اختیاری برای محدودکردن نمایه‌سازی به یک پوشه مجازی (مثلاً documents/reports/). برای نمایه‌سازی کل Container خالی بگذارید.',
      restApiQueryParamsTip:
        'جفت‌های Key=value (هر کدام در یک خط) که به‌عنوان پارامترهای پرسمان نشانی ارسال می‌شوند. به‌جای جاسازی پارامترها در نشانی از این استفاده کنید.',
      restApiHeadersTip:
        'شیء JSON اختیاری از سرآیندهای HTTP اضافی برای ارسال با هر درخواست.',
      restApiItemsPathTip:
        'نام فیلد یا JSONPath به آرایه اقلام در پاسخ. برای تشخیص خودکار خالی بگذارید («items»، «results»، «data» و غیره را امتحان می‌کند).',
      restApiIdFieldTip:
        'مسیر فیلد درون هر قلم که برای ساخت یک شناسه سند پایدار استفاده می‌شود. برای تولید خودکار از درهم محتوا خالی بگذارید.',
      restApiContentFieldsTip:
        'فهرست جداشده با ویرگول از فیلدهای قلم برای الحاق به محتوای سند.',
      restApiMetadataFieldsTip:
        'فهرست جداشده با ویرگول از فیلدهای قلم برای ذخیره به‌عنوان فراداده.',
      restApiNextCursorPathTip:
        'عبارت JSONPath که به Cursor صفحه بعدی در پاسخ API اشاره می‌کند.',
      restApiPollTimestampFieldTip:
        'مسیر فیلد در هر قلم که زمان آخرین به‌روزرسانی را نشان می‌دهد و برای همگام‌سازی افزایشی استفاده می‌شود.',
      restApiRequestBodyTip:
        'بدنه JSON اختیاری برای ارسال در درخواست‌های POST. همراه با پارامترهای پرسمان و صفحه‌بندی استفاده می‌شود.',
      restApiRequestDelayTip:
        'تأخیر بر حسب ثانیه بین درخواست‌های متوالی صفحه. به جلوگیری از محدودیت نرخ از سوی API کمک می‌کند. برای غیرفعال‌کردن روی ۰ تنظیم کنید.',
      restApiValidationApiKeyRequired:
        'وقتی نوع احراز هویت کلید API (سرآیند) باشد، کلید API الزامی است.',
      restApiValidationApiKeyHeaderNameRequired:
        'وقتی نوع احراز هویت کلید API (سرآیند) باشد، نام سرآیند کلید API الزامی است.',
      restApiValidationBearerTokenRequired:
        'وقتی نوع احراز هویت توکن Bearer باشد، توکن Bearer الزامی است.',
      restApiValidationBasicUsernameRequired:
        'وقتی نوع احراز هویت احراز هویت پایه باشد، نام کاربری الزامی است.',
      restApiValidationBasicPasswordRequired:
        'وقتی نوع احراز هویت احراز هویت پایه باشد، رمز عبور الزامی است.',
      restApiTestConnection: 'آزمون اتصال',
      restApiTestSuccess: 'رابط REST API با موفقیت اعتبارسنجی شد.',
      restApiTestFailed:
        'اعتبارسنجی رابط REST API ناموفق بود. لطفاً پیکربندی و گزارش‌های خود را بررسی کنید.',
      dataSourceTestConnection: 'آزمون اتصال',
      dataSourceTestSuccess: 'اتصال منبع داده با موفقیت اعتبارسنجی شد.',
      dataSourceTestFailed:
        'اعتبارسنجی اتصال منبع داده ناموفق بود. لطفاً پیکربندی و گزارش‌های خود را بررسی کنید.',
      availableSourcesDescription: 'یک منبع داده برای افزودن انتخاب کنید',
      availableSources: 'منابع در دسترس',
      datasourceDescription: 'منبع داده و اتصالات خود را مدیریت کنید',
      chatChannels: 'کانال‌های گفتگو',
      chatChannelsDescription: 'ربات‌ها و اطلاعات ورود کانال گفتگوی خود را مدیریت کنید',
      channelEmptyTip:
        'هنوز هیچ کانال گفتگویی افزوده نشده است. برای اتصال یکی را از زیر انتخاب کنید.',
      availableChannels: 'کانال‌های در دسترس',
      availableChannelsDescription: 'یک کانال گفتگو برای افزودن انتخاب کنید',
      addChannelModalTitle: 'افزودن ربات {{name}}',
      editChannelModalTitle: 'ویرایش ربات {{name}}',
      deleteChannelModalTitle: 'حذف کانال گفتگو',
      deleteChannelModalContent:
        'آیا از حذف این ربات کانال گفتگو مطمئن هستید؟ این عمل قابل بازگشت نیست.',
      connectDialog: 'اتصال دستیار',
      connectDialogTitle: 'اتصال {{name}} به یک دستیار',
      selectDialog: 'یک دستیار انتخاب کنید',
      connectDialogTip:
        'پیام‌های دریافتی این کانال توسط دستیار متصل پاسخ داده می‌شوند. برای قطع اتصال، انتخاب را پاک کنید.',
      notConnected: 'هیچ دستیاری متصل نیست',
      chatChannelDesc: {
        clickclack: 'اتصال یک ربات ClickClack',
        discord: 'اتصال یک ربات Discord',
        dingtalk: 'اتصال یک ربات DingTalk',
        feishu: 'اتصال یک ربات Feishu / Lark',
        googlechat: 'اتصال یک ربات Google Chat',
        irc: 'اتصال به یک سرور IRC',
        line: 'اتصال یک ربات پیام‌رسان LINE',
        matrix: 'اتصال یک ربات Matrix',
        mattermost: 'اتصال یک ربات Mattermost',
        msteams: 'اتصال یک ربات Microsoft Teams',
        nextcloud_talk: 'اتصال یک ربات Nextcloud Talk',
        nostr: 'اتصال یک ربات Nostr',
        qqbot: 'اتصال یک ربات QQ',
        slack: 'اتصال یک ربات Slack',
        synology_chat: 'اتصال یک ربات Synology Chat',
        telegram: 'اتصال یک ربات Telegram',
        tlon: 'اتصال یک ربات Tlon (Urbit)',
        twitch: 'اتصال یک ربات گفتگوی Twitch',
        wecom: 'اتصال یک ربات WeCom',
        whatsapp: 'اتصال یک ربات WhatsApp (جفت‌سازی QR)',
        yuanbao: 'اتصال یک ربات Tencent Yuanbao',
        zalo: 'اتصال یک ربات Zalo',
        zalouser: 'اتصال یک حساب شخصی Zalo',
      },
      save: 'ذخیره',
      search: 'جستجو',
      availableModels: 'مدل‌های در دسترس',
      recommended: 'پیشنهادشده',
      profile: 'نمایه',
      avatar: 'آواتار',
      avatarTip: 'این در نمایه شما نمایش داده می‌شود.',
      profileDescription: 'عکس و جزئیات شخصی خود را اینجا به‌روزرسانی کنید.',
      maxTokens: 'حداکثر توکن',
      maxTokensMessage: 'حداکثر توکن الزامی است',
      maxTokensTip: `حداکثر اندازه زمینه مدل؛ مقدار نامعتبر یا نادرست باعث خطا می‌شود. پیش‌فرض ۵۱۲ است.`,
      maxTokensInvalidMessage: 'لطفاً یک عدد معتبر برای حداکثر توکن وارد کنید.',
      maxTokensMinMessage: 'حداکثر توکن نمی‌تواند کمتر از ۰ باشد.',
      password: 'رمز عبور',
      passwordDescription:
        'لطفاً برای تغییر رمز عبور، رمز عبور فعلی خود را وارد کنید.',
      model: 'ارائه‌دهندگان مدل',
      systemModelDescription: 'لطفاً پیش از شروع این تنظیمات را تکمیل کنید',
      dataSources: 'منابع داده',
      team: 'تیم',
      system: 'سیستم',
      logout: 'خروج',
      api: 'API',
      username: 'نام',
      usernameMessage: 'لطفاً نام کاربری خود را وارد کنید!',
      usernameMaxLength: 'نام باید حداکثر {{max}} کاراکتر باشد.',
      usernameInvalidCharacters:
        "نام فقط می‌تواند شامل حروف، اعداد، فاصله و . _ ' - باشد",
      photo: 'عکس شما',
      photoDescription: 'این در نمایه شما نمایش داده می‌شود.',
      colorSchema: 'طرح رنگ',
      colorSchemaMessage: 'لطفاً طرح رنگ خود را انتخاب کنید!',
      colorSchemaPlaceholder: 'طرح رنگ خود را انتخاب کنید',
      bright: 'روشن',
      dark: 'تیره',
      timezone: 'منطقه زمانی',
      timezoneMessage: 'لطفاً منطقه زمانی خود را وارد کنید!',
      timezonePlaceholder: 'منطقه زمانی خود را انتخاب کنید',
      email: 'ایمیل',
      emailDescription: 'پس از ثبت‌نام، ایمیل قابل تغییر نیست',
      currentPassword: 'رمز عبور فعلی',
      currentPasswordMessage: 'لطفاً رمز عبور خود را وارد کنید!',
      newPassword: 'رمز عبور جدید',
      changePassword: 'تغییر رمز عبور',
      newPasswordMessage: 'لطفاً رمز عبور خود را وارد کنید!',
      newPasswordDescription:
        'رمز عبور جدید شما باید بیش از ۸ کاراکتر باشد.',
      confirmPassword: 'تأیید رمز عبور جدید',
      confirmPasswordMessage: 'لطفاً رمز عبور خود را تأیید کنید!',
      confirmPasswordNonMatchMessage:
        'رمز عبور جدیدی که وارد کردید مطابقت ندارد!',
      cancel: 'انصراف',
      addedModels: 'مدل‌های افزوده‌شده',
      modelsToBeAdded: 'مدل‌هایی که باید افزوده شوند',
      addTheModel: 'افزودن',
      apiKey: 'کلید API',
      apiKeyMessage: 'لطفاً کلید API را وارد کنید',
      apiKeyPlaceholder: 'لطفاً کلید API را وارد کنید',
      apiKeyTip:
        'کلید API را می‌توان با ثبت‌نام نزد تأمین‌کننده مربوطه مدل زبانی به دست آورد.',
      aimlapiGetKey: 'دریافت کلید API',
      aimlapiCheckStatus: 'بررسی وضعیت',
      aimlapiAwaitingConsent: 'در انتظار تأیید در پنجره AI/ML API…',
      aimlapiKeyAdded: 'کلید AI/ML API شما تولید و در بالا افزوده شد.',
      aimlapiAuthDenied: 'مجوز رد شد. لطفاً دوباره تلاش کنید.',
      aimlapiAuthExpired: 'درخواست منقضی شد. لطفاً دوباره تلاش کنید.',
      aimlapiAuthFailed: 'ورود ناموفق بود. لطفاً دوباره تلاش کنید.',
      showMoreModels: 'مشاهده مدل‌ها',
      hideModels: 'پنهان‌کردن مدل‌ها',
      baseUrl: 'نشانی پایه',
      baseUrlTip:
        'اگر کلید API شما از OpenAI است، آن را نادیده بگیرید. هر ارائه‌دهنده واسط دیگری این نشانی پایه را همراه با کلید API ارائه می‌دهد.',
      tongyiBaseUrlTip:
        'برای کاربران چینی، نیازی به پر کردن نیست یا از https://dashscope.aliyuncs.com/compatible-mode/v1 استفاده کنید. برای کاربران بین‌المللی، از https://dashscope-intl.aliyuncs.com/compatible-mode/v1 استفاده کنید',
      siliconBaseUrlTip:
        'برای کاربران چینی، نیازی به پر کردن نیست یا از https://api.siliconflow.cn/v1 استفاده کنید. برای کاربران بین‌المللی، از https://api.siliconflow.com/v1 استفاده کنید',
      tongyiBaseUrlPlaceholder: '(فقط کاربران بین‌المللی، لطفاً به راهنمایی مراجعه کنید)',
      minimaxBaseUrlTip:
        'فقط کاربران بین‌المللی: از https://api.minimax.io/v1 استفاده کنید',
      minimaxBaseUrlPlaceholder:
        '(فقط کاربران بین‌المللی، https://api.minimax.io/v1 را وارد کنید)',
      openaiBaseUrlPlaceholder: 'https://api.openai.com/v1',
      anthropicBaseUrlPlaceholder: 'https://api.anthropic.com/v1',
      siliconflowBaseUrlPlaceholder: 'https://api.siliconflow.cn/v1',
      groupId: 'شناسه گروه',
      providerOrder: 'ترتیب ارائه‌دهندگان',
      paddleocrApiUrl: 'نشانی API PaddleOCR',
      paddleocrApiUrlMessage: 'لطفاً نشانی API PaddleOCR را وارد کنید!',
      paddleocrApiUrlPlaceholder:
        'مثال: https://paddleocr-server.com/layout-parsing',
      paddleocrAccessToken: 'توکن دسترسی AI Studio',
      paddleocrAccessTokenMessage: 'توکن دسترسی برای API پادل‌اواسیآر (اختیاری)',
      paddleocrAccessTokenPlaceholder: 'توکن AI Studio شما (اختیاری)',
      paddleocrAlgorithm: 'الگوریتم PaddleOCR',
      paddleocrAlgorithmMessage: 'لطفاً یک الگوریتم PaddleOCR انتخاب کنید',
      paddleocrSelectAlgorithm: 'انتخاب الگوریتم',
      mineruApiserver: 'سرور API MinerU',
      mineruApiserverMessage: 'لطفاً نشانی سرور API MinerU را وارد کنید!',
      mineruApiserverPlaceholder: 'مثال: http://host.docker.internal:9987',
      mineruOutputDir: 'دایرکتوری خروجی MinerU',
      mineruOutputDirMessage: 'لطفاً دایرکتوری خروجی MinerU را وارد کنید!',
      mineruOutputDirPlaceholder: '/tmp/mineru',
      mineruBackend: 'بک‌اند MinerU',
      mineruBackendMessage: 'لطفاً یک بک‌اند MinerU انتخاب کنید!',
      mineruSelectBackend: 'انتخاب بک‌اند پردازش',
      mineruServerUrl: 'نشانی سرور MinerU',
      mineruServerUrlMessage: 'لطفاً نشانی سرور MinerU را وارد کنید!',
      mineruServerUrlPlaceholder: 'مثال: http://your-vllm-server:30000',
      mineruDeleteOutput: 'حذف فایل‌های خروجی',
      mineruDeleteOutputMessage: 'مقدار نامعتبر برای حذف خروجی',
      opendataloaderApiserver: 'سرور API OpenDataLoader',
      opendataloaderApiserverMessage:
        'لطفاً سرور API OpenDataLoader را وارد کنید!',
      opendataloaderApiserverPlaceholder:
        'http://your-opendataloader-service:9383',
      modify: 'تغییر',
      systemModelSettings: 'تنظیم مدل‌های پیش‌فرض',
      default: 'پیش‌فرض',
      empty: 'داده‌ای نیست',
      docLink: 'پیوند مستندات',
      addInstance: 'افزودن نمونه',
      addInstanceText: 'افزودن نمونه',
      noInstancesConfigured: 'هنوز هیچ نمونه‌ای پیکربندی نشده است.',
      editInstanceName: 'ویرایش نام نمونه',
      models: 'مدل‌ها',
      chatModel: 'مدل زبانی',
      chatModelTip: 'مدل زبانی پیش‌فرض برای هر مجموعه‌داده جدیدی که ایجاد می‌شود.',
      embeddingModel: 'جاسازی',
      embeddingModelTip:
        'مدل جاسازی پیش‌فرض برای هر مجموعه‌داده جدیدی که ایجاد می‌شود. اگر نمی‌توانید مدل جاسازی را از فهرست کشویی بیابید، بررسی کنید آیا از نسخه slim محصول DOCFLOW استفاده می‌کنید (که شامل مدل‌های جاسازی نیست) یا https://DOCFLOW.io/docs/dev/supported_models را بررسی کنید تا ببینید ارائه‌دهنده مدل شما از این مدل پشتیبانی می‌کند یا خیر.',
      img2txtModel: 'VLM',
      img2txtModelTip:
        'مدل VLM پیش‌فرض برای هر مجموعه‌داده جدیدی که ایجاد می‌شود. یک تصویر یا ویدیو را توصیف می‌کند. اگر نمی‌توانید مدلی را از فهرست کشویی بیابید، https://DOCFLOW.io/docs/dev/supported_models را بررسی کنید تا ببینید ارائه‌دهنده مدل شما از این مدل پشتیبانی می‌کند یا خیر.',
      sequence2txtModel: 'ASR',
      sequence2txtModelTip:
        'مدل ASR پیش‌فرض برای هر مجموعه‌داده جدیدی که ایجاد می‌شود. از این مدل برای تبدیل صداها به متن متناظر استفاده کنید.',
      rerankModel: 'رتبه‌بندی مجدد',
      rerankModelTip: `مدل رتبه‌بندی مجدد پیش‌فرض برای رتبه‌بندی مجدد تکه‌ها. اگر نمی‌توانید مدلی را از فهرست کشویی بیابید، https://DOCFLOW.io/docs/dev/supported_models را بررسی کنید تا ببینید ارائه‌دهنده مدل شما از این مدل پشتیبانی می‌کند یا خیر.`,
      ttsModel: 'TTS',
      ttsModelTip:
        'مدل تبدیل متن به گفتار پیش‌فرض. اگر نمی‌توانید مدلی را از فهرست کشویی بیابید، https://DOCFLOW.io/docs/dev/supported_models را بررسی کنید تا ببینید ارائه‌دهنده مدل شما از این مدل پشتیبانی می‌کند یا خیر.',
      workspace: 'فضای کاری',
      upgrade: 'ارتقا',
      addLlmTitle: 'افزودن مدل زبانی',
      editLlmTitle: 'ویرایش مدل {{name}}',
      editModel: 'ویرایش مدل',
      instanceName: 'نام نمونه',
      instanceNameMessage: 'لطفاً نام نمونه را وارد کنید!',
      instanceNameTip:
        'یک نام یکتا برای شناسایی این نمونه ارائه‌دهنده در ذیل همان کارخانه.',
      instanceNamePlaceholder: 'لطفاً نام نمونه را وارد کنید',
      instanceNameExists: 'نام نمونه از قبل وجود دارد',
      deleteInstance: 'حذف نمونه',
      modelName: 'نام مدل',
      modelID: 'شناسه مدل',
      modelUid: 'شناسه یکتای مدل',
      modelNameMessage: 'لطفاً نام مدل خود را وارد کنید!',
      modelType: 'نوع مدل',
      modelTypeMessage: 'لطفاً نوع مدل خود را وارد کنید!',
      addLlmBaseUrl: 'نشانی پایه',
      baseUrlNameMessage: 'لطفاً نشانی پایه خود را وارد کنید',
      mwsApiUrl: 'نشانی API',
      mwsApiUrlMessage: 'لطفاً نشانی API پروژه MWS را وارد کنید',
      mwsApiUrlPlaceholder: 'https://gpt.mwsapis.ru/projects/<project>',
      mwsToken: 'توکن',
      mwsTokenMessage: 'لطفاً توکن MWS را وارد کنید',
      mwsTokenPlaceholder: 'کلید API حساب سرویس MWS',
      paddleocr: {
        apiUrl: 'نشانی API PaddleOCR',
        apiUrlPlaceholder:
          'برای مثال: https://paddleocr-server.com/layout-parsing',
        accessToken: 'توکن دسترسی AI Studio',
        accessTokenPlaceholder: 'توکن AI Studio شما (اختیاری)',
        algorithm: 'الگوریتم PaddleOCR',
        selectAlgorithm: 'انتخاب الگوریتم',
        modelNamePlaceholder: 'برای مثال: paddleocr-from-env-1',
        modelNameRequired: 'نام مدل الزامی است',
        apiUrlRequired: 'نشانی API PaddleOCR الزامی است',
      },
      vision: 'آیا از Vision پشتیبانی می‌کند؟',
      ollamaLink: 'چگونه {{name}} را یکپارچه کنیم',
      FishAudioLink: 'چگونه از FishAudio استفاده کنیم',
      TencentCloudLink: 'چگونه از TencentCloud ASR استفاده کنیم',
      volcModelNameMessage: 'لطفاً نام مدل خود را وارد کنید!',
      addEndpointID: 'شناسه مدل',
      endpointIDMessage: 'لطفاً شناسه مدل خود را وارد کنید',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'لطفاً ARK_API_KEY خود را وارد کنید',
      bedrockModelNameMessage: 'لطفاً نام مدل خود را وارد کنید',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'لطفاً ACCESS KEY خود را وارد کنید',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'لطفاً SECRET KEY خود را وارد کنید',
      bedrockRegion: 'منطقه AWS',
      bedrockRegionMessage: 'لطفاً انتخاب کنید',
      'us-east-2': 'شرق آمریکا (اوهایو)',
      'us-east-1': 'شرق آمریکا (ویرجینیای شمالی)',
      'us-west-1': 'غرب آمریکا (کالیفرنیای شمالی)',
      'us-west-2': 'غرب آمریکا (اورگان)',
      'af-south-1': 'آفریقا (کیپ‌تاون)',
      'ap-east-1': 'آسیا و اقیانوسیه (هنگ‌کنگ)',
      'ap-south-2': 'آسیا و اقیانوسیه (حیدرآباد)',
      'ap-southeast-3': 'آسیا و اقیانوسیه (جاکارتا)',
      'ap-southeast-5': 'آسیا و اقیانوسیه (مالزی)',
      'ap-southeast-4': 'آسیا و اقیانوسیه (ملبورن)',
      'ap-south-1': 'آسیا و اقیانوسیه (بمبئی)',
      'ap-northeast-3': 'آسیا و اقیانوسیه (اوساکا)',
      'ap-northeast-2': 'آسیا و اقیانوسیه (سئول)',
      'ap-southeast-1': 'آسیا و اقیانوسیه (سنگاپور)',
      'ap-southeast-2': 'آسیا و اقیانوسیه (سیدنی)',
      'ap-east-2': 'آسیا و اقیانوسیه (تایپه)',
      'ap-southeast-7': 'آسیا و اقیانوسیه (تایلند)',
      'ap-northeast-1': 'آسیا و اقیانوسیه (توکیو)',
      'ca-central-1': 'کانادا (مرکزی)',
      'ca-west-1': 'غرب کانادا (کلگری)',
      'eu-central-1': 'اروپا (فرانکفورت)',
      'eu-west-1': 'اروپا (ایرلند)',
      'eu-west-2': 'اروپا (لندن)',
      'eu-south-1': 'اروپا (میلان)',
      'eu-west-3': 'اروپا (پاریس)',
      'eu-south-2': 'اروپا (اسپانیا)',
      'eu-north-1': 'اروپا (استکهلم)',
      'eu-central-2': 'اروپا (زوریخ)',
      'il-central-1': 'اسرائیل (تل‌آویو)',
      'mx-central-1': 'مکزیک (مرکزی)',
      'me-south-1': 'خاورمیانه (بحرین)',
      'me-central-1': 'خاورمیانه (امارات)',
      'sa-east-1': 'آمریکای جنوبی (سائوپائولو)',
      'us-gov-east-1': 'AWS GovCloud (شرق آمریکا)',
      'us-gov-west-1': 'AWS GovCloud (غرب آمریکا)',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'لطفاً Secret ID خود را وارد کنید',
      addTencentCloudSK: 'TencentCloud SECRET KEY',
      TencentCloudSKMessage: 'لطفاً SECRET KEY خود را وارد کنید',
      SparkModelNameMessage: 'لطفاً مدل Spark را انتخاب کنید',
      addSparkAPIPassword: 'Spark APIPassword',
      SparkAPIPasswordMessage: 'لطفاً APIPassword خود را وارد کنید',
      addSparkAPPID: 'Spark APP ID',
      SparkAPPIDMessage: 'لطفاً APP ID خود را وارد کنید',
      addSparkAPISecret: 'Spark API SECRET',
      SparkAPISecretMessage: 'لطفاً API SECRET خود را وارد کنید',
      addSparkAPIKey: 'Spark APIKey',
      SparkAPIKeyMessage: 'لطفاً APIKey خود را وارد کنید',
      yiyanModelNameMessage: 'لطفاً نام مدل را وارد کنید',
      addyiyanAK: 'yiyan API Key',
      yiyanAKMessage: 'لطفاً کلید API خود را وارد کنید',
      addyiyanSK: 'yiyan SECRET KEY',
      yiyanSKMessage: 'لطفاً SECRET KEY خود را وارد کنید',
      FishAudioModelNameMessage:
        'لطفاً به مدل ساخت گفتار خود یک نام بدهید',
      addFishAudioAK: 'Fish Audio API Key',
      FishAudioAKMessage: 'لطفاً کلید API خود را وارد کنید',
      addFishAudioRefID: 'FishAudio Reference ID',
      FishAudioRefIDMessage:
        'لطفاً Reference ID را وارد کنید (برای استفاده از مدل پیش‌فرض خالی بگذارید).',
      GoogleModelIDMessage: 'لطفاً شناسه مدل خود را وارد کنید!',
      addGoogleProjectID: 'شناسه پروژه',
      GoogleProjectIDMessage: 'لطفاً شناسه پروژه خود را وارد کنید',
      addGoogleServiceAccountKey:
        'Service Account Key (اگر از Application Default Credentials استفاده می‌کنید خالی بگذارید)',
      GoogleServiceAccountKeyMessage:
        'لطفاً Google Cloud Service Account Key را در قالب base64 وارد کنید',
      addGoogleRegion: 'منطقه Google Cloud',
      GoogleRegionMessage: 'لطفاً منطقه Google Cloud را وارد کنید',
      modelProvidersWarn: `لطفاً ابتدا هم مدل جاسازی و هم مدل زبانی را در <b>تنظیمات > ارائه‌دهندگان مدل</b> اضافه کنید. سپس آن‌ها را در «تنظیم مدل‌های پیش‌فرض» تنظیم کنید.`,
      apiVersion: 'نسخه API',
      apiVersionMessage: 'لطفاً نسخه API را وارد کنید',
      add: 'افزودن',
      updateDate: 'تاریخ',
      role: 'وضعیت',
      invite: 'دعوت عضو',
      inviteTip:
        'فقط کاربران ثبت‌نام‌شده را می‌توان دعوت کرد. لطفاً پیش از ارسال دعوت، حساب را ثبت‌نام کنید.',
      agree: 'پذیرش',
      refuse: 'رد',
      teamMembers: 'اعضای تیم',
      joinedTeams: 'تیم‌های پیوسته',
      sureDelete: 'آیا از حذف این عضو مطمئن هستید؟',
      quit: 'ترک',
      sureQuit: 'آیا از ترک تیمی که به آن پیوسته‌اید مطمئن هستید؟',
      secretKey: 'SECRET KEY',
      publicKey: 'کلید عمومی',
      secretKeyMessage: 'لطفاً SECRET KEY را وارد کنید',
      publicKeyMessage: 'لطفاً کلید عمومی را وارد کنید',
      hostMessage: 'لطفاً میزبان را وارد کنید',
      configuration: 'پیکربندی',
      langfuseDescription:
        'ردیابی‌ها، ارزیابی‌ها، مدیریت پرامپت و سنجه‌ها برای اشکال‌زدایی و بهبود برنامه مدل زبانی شما.',
      viewLangfuseSDocumentation: 'مشاهده مستندات Langfuse',
      view: 'مشاهده',
      modelsToBeAddedTooltip:
        'اگر ارائه‌دهنده مدل شما فهرست نشده است اما ادعای «سازگاری با OpenAI» دارد، کارت سازگار با OpenAI-API را برای افزودن مدل(های) مربوطه انتخاب کنید. ',
      mcp: 'MCP',
      mineru: {
        modelNameRequired: 'نام مدل الزامی است',
        apiServerRequired: 'پیکربندی سرور API MinerU الزامی است',
        serverUrlBackendLimit:
          'نشانی سرور MinerU فقط برای بک‌اند کلاینت HTTP در دسترس است',
        apiserver: 'پیکربندی سرور API MinerU',
        outputDir: 'مسیر دایرکتوری خروجی MinerU',
        backend: 'نوع بک‌اند پردازش MinerU',
        serverUrl: 'نشانی سرور MinerU',
        deleteOutput: 'حذف فایل‌های خروجی پس از پردازش',
        selectBackend: 'انتخاب بک‌اند پردازش',
        backendOptions: {
          pipeline: 'پردازش خط لوله استاندارد',
          vlmTransformers: 'مدل زبانی بصری با Transformers',
          vlmVllmEngine: 'مدل زبانی بصری با موتور vLLM',
          vlmHttpClient: 'مدل زبانی بصری از طریق کلاینت HTTP',
          vlmMlxEngine: 'مدل زبانی بصری با موتور MLX',
          vlmVllmAsyncEngine:
            'مدل زبانی بصری با موتور ناهمگام vLLM (آزمایشی)',
          vlmLmdeployEngine:
            'مدل زبانی بصری با موتور LMDeploy (آزمایشی)',
        },
      },
      somark: {
        modelNameMessage: 'لطفاً نام مدل خود را وارد کنید',
        baseUrl: 'نشانی پایه',
        baseUrlMessage: 'لطفاً نشانی پایه را وارد کنید',
        baseUrlPlaceholder:
          'برای SoMark API، در سرزمین اصلی چین از https://somark.cn/api/v1 استفاده کنید؛ خارج از سرزمین اصلی چین (شامل تایوان چین؛ هنگ‌کنگ چین؛ ماکائو چین؛ و خارج از کشور) از https://somark.ai/api/v1 استفاده کنید. برای استقرار خودمیزبان، از نشانی پایه محلی خود استفاده کنید',
        apiKey: 'کلید API',
        apiKeyPlaceholder:
          'برای SoMark API الزامی است؛ برای استقرار خودمیزبان خالی بگذارید',
        verifyPassed: 'راستی‌آزمایی‌شده',
        verifyFailed: 'راستی‌آزمایی ناموفق بود',
        sectionElementFormats: 'قالب‌های عنصر',
        imageFormat: 'قالب تصویر',
        formulaFormat: 'قالب فرمول',
        tableFormat: 'قالب جدول',
        csFormat: 'قالب فرمول ساختاری شیمیایی',
        formatOptions: {
          url: 'URL',
          base64: 'Base64',
          none: 'هیچ‌کدام',
          latex: 'LaTeX',
          mathml: 'MathML',
          ascii: 'ASCII',
          html: 'HTML',
          markdown: 'Markdown',
          image: 'تصویر',
        },
        sectionFeatureConfig: 'پیکربندی قابلیت',
        enableInlineImage: 'فعال‌سازی تصویر درون‌خطی',
        enableTableImage: 'فعال‌سازی تصویر جدول',
        enableImageUnderstanding: 'فعال‌سازی درک تصویر',
        enableTitleLevelRecognition: 'فعال‌سازی تشخیص سطح عنوان',
        enableTextCrossPage: 'فعال‌سازی متن بین‌صفحه‌ای',
        enableTableCrossPage: 'فعال‌سازی جدول بین‌صفحه‌ای',
        keepHeaderFooter: 'حفظ سرصفحه و پاصفحه',
      },
      modelTypes: {
        chat: 'گفتگو',
        embedding: 'جاسازی',
        rerank: 'رتبه‌بندی مجدد',
        sequence2text: 'ASR',
        tts: 'TTS',
        image2text: 'VLM',
        ocr: 'OCR',
        speech2text: 'ASR',
      },
      showToc: 'نمایش محتوا',
      hideToc: 'پنهان‌کردن محتوا',
      listModels: 'فهرست مدل‌ها',
      allModels: 'همه مدل‌ها',
      listModelsSearchPlaceholder: 'جستجوی مدل‌ها…',
      listModelsEmpty: 'هیچ مدلی در دسترس نیست',
      listModelsLoading: 'در حال بارگذاری مدل‌ها…',
      selectModelBeforeVerify:
        'لطفاً پیش از راستی‌آزمایی حداقل یک مدل انتخاب کنید.',
      selectModelBeforeSave:
        'لطفاً پیش از ذخیره، حداقل یک مدل را کشف و انتخاب کنید.',
      addCustomModel: 'افزودن مدل سفارشی',
      addCustomModelTitle: 'افزودن مدل سفارشی',
      batchAddModels: 'افزودن همه مدل‌ها',
      batchRemoveModels: 'حذف همه مدل‌ها',
      batchVerifyModels: 'راستی‌آزمایی همه مدل‌ها',
      editCustomModelTitle: 'ویرایش مدل',
      modelMaxTokens: 'حداکثر توکن',
      modelFeatures: 'قابلیت‌های مدل',
      modelFeatureToolCall: 'فراخوانی ابزار',
      modelFeatureFunctionCall: 'فراخوانی تابع',
      modelNameRequired: 'نام مدل الزامی است',
      modelNameDuplicate: 'نام مدل از قبل وجود دارد',
      modelTypeRequired: 'لطفاً حداقل یک نوع مدل انتخاب کنید',
      modelMaxTokensMessage: 'حداکثر توکن باید یک عدد باشد',
      modelMaxTokensMinMessage: 'حداکثر توکن باید حداقل ۰ باشد',
    },
    knowledgeCompilation: {
      addTemplateGroup: 'افزودن الگو',
      editTemplateGroup: 'ویرایش الگو',
      deleteTemplateGroupTitle: 'حذف گروه الگو',
      deleteTemplateGroupDescription:
        'آیا از حذف این گروه الگو مطمئن هستید؟ این عمل قابل بازگشت نیست.',
      templateNameRequired: 'لطفاً نام الگو را وارد کنید',
      templateKindRequired: 'لطفاً یک نوع انتخاب کنید',
      builtinTemplates: 'الگو',
      entitySpecification: 'مشخصات موجودیت',
      relationSpecification: 'مشخصات رابطه',
      conceptSpecification: 'مشخصات مفهوم',
      claimSpecification: 'مشخصات ادعا',
      fieldType: 'نوع',
      fieldTypeRequired: 'لطفاً یک نوع انتخاب کنید',
      description: 'توضیحات',
      fieldDescriptionRequired: 'لطفاً توضیحات را وارد کنید',
      fieldRule: 'قاعده',
      addField: 'افزودن فیلد',
      editField: 'ویرایش فیلد',
      selectFieldType: 'یک نوع فیلد انتخاب یا وارد کنید',
      fieldTypeExists: 'این نوع فیلد از قبل وجود دارد',
      example: 'مثال',
      instruction: 'دستورالعمل',
      custom: 'سفارشی',
      blueprints: 'طرح‌های اولیه',
      globalRules: 'قواعد سراسری',
      globalRulesPlaceholder: 'قواعد سراسری گردآوری را وارد کنید',
      wikiMode: 'حالت ویکی',
      entityMode: 'حالت موجودیت',
      topicMode: 'حالت موضوع',
      wikiModeRequired: 'لطفاً یک حالت ویکی انتخاب کنید',
      wikiModeTip:
        'حالت موجودیت: یک صفحه ویکی برای هر موجودیت یا مفهوم. حالت موضوع: به مدل زبانی اجازه دهید موجودیت‌ها یا مفاهیم مرتبط را بر اساس موضوع در یک صفحه ویکی گروه‌بندی کند.',
      raptorTreeSettings: 'تنظیمات درخت RAPTOR',
      summarizationPrompt: 'پرامپت خلاصه‌سازی',
      maxToken: 'حداکثر توکن',
      maxTokenRequired: 'لطفاً حداکثر توکن را وارد کنید',
      clusteringThreshold: 'آستانه خوشه‌بندی',
      clusteringThresholdTip:
        'صدکی را که برای تقسیم خوشه‌ها بر اساس شباهت تکه‌های مجاور استفاده می‌شود تعیین می‌کند. مقادیر بالاتر مرزهای خوشه بیشتری ایجاد می‌کنند.',
      clusteringRatio: 'نسبت خوشه‌بندی',
      clusteringRatioTip:
        'حداکثر تعداد خوشه‌ها را به‌عنوان کسری از تکه‌های ورودی تعیین می‌کند. مقادیر پایین‌تر خوشه‌های کمتری تولید می‌کنند.',
      rechunkByTreeLeaves: 'تکه‌بندی مجدد بر اساس برگ‌های درخت',
      rechunkByTreeLeavesTip:
        'تکه‌های منبع هر خوشه برگ را در یک تکه جایگزین واحد ادغام می‌کند. تکه‌های اصلی حفظ می‌شوند اما به‌عنوان غیرقابل دسترس برای بازیابی علامت‌گذاری می‌شوند. فقط یک الگوی درخت در هر گروه می‌تواند این را فعال کند.',
      rechunkInput: 'تکه‌بندی مجدد خروجی تجزیه‌کننده',
      rechunkInputTip:
        'به مدل زبانی اجازه دهید مرزهای تکه را بر اساس وظیفه گردآوری دانش تعیین کند.',
      rechunkRules: 'قواعد تکه‌بندی مجدد',
      rechunkRulesPlaceholder:
        'توصیف کنید مدل زبانی باید چگونه تکه‌های منبع را برای این وظیفه گردآوری گروه‌بندی کند.',
      jsonPreview: 'پیش‌نمایش JSON',
      processFlow: 'جریان فرایند',
      processFlowComingSoon: 'پیش‌نمایش جریان فرایند به‌زودی',
      compilationTitleSuffix: '»‌ مجموعه‌داده',
      llmWiki: 'ویکی',
      skills: 'به مهارت‌ها',
      navTree: 'درخت/نمایه صفحه',
      graph: 'گراف',
      structureMindmap: 'نقشه ذهنی',
      structureTimeline: 'خط زمانی',
      noWikiPages: 'هنوز ویکی‌ای وجود ندارد',
      noSkills: 'هنوز مهارتی وجود ندارد',
      noStructureGraph: 'هنوز گرافی وجود ندارد',
      noStructureMindmap: 'هنوز نقشه ذهنی‌ای وجود ندارد',
      noStructureTimeline: 'هنوز خط زمانی‌ای وجود ندارد',
      contents: 'ناوبری',
      topics: 'موضوعات',
      selectArtifact: 'برای مشاهده جزئیات، موردی را از فهرست مطالب انتخاب کنید',
      searchEntity: 'جستجوی موجودیت',
      sourceDocuments: 'اسناد منبع',
      clearWikiTitle: 'پاک کردن ویکی',
      clearWikiDescription:
        'آیا از پاک کردن همه صفحات ویکی در این مجموعه‌داده مطمئن هستید؟ این عمل قابل بازگشت نیست.',
      update: 'به‌روزرسانی',
      updateTooltip:
        '{{newlyUploaded}} سند جدید، {{removed}} حذف‌شده، {{changed}} تغییریافته یافت شد. برای گردآوری و ادغام در ویکی فعلی کلیک کنید.',
      updateSheetTitle: 'به‌روزرسانی ویکی',
      updateStructureSheetTitle: 'به‌روزرسانی {{name}}',
      updateStructureTooltip:
        '{{newlyUploaded}} سند جدید، {{removed}} حذف‌شده یافت شد. برای به‌روزرسانی {{name}} کلیک کنید.',
      generate: 'تولید',
      compiling: 'در حال گردآوری…',
      compilingCounts: '{{inflight}} در حال پردازش / {{backlog}} در صف',
      autoCompiled: 'هنگام تجزیه اسناد به‌طور خودکار گردآوری شد.',
      export: 'برون‌بری',
      version: 'نسخه',
      versionHistory: 'تاریخچه نسخه‌ها',
      versionDiff: 'چه چیزی در این نسخه تغییر کرده است',
      noDiffAvailable: 'تغییری برای نمایش وجود ندارد',
      commit: 'ثبت',
      confirmCommit: 'تأیید ثبت',
      versionContent: 'محتوای نسخه',
      versionContentPlaceholder: 'محتوای نسخه را وارد کنید',
      versionContentRequired: 'لطفاً محتوای نسخه را وارد کنید',
      viewUpdateLogs: 'مشاهده گزارش‌های به‌روزرسانی',
      log: 'گزارش',
      createDirectoryFolder: 'ایجاد دایرکتوری',
      directoryRule: 'قاعده',
      deleteStructureConfirm: 'آیا از حذف {{name}} مطمئن هستید؟',
      skillFolders: 'مهارت‌ها',
      skillEmpty: 'هیچ مهارتی در دسترس نیست',
      skillDeleteAllTitle: 'حذف همه مهارت‌ها',
      skillDeleteAllDescription:
        'آیا از حذف همه مهارت‌ها مطمئن هستید؟ این عمل قابل بازگشت نیست.',
      skillDeleteTitle: 'حذف مهارت',
      skillDeleteDescription: 'آیا از حذف این مهارت مطمئن هستید؟',
      navTitle: 'درخت ناوبری',
      navEmpty: 'هیچ گره ناوبری‌ای وجود ندارد',
      navLoadFailed: 'بارگذاری درخت ناوبری ناموفق بود',
      navChildLoadFailed: 'بارگذاری گره‌های فرزند ناموفق بود',
      navLoading: 'در حال بارگذاری...',
      navSelectNode: 'برای مشاهده جزئیات، یک گره فرزند انتخاب کنید',
      navNoDescription: 'بدون توضیحات',
      navKeywords: 'کلیدواژه‌ها',
      navEntities: 'موجودیت‌ها',
      navGraphContent: 'محتوای کامل گراف',
      navDocCount: '{{count}} سند',
      navDeleteAllTitle: 'حذف درخت ناوبری',
      navDeleteAllDescription:
        'آیا از حذف کل درخت ناوبری مطمئن هستید؟ این عمل قابل بازگشت نیست.',
      navDeleteNodeTitle: 'حذف گره',
      navDeleteNodeDescription:
        'آیا از حذف این گره و فرزندانش مطمئن هستید؟',
      representationEmpty: 'هیچ الگوی آرتیفکتی در دسترس نیست.',
      representationUnsupported:
        'این نوع بازنمایی هنوز پشتیبانی نمی‌شود.',
    },
    message: {
      registered: 'ثبت‌نام شد!',
      logout: 'خروج',
      logged: 'وارد شد!',
      pleaseSelectChunk: 'لطفاً تکه را انتخاب کنید!',
      registerDisabled: 'ثبت‌نام کاربر غیرفعال است',
      modified: 'تغییر داده شد',
      created: 'ایجاد شد',
      deleted: 'حذف شد',
      noLangfuseConfigToDelete: 'هیچ پیکربندی Langfuse برای حذف وجود ندارد',
      renamed: 'نام تغییر کرد',
      operated: 'عملیات انجام شد',
      compileAutoGenerated:
        'گردآوری هنگام تجزیه اسناد به‌طور خودکار اجرا می‌شود؛ به راه‌اندازی دستی نیازی نیست.',
      compileNotSupported:
        'گردآوری دستی اینجا پشتیبانی نمی‌شود؛ هنگام تجزیه اسناد به‌طور خودکار اجرا می‌شود.',
      updated: 'به‌روزرسانی شد',
      uploaded: 'بارگذاری شد',
      200: 'سرور با موفقیت داده‌های درخواست‌شده را بازمی‌گرداند.',
      201: 'ایجاد یا تغییر داده با موفقیت انجام شد.',
      202: 'یک درخواست در پس‌زمینه در صف قرار گرفت (وظیفه ناهمگام).',
      204: 'داده با موفقیت حذف شد.',
      400: 'در درخواست صادرشده خطایی وجود داشت و سرور داده‌ای ایجاد یا تغییر نداد.',
      401: 'لطفاً دوباره وارد شوید.',
      403: 'کاربر مجاز است، اما دسترسی ممنوع است.',
      404: 'درخواست برای رکوردی صورت گرفت که وجود ندارد و سرور عملیات را انجام نداد.',
      406: 'قالب درخواست‌شده در دسترس نیست.',
      410: 'منبع درخواست‌شده برای همیشه حذف شده و دیگر در دسترس نخواهد بود.',
      413: 'اندازه کل فایل‌های بارگذاری‌شده به‌صورت یکجا بیش از حد بزرگ است.',
      422: 'هنگام ایجاد یک شیء، خطای اعتبارسنجی رخ داد.',
      500: 'خطای سرور رخ داد، لطفاً سرور را بررسی کنید.',
      502: 'خطای دروازه.',
      503: 'سرویس در دسترس نیست و سرور به‌طور موقت بیش از حد بارگذاری شده یا در حال تعمیر است.',
      504: 'مهلت زمانی دروازه به پایان رسید.',
      requestError: 'خطای درخواست',
      networkAnomalyDescription:
        'در شبکه شما ناهنجاری وجود دارد و نمی‌توانید به سرور متصل شوید.',
      networkAnomaly: 'ناهنجاری شبکه',
      hint: 'راهنمایی',
    },
    fileManager: {
      uploadFolderTitle: 'بارگذاری پوشه',
      folder: 'پوشه',
      files: 'فایل‌ها',
      name: 'نام',
      uploadDate: 'تاریخ بارگذاری',
      knowledgeBase: 'مجموعه‌داده',
      size: 'اندازه',
      action: 'عملیات',
      addToKnowledge: 'پیوند به مجموعه‌داده',
      pleaseSelect: 'لطفاً انتخاب کنید',
      newFolder: 'پوشه جدید',
      file: 'فایل',
      uploadFile: 'بارگذاری فایل',
      parseOnCreation: 'تجزیه هنگام ایجاد',
      directory: 'دایرکتوری',
      uploadTitle: 'فایل خود را برای بارگذاری اینجا بکشید و رها کنید',
      uploadDescription:
        'از بارگذاری تکی یا گروهی فایل پشتیبانی می‌کند. برای DOCFLOW مستقرشده به‌صورت محلی: محدودیت کل اندازه فایل در هر بارگذاری ۱ گیگابایت است، با محدودیت بارگذاری گروهی ۳۲ فایل. سقفی برای تعداد کل فایل‌ها در هر حساب وجود ندارد. برای cloud.DOCFLOW.io، محدودیت کل اندازه فایل در هر بارگذاری ۱۰ مگابایت است، هر فایل نباید از ۱۰ مگابایت فراتر رود و حداکثر ۱۲۸ فایل در هر حساب مجاز است.',
      local: 'بارگذاری‌های محلی',
      s3: 'بارگذاری‌های S3',
      preview: 'پیش‌نمایش',
      fileError: 'خطای فایل',
      uploadLimit:
        'هر فایل نباید از ۱۰ مگابایت فراتر رود و تعداد کل فایل‌ها نباید از ۱۲۸ فراتر رود.',
      destinationFolder: 'پوشه مقصد',
      pleaseUploadAtLeastOneFile: 'لطفاً حداقل یک فایل بارگذاری کنید',
    },
    flow: {
      exportCurrentPage: 'برون‌بری صفحه فعلی',
      preprocess: {
        preprocess: 'پیش‌پردازش',
        mainContent: 'محتوای اصلی',
        abstract: 'چکیده',
        author: 'نویسنده',
        sectionTitle: 'عنوان بخش',
      },
      tags: 'برچسب‌ها',
      canvasCategory: 'دسته بوم',
      editTags: 'ویرایش برچسب‌ها',
      editTagsDescription:
        'برای سازماندهی و فیلترکردن عامل‌های خود برچسب اضافه کنید. برای افزودن، Enter یا ویرگول را فشار دهید.',
      tagsPlaceholder: 'یک برچسب اضافه کنید و Enter را فشار دهید',
      tagSuggestionsLabel: 'برچسب‌های موجود',
      removeTagAriaLabel: 'حذف {{tag}}',
      includeHeadingContent: 'تفکیک محتوای عنوان والد',
      includeHeadingContentTip:
        'وقتی فعال باشد، تکه‌ها فقط شامل مسیر عنوان و محتوای خود هستند؛ محتوای بلافاصله پس از یک عنوان والد به‌عنوان تکه‌ای جداگانه نگه داشته می‌شود.',
      rootAsHeading: 'تنظیم اولین تکه به‌عنوان زمینه سراسری',
      rootAsHeadingTip:
        'اولین تقسیم را به‌عنوان عنوان سراسری در نظر می‌گیرد تا زمینه‌ای یکسان در سراسر سلسله‌مراتب سند حفظ شود. برای رزومه‌ها که بخش اول موضوع را مشخص می‌کند ایده‌آل است.',
      hierarchyTip: `یک درخت عنوان بسازید و تکه‌های خودبسنده تولید کنید که هر کدام مسیر نیاکانی کامل خود را حمل می‌کنند (مثلاً بخش ۱ › فصل ۳ › قسمت ۲ + متن اصلی).\n
بهترین برای: متن‌های بسیار ساختاریافته — مانند مواد قانونی، مقررات، قراردادها و مشخصات فنی — که هر تکه باید بر اساس موقعیتش در سلسله‌مراتب قابل شناسایی باشد.`,
      groupTip: `سند را به‌صورت مسطح در یک سطح عنوان انتخابی تقسیم کنید و بخش‌های کوچک مجاور را ادغام کنید تا جریان معنایی تضمین شود. تکه‌ها مسیر نیاکانی را در بر نمی‌گیرند.\n
بهترین برای: اسنادی با محتوای روان و مرتبط از نظر زمینه — مانند کتاب‌ها، راهنماها، گزارش‌ها و مقالات — که انسجام روایی به کنار هم نگه‌داشتن پاراگراف‌های مجاور بستگی دارد.`,
      enableMultiColumn: 'تشخیص چیدمان چندستونی',
      enableMultiColumnTip:
        'چیدمان‌های صفحه چندستونی را تشخیص و تجزیه کنید تا ترتیب صحیح خواندن حفظ شود. این را برای PDFها یا اسنادی با چیدمان دوستونی یا سبک روزنامه‌ای فعال کنید.',
      removeToc: 'حذف فهرست مطالب اصلی',
      removeTocTip:
        'فهرست مطالب گنجانده‌شده در PDF اصلی را حذف کنید تا به‌عنوان محتوای عادی تجزیه یا برای بازیابی تکه‌بندی نشود.',
      removeHeaderFooter: 'حذف سرصفحه و پاصفحه',
      autoPlay: 'پخش خودکار صوت',
      downloadFileTypeTip: 'نوع فایل برای دانلود',
      downloadFileType: 'نوع فایل دانلود',
      formatTypeError: 'خطای قالب یا نوع',
      variableNameMessage:
        'نام متغیر فقط می‌تواند شامل حروف، زیرخط و اعداد باشد',
      variableDescription: 'توضیحات متغیر',
      defaultValue: 'مقدار پیش‌فرض',
      conversationVariable: 'متغیر گفتگو',
      recommended: 'پیشنهادشده',
      customerSupport: 'پشتیبانی مشتری',
      marketing: 'بازاریابی',
      visualInputFile: 'فایل ورودی بصری',
      consumerApp: 'اپلیکیشن مصرف‌کننده',
      other: 'سایر',
      ingestionPipeline: 'خط لوله دریافت',
      agents: 'عامل‌ها',
      publishedAt: 'منتشرشده در',
      days: 'روز',
      beginInput: 'ورودی آغازین',
      ref: 'متغیر',
      stockCode: 'کد سهام',
      apiKeyPlaceholder:
        'YOUR_API_KEY (از https://serpapi.com/manage-api-key به دست می‌آید)',
      flowStart: 'شروع',
      flowNum: 'N',
      test: 'آزمون',
      extractDepth: 'عمق استخراج',
      format: 'قالب',
      basic: 'پایه',
      advanced: 'پیشرفته',
      general: 'عمومی',
      searchDepth: 'عمق جستجو',
      tavilyTopic: 'موضوع Tavily',
      maxResults: 'حداکثر نتایج',
      includeAnswer: 'گنجاندن پاسخ',
      includeRawContent: 'گنجاندن محتوای خام',
      includeImages: 'گنجاندن تصاویر',
      includeImageDescriptions: 'گنجاندن توصیف تصاویر',
      includeDomains: 'دامنه‌های شامل',
      ExcludeDomains: 'دامنه‌های مستثنا',
      queritCount: 'تعداد نتایج',
      queritCountTip: 'حداکثر تعداد نتایج جستجو برای بازگرداندن را تنظیم کنید.',
      queritChunksPerDoc: 'تکه در هر سند',
      queritChunksPerDocTip:
        'تعداد تکه‌های متنی مرتبط بازگردانده‌شده برای هر نتیجه را از ۱ تا ۳ تنظیم کنید.',
      queritSiteInclude: 'سایت‌های شامل',
      queritSiteIncludeTip:
        'فقط نتایج را از دامنه‌ها یا وب‌سایت‌های مشخص‌شده بازگردانید.',
      queritSiteExclude: 'سایت‌های مستثنا',
      queritSiteExcludeTip:
        'نتایج را از دامنه‌ها یا وب‌سایت‌های مشخص‌شده مستثنا کنید.',
      queritTimeRange: 'محدوده زمانی',
      queritTimeRangeTip:
        'از یک محدوده نسبی مانند d7، w2، m1 یا y1، یا یک محدوده مطلق مانند 2026-01-01to2026-01-31 استفاده کنید.',
      queritCountryInclude: 'کشورهای شامل',
      queritCountryIncludeTip:
        'نتایج مرتبط با کشورهای مشخص‌شده را بازگردانید.',
      queritLanguageInclude: 'زبان‌های شامل',
      queritLanguageIncludeTip: 'نتایج را به زبان‌های مشخص‌شده بازگردانید.',
      queritListPlaceholder: 'یک مقدار وارد کنید',
      queritContentsUrls: 'نشانی‌ها',
      queritContentsUrlsTip:
        'بین یک تا ده نشانی مطلق HTTP یا HTTPS، جداشده با ویرگول، وارد کنید.',
      queritContentsTimeout: 'مهلت زمانی خزش',
      queritContentsTimeoutTip:
        'مهلت زمانی خزش هر صفحه را از ۱ تا ۶۰ ثانیه تنظیم کنید.',
      queritContentsMetadata: 'گنجاندن فراداده صفحه',
      queritContentsMetadataTip:
        'در صورت دسترسی، عنوان صفحه، زمان انتشار، نام سایت و نماد سایت را بازگردانید.',
      Days: 'روز',
      comma: 'ویرگول',
      semicolon: 'نقطه‌ویرگول',
      period: 'نقطه',
      lineBreak: 'خط جدید',
      tab: 'تب',
      space: 'فاصله',
      delimiters: 'جداکننده‌ها',
      one: 'یگانه',
      oneChunkTitle: 'یادداشت',
      oneChunkDescription:
        'همه بخش‌های تجزیه‌شده به‌ترتیب در یک تکه واحد ادغام می‌شوند.',
      flattenMediaToText: 'غیرفعال‌کردن مدل بصری',
      flattenMediaToTextTip:
        'بخش‌های تصویر و جدول را به‌عنوان متن ساده در نظر بگیرید و بهبود بصری را نادیده بگیرید.',
      enableChildrenDelimiters: 'تکه‌های فرزند برای بازیابی استفاده می‌شوند',
      merge: 'ادغام',
      split: 'تقسیم',
      script: 'اسکریپت',
      iterationItemDescription:
        'نمایانگر عنصر فعلی در تکرار است که می‌توان در مراحل بعدی به آن ارجاع داد و آن را دستکاری کرد.',
      maxConcurrency: 'حداکثر هم‌زمانی',
      maxConcurrencyTip:
        '۰ یا ۱ اقلام را یکی‌یکی اجرا می‌کند. مقادیر بزرگ‌تر از ۱ همان تعداد قلم را به‌طور هم‌زمان اجرا می‌کنند.',
      guidingQuestion: 'سؤال راهنما',
      onFailure: 'در صورت شکست',
      userPromptDefaultValue:
        'این دستوری است که باید به عامل ارسال کنید.',
      search: 'جستجو',
      communication: 'ارتباطات',
      developer: 'توسعه‌دهنده',
      typeCommandORsearch: 'یک فرمان تایپ کنید یا جستجو کنید...',
      builtIn: 'داخلی',
      ExceptionDefaultValue: 'مقدار پیش‌فرض استثنا',
      exceptionMethod: 'روش استثنا',
      maxRounds: 'حداکثر دورهای بازتاب',
      delayAfterError: 'تأخیر پس از خطا',
      maxRetries: 'حداکثر دورهای تلاش مجدد',
      toolTimeout: 'مهلت زمانی ابزار',
      toolTimeoutTip:
        'مهلت زمانی بر حسب ثانیه برای یک فراخوانی ابزار واحد (شامل ابزارهای MCP). برای ابزارهای طولانی‌مدت آن را افزایش دهید.',
      maxSteps: 'حداکثر گام‌ها',
      headless: 'بدون رابط گرافیکی',
      enableDefaultExtensions: 'فعال‌سازی افزونه‌های پیش‌فرض',
      enableDefaultExtensionsTip:
        'افزونه‌های پیش‌فرض browser-use (uBlock، مدیریت کوکی، ClearURLs) را فعال کنید. برای جلوگیری از دانلود افزونه در زمان اجرا این را غیرفعال کنید.',
      chromiumSandbox: 'جعبه‌شنی Chromium',
      chromiumSandboxTip:
        'اینکه آیا جعبه‌شنی Chromium فعال شود. در محیط‌های root داکر معمولاً غیرفعال است؛ در میزبان‌های عادی فعال‌کردن آن توصیه می‌شود.',
      persistSession: 'حفظ نشست',
      persistSessionTip:
        'وقتی فعال باشد، این گره مرورگر نشست مرورگر خود را برای جلوگیری از ورودهای مکرر دوباره استفاده می‌کند.',
      uploadSources: 'منابع بارگذاری',
      uploadSourcesTip:
        'از شناسه‌های فایل، نشانی‌های فایل یا متغیرها پشتیبانی می‌کند. می‌توانید چند مقدار را با ویرگول جدا کنید یا از قالب آرایه JSON استفاده کنید (برای مثال ["id1","https://example.com/a.pdf"]).',
      advancedSettings: 'تنظیمات پیشرفته',
      addTools: 'افزودن ابزارها',
      sysPromptDefaultValue: `
      <role>
        شما یک دستیار یاری‌رسان هستید، یک دستیار هوش مصنوعی متخصص در حل مسئله برای کاربر.
        اگر حوزه خاصی ارائه شد، تخصص خود را با آن حوزه تطبیق دهید؛ در غیر این صورت، به‌عنوان یک متخصص عمومی عمل کنید.
      </role>
      <instructions>
        ۱. درخواست کاربر را درک کنید.
        ۲. آن را به زیرمسائل منطقی تجزیه کنید.
        ۳. هر زیرمسئله را گام‌به‌گام و با استدلال شفاف اجرا کنید.
        ۴. دقت و سازگاری را اعتبارسنجی کنید.
        ۵. نتیجه نهایی را به‌روشنی خلاصه کنید.
      </instructions>`,
      singleLineText: 'متن تک‌خطی',
      multimodalModels: 'مدل‌های چندوجهی',
      textOnlyModels: 'مدل‌های فقط‌متنی',
      allModels: 'همه مدل‌ها',
      codeExecDescription: 'منطق سفارشی Python یا Javascript خود را بنویسید.',
      stringTransformDescription:
        'محتوای متن را تغییر می‌دهد. در حال حاضر پشتیبانی می‌کند از: تقسیم یا الحاق متن.',
      foundation: 'پایه',
      tools: 'ابزارها',
      dataManipulation: 'دستکاری داده',
      flow: 'جریان',
      dialog: 'گفتگو',
      cite: 'استناد',
      citeTip: 'citeTip',
      name: 'نام',
      nameMessage: 'لطفاً نام را وارد کنید',
      lastSavedAt: 'آخرین ذخیره در',
      description: 'توضیحات',
      descriptionMessage: 'این یک عامل برای یک وظیفه خاص است.',
      examples: 'مثال‌ها',
      to: 'به',
      msg: 'پیام‌ها',
      msgTip:
        'محتوای متغیر مؤلفه بالادست یا متنی را که خودتان وارد کرده‌اید خروجی دهید.',
      messagePlaceholder: `لطفاً محتوای پیام خود را وارد کنید، از «/» برای درج سریع متغیرها استفاده کنید.`,
      messageMsg: 'لطفاً پیام را وارد کنید یا این فیلد را حذف کنید.',
      addField: 'افزودن گزینه',
      addMessage: 'افزودن پیام',
      loop: 'حلقه',
      loopDescription:
        'حلقه حد بالای تعداد تکرارهای مؤلفه فعلی است؛ وقتی تعداد تکرارها از مقدار حلقه فراتر رود، به این معنی است که مؤلفه نمی‌تواند وظیفه فعلی را تکمیل کند، لطفاً عامل را دوباره بهینه کنید',
      exitLoop: 'خروج از حلقه',
      exitLoopDescription: `معادل «break». این گره هیچ مورد پیکربندی ندارد. وقتی بدنه حلقه به این گره برسد، حلقه پایان می‌یابد.`,
      loopVariables: 'متغیرهای حلقه',
      maximumLoopCount: 'حداکثر تعداد حلقه',
      loopTerminationCondition: 'شرط پایان حلقه',
      yes: 'بله',
      no: 'خیر',
      key: 'کلید',
      componentId: 'شناسه مؤلفه',
      add: 'افزودن',
      operation: 'عملیات',
      run: 'اجرا',
      save: 'ذخیره',
      title: 'شناسه:',
      beginDescription: 'اینجا جایی است که جریان آغاز می‌شود.',
      answerDescription: `مؤلفه‌ای که به‌عنوان رابط بین انسان و ربات عمل می‌کند، ورودی‌های کاربر را دریافت و پاسخ‌های عامل را نمایش می‌دهد.`,
      retrievalDescription: `مؤلفه‌ای که اطلاعات را از مجموعه‌داده‌های مشخص‌شده بازیابی می‌کند. مطمئن شوید مجموعه‌داده‌هایی که انتخاب می‌کنید از مدل جاسازی یکسانی استفاده می‌کنند.`,
      generateDescription: `مؤلفه‌ای که مدل زبانی را به تولید پاسخ ترغیب می‌کند. مطمئن شوید پرامپت به‌درستی تنظیم شده است.`,
      categorizeDescription: `مؤلفه‌ای که از مدل زبانی برای دسته‌بندی ورودی‌های کاربر به دسته‌های از پیش تعریف‌شده استفاده می‌کند. مطمئن شوید نام، توضیحات و مثال‌های هر دسته را به همراه مؤلفه بعدی متناظر مشخص کرده‌اید.`,
      relevantDescription: `مؤلفه‌ای که از مدل زبانی برای ارزیابی اینکه آیا خروجی بالادست با آخرین پرسمان کاربر مرتبط است استفاده می‌کند. مطمئن شوید مؤلفه بعدی را برای هر نتیجه داوری مشخص کرده‌اید.`,
      rewriteQuestionDescription: `مؤلفه‌ای که یک پرسمان کاربر را از مؤلفه تعامل، بر اساس زمینه گفتگوهای قبلی بازنویسی می‌کند.`,
      messageDescription:
        'این مؤلفه خروجی داده نهایی گردش‌کار را به همراه محتوای پیام از پیش تعریف‌شده بازمی‌گرداند. ',
      keywordDescription: `مؤلفه‌ای که N نتیجه برتر جستجو را از ورودی کاربر بازیابی می‌کند. مطمئن شوید مقدار TopN پیش از استفاده به‌درستی تنظیم شده است.`,
      switchDescription: `مؤلفه‌ای که شرایط را بر اساس خروجی مؤلفه‌های قبلی ارزیابی می‌کند و جریان اجرا را بر همان اساس هدایت می‌کند. با تعریف موارد و مشخص‌کردن اقدامات برای هر مورد یا اقدام پیش‌فرض در صورت عدم برآورده‌شدن هیچ شرطی، امکان منطق انشعابی پیچیده را فراهم می‌کند.`,
      wikipediaDescription: `مؤلفه‌ای که از wikipedia.org جستجو می‌کند و با استفاده از TopN تعداد نتایج جستجو را مشخص می‌کند. مجموعه‌داده‌های موجود را تکمیل می‌کند.`,
      promptText: `لطفاً پاراگراف‌های زیر را خلاصه کنید. مراقب اعداد باشید، چیزی از خودتان نسازید. پاراگراف‌ها به شرح زیر:
        {input}
  موارد بالا محتوایی است که باید خلاصه کنید.`,
      createGraph: 'ایجاد عامل',
      createFromTemplates: 'ایجاد از الگو',
      retrieval: 'بازیابی',
      generate: 'تولید',
      answer: 'تعامل',
      categorize: 'دسته‌بندی',
      rewriteQuestion: 'بازنویسی',
      rewrite: 'بازنویسی',
      begin: 'آغاز',
      message: 'پیام',
      blank: 'خالی',
      createFromNothing: 'عامل خود را از ابتدا بسازید',
      addItem: 'افزودن مورد',
      addSubItem: 'افزودن زیرمورد',
      nameRequiredMsg: 'نام الزامی است',
      nameRepeatedMsg: 'نام نمی‌تواند تکراری باشد',
      keywordExtract: 'کلیدواژه',
      keywordExtractDescription: `مؤلفه‌ای که کلیدواژه‌ها را از یک پرسمان کاربر استخراج می‌کند و Top N تعداد کلیدواژه‌های استخراجی را مشخص می‌کند.`,
      baidu: 'Baidu',
      baiduDescription: `مؤلفه‌ای که از baidu.com جستجو می‌کند و با استفاده از TopN تعداد نتایج جستجو را مشخص می‌کند. مجموعه‌داده‌های موجود را تکمیل می‌کند.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'مؤلفه‌ای که از duckduckgo.com جستجو می‌کند و به شما امکان می‌دهد تعداد نتایج جستجو را با استفاده از TopN مشخص کنید. مجموعه‌داده‌های موجود را تکمیل می‌کند.',
      searXNG: 'SearXNG',
      searXNGDescription:
        'مؤلفه‌ای که از طریق نشانی نمونه SearXNG ارائه‌شده شما جستجو می‌کند. TopN و نشانی نمونه را مشخص کنید.',
      keenableSearch: 'Keenable',
      keenableSearchDescription:
        'یک مؤلفه جستجوی وب مبتنی بر Keenable، یک API جستجوی ساخته‌شده برای عامل‌های هوش مصنوعی. به‌طور پیش‌فرض بدون کلید API کار می‌کند (سطح رایگان بدون‌کلید)؛ برای رفع محدودیت‌های نرخ یک کلید اضافه کنید.',
      keenableMode: 'حالت جستجو',
      keenableSite: 'سایت',
      keenableApiKeyTip: 'اختیاری. برای استفاده از سطح رایگان بدون‌کلید خالی بگذارید.',
      youComSearch: 'You.com',
      youComSearchDescription:
        'یک مؤلفه جستجوی وب مبتنی بر نمایه اختصاصی You.com. هر نتیجه به‌جای یک قطعه واحد، عبارات استخراج‌شده از صفحه را حمل می‌کند. به‌طور پیش‌فرض بدون کلید API کار می‌کند (سطح رایگان بدون‌کلید)؛ برای رفع محدودیت‌های نرخ یک کلید اضافه کنید.',
      youComFreshness: 'تازگی',
      youComFreshnessTip:
        'نتایج را بر اساس تازگی انتشارشان محدود کنید.',
      youComFreshnessAny: 'هر زمان',
      youComFreshnessDay: 'روز گذشته',
      youComFreshnessWeek: 'هفته گذشته',
      youComFreshnessMonth: 'ماه گذشته',
      youComFreshnessYear: 'سال گذشته',
      youComApiKeyTip: 'اختیاری. برای استفاده از سطح رایگان بدون‌کلید خالی بگذارید.',
      docGenerator: 'مولد سند',
      docGeneratorDescription: `یک فایل از محتوای Markdown تولید کنید.`,
      browser: 'مرورگر',
      browserDescription:
        'وظایف مرورگر را خودکار کنید. از پیکربندی مدل و اقدامات مبتنی بر پرامپت پشتیبانی می‌کند. منابع بارگذاری از شناسه‌های فایل و نشانی‌ها پشتیبانی می‌کنند و فایل‌های دانلودشده را می‌توان در یک پوشه مقصد ذخیره کرد.',
      subtitle: 'زیرعنوان',
      logoImage: 'تصویر لوگو',
      logoPosition: 'موقعیت لوگو',
      logoWidth: 'عرض لوگو',
      logoHeight: 'ارتفاع لوگو',
      fontFamily: 'خانواده قلم',
      fontSize: 'اندازه قلم',
      titleFontSize: 'اندازه قلم عنوان',
      pageSize: 'اندازه صفحه',
      orientation: 'جهت',
      marginTop: 'حاشیه بالا',
      marginBottom: 'حاشیه پایین',
      filename: 'نام فایل',
      outputDirectory: 'دایرکتوری خروجی',
      addPageNumbers: 'افزودن شماره صفحه',
      addTimestamp: 'افزودن مُهر زمانی',
      watermarkText: 'متن واترمارک',
      channel: 'کانال',
      channelTip: `جستجوی متن یا جستجوی خبر را روی ورودی مؤلفه انجام دهید`,
      text: 'متن',
      news: 'خبر',
      messageHistoryWindowSize: 'اندازه پنجره پیام',
      messageHistoryWindowSizeTip:
        'اندازه پنجره تاریخچه گفتگو که برای مدل زبانی قابل مشاهده است. بزرگ‌تر بهتر است، اما مراقب حداکثر محدودیت توکن مدل زبانی باشید.',
      wikipedia: 'ویکی‌پدیا',
      pubMed: 'PubMed',
      pubMedDescription:
        'مؤلفه‌ای که از https://pubmed.ncbi.nlm.nih.gov/ جستجو می‌کند و به شما امکان می‌دهد تعداد نتایج جستجو را با استفاده از TopN مشخص کنید. مجموعه‌داده‌های موجود را تکمیل می‌کند.',
      bGPT: 'BGPT',
      bGPTDescription:
        'مقالات علمی را از طریق BGPT جستجو کنید و شواهد ساختاریافته از مطالعات تمام‌متن را بازگردانید: روش‌ها، اندازه نمونه‌ها، محدودیت‌ها، تعارض منافع، دسترسی به داده، نقاط کور و پرامپت‌های ابطال‌پذیری. کلید API اختیاری پس از سطح رایگان.',
      bgptApiKey: 'کلید API',
      bgptApiKeyTip:
        'اختیاری. برای سطح رایگان (۵۰ نتیجه اول) خالی بگذارید.',
      bgptDaysBack: 'روزهای گذشته',
      bgptDaysBackTip: 'فیلتر تازگی اختیاری (مثلاً ۳۶۵ برای سال گذشته).',
      email: 'ایمیل',
      emailTip:
        'ایمیل یک فیلد الزامی است. باید یک نشانی ایمیل اینجا وارد کنید.',
      arXiv: 'ArXiv',
      arXivDescription:
        'مؤلفه‌ای که از https://arxiv.org/ جستجو می‌کند و به شما امکان می‌دهد تعداد نتایج جستجو را با استفاده از TopN مشخص کنید. مجموعه‌داده‌های موجود را تکمیل می‌کند.',
      sortBy: 'مرتب‌سازی بر اساس',
      submittedDate: 'تاریخ ارسال',
      lastUpdatedDate: 'تاریخ آخرین به‌روزرسانی',
      relevance: 'ارتباط',
      google: 'Google',
      googleDescription:
        'مؤلفه‌ای که از https://www.google.com/ جستجو می‌کند و به شما امکان می‌دهد تعداد نتایج جستجو را با استفاده از TopN مشخص کنید. مجموعه‌داده‌های موجود را تکمیل می‌کند. لطفاً توجه داشته باشید که این به یک کلید API از serpapi.com نیاز دارد.',
      bing: 'Bing',
      bingDescription:
        'مؤلفه‌ای که از https://www.bing.com/ جستجو می‌کند و به شما امکان می‌دهد تعداد نتایج جستجو را با استفاده از TopN مشخص کنید. مجموعه‌داده‌های موجود را تکمیل می‌کند. لطفاً توجه داشته باشید که این به یک کلید API از microsoft.com نیاز دارد.',
      apiKey: 'کلید API',
      country: 'کشور و منطقه',
      language: 'زبان',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'مؤلفه‌ای که از https://scholar.google.com/ جستجو می‌کند. می‌توانید از Top N برای مشخص‌کردن تعداد نتایج جستجو استفاده کنید.',
      yearLow: 'سال پایین',
      yearHigh: 'سال بالا',
      patents: 'ثبت اختراعات',
      data: 'داده',
      deepL: 'DeepL',
      deepLDescription:
        'مؤلفه‌ای که ترجمه‌های تخصصی‌تری از https://www.deepl.com/ دریافت می‌کند.',
      authKey: 'کلید احراز هویت',
      sourceLang: 'زبان مبدأ',
      targetLang: 'زبان مقصد',
      gitHub: 'GitHub',
      gitHubDescription:
        'مؤلفه‌ای که مخازن را از https://github.com/ جستجو می‌کند. می‌توانید از Top N برای مشخص‌کردن تعداد نتایج جستجو استفاده کنید.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'مؤلفه‌ای که ترجمه‌های تخصصی از https://fanyi.baidu.com/ دریافت می‌کند.',
      appid: 'شناسه برنامه',
      secretKey: 'SECRET KEY',
      domain: 'حوزه',
      transType: 'نوع ترجمه',
      baiduSecretKeyOptions: {
        translate: 'ترجمه عمومی',
        fieldtranslate: 'ترجمه تخصصی حوزه',
      },
      baiduDomainOptions: {
        it: 'فناوری اطلاعات',
        finance: 'مالی و اقتصاد',
        machinery: 'ساخت ماشین‌آلات',
        senimed: 'زیست‌پزشکی',
        novel: 'ادبیات آنلاین',
        academic: 'مقاله علمی',
        aerospace: 'هوافضا',
        wiki: 'علوم انسانی و اجتماعی',
        news: 'اخبار و اطلاعات',
        law: 'قوانین و مقررات',
        contract: 'قرارداد',
      },
      baiduSourceLangOptions: {
        auto: 'تشخیص خودکار',
        zh: 'چینی',
        en: 'انگلیسی',
        yue: 'کانتونی',
        wyw: 'چینی کلاسیک',
        jp: 'ژاپنی',
        kor: 'کره‌ای',
        fra: 'فرانسوی',
        spa: 'اسپانیایی',
        th: 'تایلندی',
        ara: 'عربی',
        ru: 'روسی',
        pt: 'پرتغالی',
        de: 'آلمانی',
        it: 'ایتالیایی',
        el: 'یونانی',
        nl: 'هلندی',
        pl: 'لهستانی',
        bul: 'بلغاری',
        est: 'استونیایی',
        dan: 'دانمارکی',
        fin: 'فنلاندی',
        cs: 'چکی',
        rom: 'رومانیایی',
        slo: 'اسلوونیایی',
        swe: 'سوئدی',
        hu: 'مجاری',
        cht: 'چینی سنتی',
        vie: 'ویتنامی',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'مؤلفه‌ای که اطلاعات آب‌وهوا، مانند دما و کیفیت هوا، را از https://www.qweather.com/ بازیابی می‌کند.',
      lang: 'زبان',
      type: 'نوع',
      webApiKey: 'کلید Web API',
      userType: 'نوع کاربر',
      timePeriod: 'بازه زمانی',
      qWeatherLangOptions: {
        zh: 'چینی ساده‌شده',
        'zh-hant': 'چینی سنتی',
        en: 'انگلیسی',
        de: 'آلمانی',
        es: 'اسپانیایی',
        fr: 'فرانسوی',
        it: 'ایتالیایی',
        ja: 'ژاپنی',
        ko: 'کره‌ای',
        ru: 'روسی',
        hi: 'هندی',
        th: 'تایلندی',
        ar: 'عربی',
        pt: 'پرتغالی',
        bn: 'بنگالی',
        ms: 'مالایی',
        nl: 'هلندی',
        el: 'یونانی',
        la: 'لاتین',
        sv: 'سوئدی',
        id: 'اندونزیایی',
        pl: 'لهستانی',
        tr: 'ترکی',
        cs: 'چکی',
        et: 'استونیایی',
        vi: 'ویتنامی',
        fil: 'فیلیپینی',
        fi: 'فنلاندی',
        he: 'عبری',
        is: 'ایسلندی',
        nb: 'نروژی',
      },
      qWeatherTypeOptions: {
        weather: 'پیش‌بینی آب‌وهوا',
        indices: 'شاخص زندگی آب‌وهوا',
        airquality: 'کیفیت هوا',
      },
      qWeatherUserTypeOptions: {
        free: 'مشترک رایگان',
        paid: 'مشترک پولی',
      },
      qWeatherTimePeriodOptions: {
        now: 'اکنون',
        '3d': '3 days',
        '7d': '۷ روز',
        '10d': '۱۰ روز',
        '15d': '۱۲ روز',
        '30d': '۳۰ روز',
      },
      publish: 'API',
      exeSQL: 'اجرای SQL',
      exeSQLDescription:
        'مؤلفه‌ای که پرسمان‌های SQL را روی یک پایگاه داده رابطه‌ای اجرا می‌کند و از پرسمان‌گیری از MySQL، PostgreSQL یا MariaDB پشتیبانی می‌کند.',
      dbType: 'نوع پایگاه داده',
      database: 'پایگاه داده',
      username: 'نام کاربری',
      userId: 'شناسه کاربر',
      host: 'میزبان',
      port: 'درگاه',
      password: 'رمز عبور',
      switch: 'سوئیچ',
      logicalOperator: 'عملگر منطقی',
      switchOperatorOptions: {
        equal: 'برابر است با',
        notEqual: 'نابرابر است با',
        gt: 'بزرگ‌تر از',
        ge: 'بزرگ‌تر یا مساوی',
        lt: 'کوچک‌تر از',
        le: 'کوچک‌تر یا مساوی',
        contains: 'شامل است',
        notContains: 'شامل نیست',
        startWith: 'شروع می‌شود با',
        endWith: 'پایان می‌یابد با',
        empty: 'خالی است',
        notEmpty: 'خالی نیست',
        in: 'در',
        notIn: 'در ... نیست',
        is: 'هست',
        isNot: 'نیست',
      },
      switchLogicOperatorOptions: {
        and: 'AND',
        or: 'OR',
      },
      operator: 'عملگر',
      value: 'مقدار',
      useTemplate: 'استفاده',
      wenCai: 'WenCai',
      queryType: 'نوع پرسمان',
      wenCaiDescription:
        'مؤلفه‌ای که اطلاعات مالی، شامل قیمت سهام و اخبار سرمایه‌گذاری، را از طیف گسترده‌ای از وب‌سایت‌های مالی به دست می‌آورد.',
      wenCaiQueryTypeOptions: {
        stock: 'سهام',
        zhishu: 'شاخص',
        fund: 'صندوق',
        hkstock: 'سهام هنگ‌کنگ',
        usstock: 'بازار سهام آمریکا',
        threeboard: 'بازار OTC جدید',
        conbond: 'اوراق قابل تبدیل',
        insurance: 'بیمه',
        futures: 'قراردادهای آتی',
        lccp: 'تأمین مالی',
        foreign_exchange: 'ارز خارجی',
      },
      akShare: 'AkShare',
      akShareDescription:
        'مؤلفه‌ای که اخبار مربوط به سهام را از https://www.eastmoney.com/ به دست می‌آورد.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'مؤلفه‌ای که اطلاعات مربوط به یک شرکت سهامی عام را با استفاده از نماد آن پرس‌وجو می‌کند.',
      crawler: 'خزنده وب',
      crawlerDescription:
        'مؤلفه‌ای که کد منبع HTML را از یک نشانی مشخص‌شده خزش می‌کند.',
      proxy: 'پروکسی',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'محتوا',
      },
      extractType: 'نوع استخراج',
      info: 'اطلاعات',
      history: 'تاریخچه',
      financials: 'صورت‌های مالی',
      balanceSheet: 'ترازنامه',
      cashFlowStatement: 'صورت جریان وجوه نقد',
      jin10: 'Jin10',
      jin10Description:
        'مؤلفه‌ای که اطلاعات مالی را از پلتفرم باز Jin10 بازیابی می‌کند، شامل به‌روزرسانی‌های خبری، تقویم‌ها، نرخ‌ها و مراجع.',
      flashType: 'نوع خبر فوری',
      filter: 'فیلتر',
      contain: 'شامل',
      calendarType: 'نوع تقویم',
      calendarDatashape: 'شکل داده تقویم',
      symbolsDatatype: 'نوع داده نمادها',
      symbolsType: 'نوع نمادها',
      jin10TypeOptions: {
        flash: 'اخبار فوری',
        calendar: 'تقویم',
        symbols: 'نرخ‌ها',
        news: 'مرجع',
      },
      jin10FlashTypeOptions: {
        '1': 'اخبار بازار',
        '2': 'اخبار قراردادهای آتی',
        '3': 'اخبار آمریکا-هنگ‌کنگ',
        '4': 'اخبار A-Share',
        '5': 'اخبار کالاها و فارکس',
      },
      jin10CalendarTypeOptions: {
        cj: 'تقویم داده‌های کلان‌اقتصادی',
        qh: 'تقویم قراردادهای آتی',
        hk: 'تقویم بازار سهام هنگ‌کنگ',
        us: 'تقویم بازار سهام آمریکا',
      },
      jin10CalendarDatashapeOptions: {
        data: 'داده',
        event: 'رویداد',
        holiday: 'تعطیلات',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'نرخ کالاها',
        FOREX: 'نرخ فارکس',
        FUTURE: 'نرخ بازار بین‌المللی',
        CRYPTO: 'نرخ ارز دیجیتال',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'فهرست کالاها',
        quotes: 'آخرین نرخ‌های بازار',
      },
      concentrator: 'تجمیع‌کننده',
      concentratorDescription:
        'مؤلفه‌ای که خروجی مؤلفه بالادست را دریافت و آن را به‌عنوان ورودی به مؤلفه‌های پایین‌دست منتقل می‌کند.',
      tuShare: 'TuShare',
      tuShareDescription:
        'مؤلفه‌ای که خلاصه اخبار مالی را از وب‌سایت‌های مالی اصلی به دست می‌آورد و به پژوهش صنعتی و کمّی کمک می‌کند.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Straight flush',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'توکن',
      src: 'منبع',
      startDate: 'تاریخ شروع',
      endDate: 'تاریخ پایان',
      keyword: 'کلیدواژه',
      note: 'یادداشت',
      noteDescription: 'یادداشت',
      notePlaceholder: 'لطفاً یک یادداشت وارد کنید',
      invoke: 'درخواست HTTP',
      invokeDescription: `مؤلفه‌ای که قادر به فراخوانی سرویس‌های راه دور است و از خروجی‌های مؤلفه‌های دیگر یا ثابت‌ها به‌عنوان ورودی استفاده می‌کند.`,
      url: 'نشانی',
      method: 'روش',
      timeout: 'مهلت زمانی',
      headers: 'سرآیندها',
      cleanHtml: 'پاک‌سازی HTML',
      cleanHtmlTip:
        'اگر پاسخ به قالب HTML است و فقط محتوای اصلی مدنظر است، لطفاً آن را روشن کنید.',
      invalidUrl:
        'باید یک نشانی معتبر یا نشانی با جای‌نماهای متغیر در قالب {variable_name} یا {component@variable} باشد',
      reference: 'ارجاع',
      input: 'ورودی',
      output: 'خروجی',
      parameter: 'پارامتر',
      howUseId: 'چگونه از شناسه عامل استفاده کنیم؟',
      content: 'محتوا',
      operationResults: 'نتایج عملیات',
      autosaved: 'ذخیره خودکار شد',
      optional: 'اختیاری',
      pasteFileLink: 'جای‌گذاری پیوند فایل',
      testRun: 'اجرای آزمایشی',
      debugRunLimits:
        'یک اجرای اشکال‌زدایی راستی‌آزمایی می‌کند که جریان بدون خطا اجرا می‌شود: PDF فقط ۲ صفحه اول را تجزیه می‌کند (قالب‌های دیگر همه صفحات را تجزیه می‌کنند)؛ اگر یک گره تکه‌بند وجود داشته باشد، فقط ۳ تکه اول پیش‌نمایش می‌شوند؛ اگر یک گره گردآورنده دانش وجود داشته باشد، فقط به‌صورت محلی اجرا می‌شود و بازسازی مجموعه‌داده یا اعلان را فعال نمی‌کند.',
      template: 'الگو',
      templateDescription:
        'مؤلفه‌ای که خروجی مؤلفه‌های دیگر را قالب‌بندی می‌کند. ۱. از الگوهای Jinja2 پشتیبانی می‌کند، ابتدا ورودی را به یک شیء تبدیل و سپس الگو را رندر می‌کند، ۲. هم‌زمان روش اصلی استفاده از جایگزینی رشته {parameter} را حفظ می‌کند',
      emailComponent: 'ایمیل',
      emailDescription: 'ارسال یک ایمیل به نشانی مشخص‌شده.',
      smtpServer: 'میزبان SMTP',
      smtpPort: 'درگاه SMTP',
      senderEmail: 'نشانی ایمیل فرستنده',
      smtpUsername: 'نام کاربری ورود SMTP',
      authCode: 'رمز عبور SMTP / رمز عبور برنامه',
      senderName: 'نام نمایشی فرستنده',
      toEmail: 'ایمیل گیرنده',
      ccEmail: 'ایمیل رونوشت',
      emailSubject: 'موضوع',
      emailContent: 'محتوا',
      smtpServerRequired: 'لطفاً نشانی سرور SMTP را وارد کنید',
      senderEmailRequired: 'لطفاً ایمیل فرستنده را وارد کنید',
      authCodeRequired: 'لطفاً کد مجوز را وارد کنید',
      toEmailRequired: 'لطفاً ایمیل گیرنده را وارد کنید',
      emailContentRequired: 'لطفاً محتوای ایمیل را وارد کنید',
      emailSentSuccess: 'ایمیل با موفقیت ارسال شد',
      emailSentFailed: 'ارسال ایمیل ناموفق بود',
      dynamicParameters: 'پارامترهای پویا',
      jsonFormatTip:
        'مؤلفه بالادست باید رشته JSON را در قالب زیر ارائه دهد:',
      toEmailTip: 'to_email: ایمیل گیرنده (الزامی)',
      ccEmailTip: 'cc_email: ایمیل رونوشت (اختیاری)',
      subjectTip: 'subject: موضوع ایمیل (اختیاری)',
      contentTip: 'content: محتوای ایمیل (اختیاری)',
      jsonUploadTypeErrorMessage: 'لطفاً فایل json بارگذاری کنید',
      jsonUploadContentErrorMessage: 'خطای فایل json',
      iteration: 'تکرار',
      iterationDescription: `یک مؤلفه حلقه‌ای که روی یک آرایه ورودی تکرار می‌کند و برای هر قلم یک منطق تعریف‌شده را اجرا می‌کند.`,
      delimiterTip: `
این جداکننده برای تقسیم متن ورودی به چند قطعه متنی استفاده می‌شود که هر کدام به‌عنوان قلم ورودی هر تکرار اجرا می‌شود.`,
      delimiterOptions: {
        comma: 'ویرگول',
        lineBreak: 'خط جدید',
        tab: 'تب',
        underline: 'زیرخط',
        diagonal: 'اسلش رو به جلو',
        minus: 'خط تیره',
        semicolon: 'نقطه‌ویرگول',
      },
      addVariable: 'افزودن متغیر',
      variableSettings: 'تنظیمات متغیر',
      systemPrompt: 'پرامپت سیستمی',
      userPrompt: 'پرامپت کاربر',
      tagFile: 'برچسب‌گذاری فایل',
      addCategory: 'افزودن دسته',
      categoryName: 'نام دسته',
      nextStep: 'گام بعدی',
      variableExtractDescription:
        'استخراج اطلاعات کاربر در متغیر سراسری در طول گفتگو',
      variableExtract: 'متغیرها',
      variables: 'متغیرها',
      variablesTip: `کلید متغیر json را با مقدار خالی تنظیم کنید. مثلاً
      {
        "UserCode":"",
        "NumberPhone":""
      }`,
      datatype: 'نوع MIME درخواست HTTP',
      insertVariableTip: `Enter / درج متغیرها`,
      mergePath: 'ادغام مسیر',
      mergePathTip:
        'وقتی فعال باشد، یک پسوند نقطه بلافاصله پس از یک متغیر در یک پرسمان مسیر ادغام می‌شود، مانند {node@result.name}.',
      historyVersion: 'تاریخچه نسخه‌ها',
      version: {
        created: 'ایجادشده',
        details: 'جزئیات نسخه',
        dsl: 'DSL',
        download: 'دانلود',
        version: 'نسخه',
        select: 'هیچ نسخه‌ای انتخاب نشده است',
      },
      setting: 'تنظیمات',
      settings: {
        agentSetting: 'تنظیمات عامل',
        title: 'عنوان',
        description: 'توضیحات',
        upload: 'بارگذاری',
        photo: 'عکس',
        permissions: 'دسترسی‌ها',
        permissionsTip: 'می‌توانید دسترسی‌های اعضای تیم را اینجا تنظیم کنید.',
        me: 'من',
        team: 'تیم',
      },
      noMoreData: 'داده بیشتری نیست',
      searchAgentPlaceholder: 'جستجوی عامل',
      footer: {
        profile: 'کلیه حقوق محفوظ است @ React',
      },
      layout: {
        file: 'فایل',
        knowledge: 'دانش',
        chat: 'گفتگو',
      },
      prompt: 'پرامپت',
      promptTip:
        'از پرامپت سیستمی برای توصیف وظیفه به مدل زبانی، تعیین نحوه پاسخ‌دهی و بیان دیگر الزامات متفرقه استفاده کنید. پرامپت سیستمی اغلب همراه با کلیدها (متغیرها) استفاده می‌شود که به‌عنوان ورودی‌های داده گوناگون برای مدل زبانی عمل می‌کنند. برای نمایش کلیدهای قابل استفاده، از اسلش رو به جلو `/` یا دکمه (x) استفاده کنید.',
      promptMessage: 'پرامپت الزامی است',
      infor: 'اجرای اطلاعاتی',
      knowledgeBasesTip:
        'مجموعه‌داده‌هایی را که می‌خواهید با این دستیار گفتگو مرتبط شوند انتخاب کنید، یا متغیرهای حاوی شناسه مجموعه‌داده را در زیر انتخاب کنید.',
      knowledgeBaseVars: 'متغیرهای مجموعه‌داده',
      code: 'کد',
      codeDescription: 'به توسعه‌دهندگان امکان می‌دهد منطق سفارشی Python بنویسند.',
      dataOperations: 'عملیات داده',
      dataOperationsDescription: 'عملیات گوناگون را روی یک شیء Data انجام می‌دهد.',
      listOperations: 'عملیات فهرست',
      listOperationsDescription: 'عملیات را روی یک فهرست انجام می‌دهد.',
      variableAssigner: 'تخصیص‌دهنده متغیر',
      variableAssignerDescription:
        'این مؤلفه عملیات را روی اشیاء Data انجام می‌دهد، شامل استخراج، فیلترکردن و ویرایش کلیدها و مقادیر در Data.',
      variableAggregator: 'تجمیع‌کننده متغیر',
      variableAggregatorDescription: `
این فرایند متغیرها را از چند شاخه در یک متغیر واحد تجمیع می‌کند تا پیکربندی یکپارچه برای گره‌های پایین‌دست حاصل شود.`,
      inputVariables: 'متغیرهای ورودی',
      runningHintText: 'در حال اجراست...🕞',
      openingSwitch: 'کلید پیام آغازین',
      openingCopy: 'پیام خوش‌آمدگویی',
      openingSwitchTip:
        'کاربران شما این پیام خوش‌آمدگویی را در ابتدا خواهند دید.',
      modeTip: 'حالت تعیین می‌کند که گردش‌کار چگونه راه‌اندازی می‌شود.',
      mode: 'حالت',
      conversational: 'گفتگویی',
      task: 'وظیفه',
      beginInputTip:
        'پارامترهای ورودی تعریف‌شده اینجا توسط مؤلفه‌های گردش‌کار پایین‌دست قابل دسترسی هستند.',
      query: 'متغیرهای پرسمان',
      switchPromptMessage:
        'کلمات پرامپت تغییر خواهند کرد. لطفاً تأیید کنید که آیا می‌خواهید کلمات پرامپت موجود را کنار بگذارید؟',
      queryRequired: 'پرسمان الزامی است',
      queryTip: 'متغیری را که می‌خواهید استفاده کنید انتخاب کنید',
      agent: 'عامل',
      addAgent: 'افزودن عامل',
      agentDescription:
        'مؤلفه‌های عامل مجهز به استدلال، استفاده از ابزار و همکاری چندعاملی می‌سازد. ',
      maxRecords: 'حداکثر رکوردها',
      createAgent: 'جریان عامل',
      stringTransform: 'پردازش متن',
      userFillUp: 'انتظار پاسخ',
      userFillUpDescription: `گردش‌کار را متوقف می‌کند و پیش از ادامه منتظر پیام کاربر می‌ماند.`,
      codeExec: 'کد',
      tavilySearch: 'جستجوی Tavily',
      tavilySearchDescription: 'نتایج جستجو از طریق سرویس Tavily.',
      queritSearch: 'جستجوی Querit',
      queritSearchDescription:
        'وب را با Querit جستجو کنید و نتایج مبتنی بر منبع را برای عامل‌ها بازگردانید.',
      queritContents: 'محتوای Querit',
      queritContentsDescription:
        'صفحات وب را با Querit خزش کنید و محتوای آن‌ها را بازگردانید.',
      tavilyExtract: 'استخراج Tavily',
      tavilyExtractDescription: 'استخراج Tavily',
      log: 'گزارش',
      management: 'مدیریت',
      import: 'وارد کردن',
      export: 'برون‌بری',
      seconds: 'ثانیه',
      subject: 'موضوع',
      tag: 'برچسب',
      tagPlaceholder: 'لطفاً برچسب را وارد کنید',
      descriptionPlaceholder: 'لطفاً توضیحات را وارد کنید',
      line: 'متن تک‌خطی',
      paragraph: 'متن پاراگرافی',
      options: 'گزینه‌های کشویی',
      file: 'بارگذاری فایل',
      integer: 'عدد',
      boolean: 'بولی',
      object: 'شیء JSON',

      logTimeline: {
        begin: 'آماده برای شروع',
        agent: 'عامل در حال فکر کردن است',
        userFillUp: 'در انتظار شما',
        retrieval: 'در حال جستجوی دانش',
        message: 'عامل می‌گوید',
        awaitResponse: 'در انتظار شما',
        switch: 'در حال انتخاب بهترین مسیر',
        iteration: 'پردازش گروهی',
        categorize: 'در حال دسته‌بندی اطلاعات',
        code: 'در حال اجرای یک اسکریپت سریع',
        textProcessing: 'در حال مرتب‌کردن متن',
        tavilySearch: 'در حال جستجوی وب',
        queritSearch: 'در حال جستجوی وب با Querit',
        queritContents: 'در حال خواندن صفحات وب با Querit',
        tavilyExtract: 'در حال خواندن صفحه',
        exeSQL: 'در حال پرس‌وجوی پایگاه داده',
        google: 'در حال جستجوی وب',
        wikipedia: 'در حال جستجوی ویکی‌پدیا',
        googleScholar: 'جستجوی علمی',
        gitHub: 'در حال جستجوی GitHub',
        email: 'در حال ارسال ایمیل',
        httpRequest: 'در حال فراخوانی یک API',
        wenCai: 'در حال پرس‌وجوی داده‌های مالی',
      },
      goto: 'شاخه شکست',
      comment: 'مقدار پیش‌فرض',
      sqlStatement: 'دستور SQL',
      sqlStatementTip:
        'پرسمان SQL خود را اینجا بنویسید. می‌توانید از متغیرها، SQL خام، یا ترکیب هر دو با استفاده از نحو متغیر استفاده کنید.',
      frameworkPrompts: 'چارچوب',
      release: 'انتشار',
      production: 'تولید',
      productionTooltip:
        'این نسخه در محیط تولید منتشر شده است. از طریق API یا صفحه جاسازی‌شده به آن دسترسی پیدا کنید.',
      confirmPublish: 'تأیید انتشار',
      publishIngestionPipeline:
        'شما در آستانه انتشار این خط لوله دریافت هستید.',
      publishAgent: 'شما در آستانه انتشار این عامل هستید',
      linkedDataset: 'مجموعه‌داده پیوندشده:',
      lastPublished: 'آخرین انتشار',
      createFromBlank: 'ایجاد از صفحه خالی',
      createFromTemplate: 'ایجاد از الگو',
      importJsonFile: 'وارد کردن فایل JSON',
      duplicate: 'تکثیر',
      copyOfAgentName: '{{name}} (رونوشت)',
      ceateAgent: 'گردش‌کار',
      createPipeline: 'خط لوله دریافت',
      createIngestionPipeline: 'ایجاد خط لوله دریافت',
      createWorkflow: 'ایجاد گردش‌کار',
      tabList: {
        ingestionPipeline: 'خط لوله دریافت',
        compilationOperator: 'عملگر گردآوری',
        workflow: 'گردش‌کار',
      },
      chooseAgentType: 'نوع عامل را انتخاب کنید',
      parser: 'تجزیه‌کننده',
      parserDescription:
        'متن خام و ساختار را برای پردازش پایین‌دست از فایل‌ها استخراج می‌کند.',
      tokenizer: 'نمایه‌ساز',
      tokenizerRequired: 'لطفاً ابتدا گره نمایه‌ساز را اضافه کنید',
      nodeFormInvalid:
        'ذخیره ممکن نیست: «{{name}}» تنظیمات نامعتبری دارد. لطفاً ابتدا آن‌ها را رفع کنید',
      agentModelMissing:
        'ذخیره ممکن نیست: برای «{{name}}» مدلی انتخاب نشده است. لطفاً ابتدا یکی انتخاب کنید',
      tokenizerDescription:
        'متن را بسته به روش جستجوی انتخابی به ساختار داده موردنیاز تبدیل می‌کند (مثلاً جاسازی برداری برای جستجوی جاسازی).',
      tokenChunker: 'تکه‌بند توکن',
      tokenChunkerDescription:
        'متن را بر اساس طول توکن با جداکننده‌ها و هم‌پوشانی اختیاری به تکه‌ها تقسیم می‌کند.',
      titleChunkerDescription:
        'اسناد را بر اساس سلسله‌مراتب عنوان به بخش‌ها تقسیم می‌کند. سطوح عنوان را با قواعد regex تعریف کنید، سپس حالت سلسله‌مراتبی یا گروهی را برای کنترل نحوه ساختاردهی تکه‌ها انتخاب کنید.',
      titleChunker: 'تکه‌بند عنوان',
      extractor: 'مبدل',
      extractorDescription:
        'از یک مدل زبانی برای استخراج بینش‌های ساختاریافته از تکه‌های سند استفاده کنید — مانند خلاصه‌ها، دسته‌بندی‌ها و غیره.',
      compiler: 'گردآورنده',
      compilerDescription:
        'تکه‌های سند را با استفاده از الگوهای گردآوری دانش به آرتیفکت‌های ساختاریافته گردآوری می‌کند.',
      outputFormat: 'قالب خروجی',
      fileFormatOptions: {
        pdf: 'PDF',
        spreadsheet: 'صفحه‌گسترده',
        image: 'تصویر',
        email: 'ایمیل',
        markdown: 'Markdown',
        'text&code': 'متن و کد',
        html: 'HTML',
        doc: 'DOC',
        docx: 'DOCX',
        slides: 'PPTX',
        audio: 'صوت',
        video: 'ویدیو',
      },
      fields: 'فیلد',
      rule: 'قاعده',
      addRule: 'افزودن قاعده',
      group: 'گروه',
      hierarchy: 'سلسله‌مراتب',
      addRegularExpressions: 'افزودن عبارات باقاعده',
      regularExpressions: 'عبارات باقاعده',
      overlappedPercent: 'درصد هم‌پوشانی (%)',
      searchMethod: 'روش جستجو',
      searchMethodTip: `تعیین می‌کند که محتوا چگونه قابل جستجو باشد — با متن کامل، جاسازی، یا هر دو.
نمایه‌ساز محتوا را در ساختارهای داده متناظر برای روش‌های انتخاب‌شده ذخیره می‌کند.`,
      // file: 'File',
      parserMethod: 'تجزیه‌کننده PDF',
      tableResultType: 'نوع نتیجه جدول',
      markdownImageResponseType: 'نوع پاسخ تصویر Markdown',
      // systemPrompt: 'System Prompt',
      systemPromptPlaceholder:
        'پرامپت سیستمی برای تحلیل تصویر را وارد کنید؛ اگر خالی باشد از مقدار پیش‌فرض سیستم استفاده می‌شود',
      exportJson: 'برون‌بری JSON',
      viewResult: 'مشاهده نتیجه',
      running: 'در حال اجرا',
      summary: 'خلاصه',
      keywords: 'کلیدواژه‌ها',
      questions: 'پرسش‌ها',
      metadata: 'فراداده',
      fieldName: 'مقصد نتیجه',
      enableSummary: 'فعال‌سازی خلاصه',
      useBuiltInTemplate: 'استفاده از الگوی داخلی',
      prompts: {
        system: {
          keywords: `نقش
شما یک تحلیل‌گر متن هستید.

وظیفه
مهم‌ترین کلیدواژه‌ها/عبارت‌های یک قطعه متن مشخص را استخراج کنید.

الزامات
- محتوای متن را خلاصه کنید و {{ topn }} کلیدواژه/عبارت مهم برتر را ارائه دهید.
- کلیدواژه‌ها باید به همان زبان قطعه متن داده‌شده باشند.
- کلیدواژه‌ها با کامای انگلیسی از هم جدا می‌شوند.
- فقط کلیدواژه‌ها را خروجی دهید.`,
          questions: `نقش
شما یک تحلیل‌گر متن هستید.

وظیفه
{{ topn }} پرسش درباره یک قطعه متن مشخص پیشنهاد دهید.

الزامات
- محتوای متن را درک و خلاصه کنید و {{ topn }} پرسش مهم برتر را پیشنهاد دهید.
- پرسش‌ها نباید معانی هم‌پوشان داشته باشند.
- پرسش‌ها باید تا حد امکان محتوای اصلی متن را پوشش دهند.
- پرسش‌ها باید به همان زبان قطعه متن داده‌شده باشند.
- هر پرسش در یک خط.
- فقط پرسش‌ها را خروجی دهید.`,
          summary: `به‌عنوان یک خلاصه‌کننده دقیق عمل کنید. وظیفه شما ایجاد خلاصه‌ای از محتوای ارائه‌شده است که هم مختصر و هم وفادار به متن اصلی باشد.

دستورالعمل‌های کلیدی:
۱. دقت: خلاصه را کاملاً بر اساس اطلاعات داده‌شده بنا کنید. هیچ واقعیت، نتیجه‌گیری یا تفسیر جدیدی که به‌صراحت بیان نشده وارد نکنید.
۲. زبان: خلاصه را به همان زبان متن منبع بنویسید.
۳. بی‌طرفی: نکات کلیدی را بدون سوگیری ارائه دهید و قصد و لحن اصلی محتوا را حفظ کنید. اظهارنظر شخصی نکنید.
۴. اختصار: بر مهم‌ترین ایده‌ها تمرکز کنید و جزئیات جزئی و حشو را حذف کنید.`,
          metadata: `اطلاعات ساختاریافته مهم را از محتوای داده‌شده استخراج کنید. فقط یک رشته JSON معتبر بدون هیچ متن اضافی خروجی دهید. اگر هیچ اطلاعات ساختاریافته مهمی یافت نشد، یک شیء JSON خالی خروجی دهید: {}.

اطلاعات ساختاریافته مهم ممکن است شامل موارد زیر باشد: نام‌ها، تاریخ‌ها، مکان‌ها، رویدادها، واقعیت‌های کلیدی، داده‌های عددی، یا سایر موجودیت‌های قابل استخراج.`,
        },
        user: {
          keywords: `محتوای متن
[متن را اینجا درج کنید]`,
          questions: `محتوای متن
[متن را اینجا درج کنید]`,
          summary: `متن برای خلاصه‌سازی:
[متن را اینجا درج کنید]`,
          metadata: `محتوا: [محتوا را اینجا درج کنید]`,
        },
      },
      cancel: 'لغو',
      swicthPromptMessage:
        'کلمه پرامپت تغییر خواهد کرد. لطفاً تأیید کنید که آیا کلمه پرامپت موجود کنار گذاشته شود؟',
      tokenizerSearchMethodOptions: {
        full_text: 'متن کامل',
        embedding: 'جاسازی',
      },
      filenameEmbeddingWeight: 'وزن جاسازی نام فایل',
      tokenizerFieldsOptions: {
        text: 'متن پردازش‌شده',
        keywords: 'کلیدواژه‌ها',
        questions: 'پرسش‌ها',
        summary: 'زمینه تقویت‌شده',
      },
      imageParseMethodOptions: {
        ocr: 'OCR',
      },
      structuredOutput: {
        configuration: 'پیکربندی',
        structuredOutput: 'خروجی ساختاریافته',
      },
      operations: 'عملیات',
      operationsOptions: {
        selectKeys: 'انتخاب کلیدها',
        literalEval: 'ارزیابی تحت‌اللفظی',
        combine: 'ترکیب',
        filterValues: 'فیلترکردن مقادیر',
        appendOrUpdate: 'افزودن یا به‌روزرسانی',
        removeKeys: 'حذف کلیدها',
        renameKeys: 'تغییر نام کلیدها',
      },
      ListOperationsOptions: {
        nth: 'nاُم',
        head: 'سر',
        tail: 'دم',
        sort: 'مرتب‌سازی',
        filter: 'فیلتر',
        dropDuplicates: 'حذف تکراری‌ها',
      },
      sortMethod: 'روش مرتب‌سازی',
      strictMode: 'حالت سخت‌گیرانه',
      strictModeTip:
        'خاموش از رفتار سهل‌گیرانه استفاده می‌کند و برای n نامعتبر نتیجه خالی برمی‌گرداند. روشن از رفتار سخت‌گیرانه استفاده می‌کند و برای n خارج از محدوده خطا ایجاد می‌کند.',
      SortMethodOptions: {
        asc: 'صعودی',
        desc: 'نزولی',
      },
      variableAssignerLogicalOperatorOptions: {
        overwrite: 'بازنویسی با',
        clear: 'پاک‌کردن',
        set: 'تنظیم',
        add: 'جمع',
        subtract: 'تفریق',
        multiply: 'ضرب',
        divide: 'تقسیم',
        append: 'افزودن',
        extend: 'گسترش',
        removeFirst: 'حذف اولی',
        removeLast: 'حذف آخری',
      },
      webhook: {
        name: 'Webhook',
        methods: 'متدها',
        contentTypes: 'انواع محتوا',
        security: 'امنیت',
        schema: 'ساختار',
        response: 'پاسخ',
        executionMode: 'حالت اجرا',
        executionModeTip:
          'پاسخ پذیرفته‌شده: سیستم بلافاصله پس از اعتبارسنجی درخواست یک تأییدیه برمی‌گرداند، در حالی که گردش‌کار به‌صورت ناهمگام در پس‌زمینه به اجرا ادامه می‌دهد. / پاسخ نهایی: سیستم تنها پس از تکمیل اجرای گردش‌کار پاسخ برمی‌گرداند.',
        authMethods: 'روش‌های احراز هویت',
        authType: 'نوع احراز هویت',
        allowAnonymous: 'اجازه دسترسی ناشناس',
        allowAnonymousTip:
          'وقتی این فعال باشد، هر کسی که این نشانی webhook را داشته باشد می‌تواند عامل را فعال کند.',
        limit: 'محدودیت تناوب درخواست',
        per: 'بازه زمانی',
        maxBodySize: 'حداکثر اندازه بدنه',
        ipWhitelist: 'فهرست سفید IP',
        tokenHeader: 'سرآیند توکن',
        tokenValue: 'مقدار توکن',
        username: 'نام کاربری',
        password: 'گذرواژه',
        algorithm: 'الگوریتم',
        secret: 'SECRET',
        issuer: 'صادرکننده',
        audience: 'مخاطب',
        requiredClaims: 'ادعاهای موردنیاز',
        header: 'سرآیند',
        status: 'وضعیت',
        headersTemplate: 'الگوی سرآیندها',
        bodyTemplate: 'الگوی بدنه',
        basic: 'Basic',
        bearer: 'Bearer',
        apiKey: 'کلید API',
        queryParameters: 'پارامترهای پرسمان',
        headerParameters: 'پارامترهای سرآیند',
        requestBodyParameters: 'پارامترهای بدنه درخواست',
        immediately: 'پاسخ پذیرفته‌شده',
        streaming: 'پاسخ نهایی',
        overview: 'نمای کلی',
        logs: 'گزارش‌ها',
        agentStatus: 'وضعیت عامل:',
      },
      saveToMemory: 'ذخیره در حافظه',
      retrievalFrom: 'بازیابی از',
      id: 'شناسه',
      state: 'وضعیت',
      number: 'شماره',
      latestDate: 'آخرین تاریخ',
      createDate: 'تاریخ ایجاد',
      noDataToExport: 'داده‌ای برای برون‌بری نیست',
      success: 'موفق',
      failed: 'ناموفق',
      logTitle: 'عنوان',
      conversationDetail: 'جزئیات گفتگو',
      user: 'کاربر',
      assistant: 'دستیار',
    },
    llmTools: {
      bad_calculator: {
        name: 'ماشین‌حساب',
        description:
          'ابزاری برای محاسبه مجموع دو عدد (پاسخ نادرست خواهد داد)',
        params: {
          a: 'عدد اول',
          b: 'عدد دوم',
        },
      },
    },
    modal: {
      okText: 'تأیید',
      cancelText: 'لغو',
    },
    mcp: {
      export: 'برون‌بری',
      import: 'وارد کردن',
      url: 'URL',
      serverType: 'نوع سرور',
      addMCP: 'افزودن MCP',
      editMCP: 'ویرایش MCP',
      toolsAvailable: 'ابزار در دسترس',
      mcpServers: 'سرورهای MCP',
      mcpServer: 'سرور MCP',
      customizeTheListOfMcpServers: 'سفارشی‌سازی فهرست سرورهای MCP',
      cachedTools: 'ابزارهای کش‌شده',
      bulkManage: 'مدیریت انبوه',
      exitBulkManage: 'خروج از مدیریت انبوه',
      selected: 'انتخاب‌شده',
      noServerSelected: 'لطفاً حداقل یک سرور MCP انتخاب کنید',
    },
    search: {
      searchApps: 'جستجوی برنامه‌ها',
      createSearch: 'ایجاد جستجو',
      searchGreeting: 'امروز چطور می‌توانم کمکتان کنم؟',
      profile: 'پنهان‌کردن نمایه',
      locale: 'زبان',
      embedCode: 'کد جاسازی',
      id: 'شناسه',
      copySuccess: 'کپی موفق',
      welcomeBack: 'خوش آمدید',
      searchSettings: 'تنظیمات جستجو',
      name: 'نام',
      avatar: 'آواتار',
      description: 'توضیحات',
      datasets: 'مجموعه‌داده‌ها',
      rerankModel: 'مدل رتبه‌بندی مجدد',
      AISummary: 'خلاصه هوش مصنوعی',
      enableWebSearch: 'فعال‌سازی جستجوی وب',
      enableRelatedSearch: 'فعال‌سازی جستجوی مرتبط',
      showQueryMindmap: 'نمایش نقشه ذهنی پرسمان',
      embedApp: 'جاسازی برنامه',
      relatedSearch: 'جستجوی مرتبط',
      descriptionValue: 'شما یک دستیار هوشمند هستید.',
      okText: 'ذخیره',
      cancelText: 'لغو',
      chooseDataset: 'لطفاً ابتدا یک مجموعه‌داده انتخاب کنید',
      selectLocalePlaceholder: 'یک زبان انتخاب کنید',
    },
    language: {
      english: 'انگلیسی',
      chinese: 'چینی',
      spanish: 'اسپانیایی',
      french: 'فرانسوی',
      german: 'آلمانی',
      japanese: 'ژاپنی',
      korean: 'کره‌ای',
      vietnamese: 'ویتنامی',
      russian: 'روسی',
      bulgarian: 'بلغاری',
      arabic: 'عربی',
      turkish: 'ترکی',
      dutch: 'هلندی',
    },
    pagination: {
      total: 'مجموع {{total}}',
      page: '{{page}} / صفحه',
    },
    dataflowParser: {
      result: 'نتیجه',
      parseSummary: 'خلاصه تجزیه',
      parseSummaryTip: 'تجزیه‌کننده：DeepDoc',
      parserMethod: 'روش تجزیه',
      outputFormat: 'قالب خروجی',
      rerunFromCurrentStep: 'اجرای مجدد از گام فعلی',
      rerunFromCurrentStepTip: 'تغییرات شناسایی شد. برای اجرای مجدد کلیک کنید.',
      confirmRerun: 'تأیید فرایند اجرای مجدد',
      confirmRerunModalContent: `
      <p class="text-sm text-text-disabled font-medium mb-2">
        شما در آستانه اجرای مجدد فرایند از گام <span class="text-text-secondary">{{step}}</span> هستید.
      </p>
      <p class="text-sm mb-3 text-text-disabled">این کار:</p><br />
      <ul class="list-disc list-inside space-y-1 text-sm text-text-secondary">
        <li>• نتایج موجود را از گام فعلی به بعد بازنویسی می‌کند</li>
        <li>• یک ورودی گزارش جدید برای ردیابی ایجاد می‌کند</li>
        <li>• گام‌های قبلی بدون تغییر باقی می‌مانند</li>
      </ul>`,
      changeStepModalTitle: 'هشدار تعویض گام',
      changeStepModalContent: `
      <p>شما در حال ویرایش نتایج این مرحله هستید.</p>
      <p>اگر به مرحله بعدی بروید، تغییرات شما از دست می‌رود. </p>
      <p>برای حفظ آن‌ها، لطفاً روی «اجرای مجدد» کلیک کنید تا مرحله فعلی دوباره اجرا شود.</p> `,
      changeStepModalConfirmText: 'به‌هرحال تعویض کن',
      changeStepModalCancelText: 'لغو',
      unlinkPipelineModalTitle: 'قطع پیوند خط لوله دریافت',
      unlinkPipelineModalConfirmText: 'قطع پیوند',
      unlinkPipelineModalContent: `
      <p>پس از قطع پیوند، این مجموعه‌داده دیگر به خط لوله دریافت فعلی متصل نخواهد بود.</p>
      <p>فایل‌هایی که در حال تجزیه هستند تا تکمیل ادامه خواهند یافت</p>
      <p>فایل‌هایی که هنوز تجزیه نشده‌اند دیگر پردازش نخواهند شد</p> <br/>
      <p>آیا مطمئن هستید که می‌خواهید ادامه دهید؟</p> `,
      unlinkSourceModalTitle: 'قطع پیوند منبع داده',
      unlinkSourceModalContent: `
      <p>آیا از قطع پیوند این منبع داده مطمئن هستید؟</p>`,
      unlinkSourceModalConfirmText: 'قطع پیوند',
    },
    datasetOverview: {
      downloadTip: 'فایل‌هایی که از منابع داده دانلود می‌شوند. ',
      processingTip: 'فایل‌هایی که توسط خط لوله دریافت پردازش می‌شوند.',
      totalFiles: 'مجموع فایل‌ها',
      downloading: 'در حال دانلود',
      downloadSuccessTip: 'مجموع دانلودهای موفق',
      downloadFailedTip: 'مجموع دانلودهای ناموفق',
      processingSuccessTip: 'مجموع فایل‌های پردازش‌شده موفق',
      processingFailedTip: 'مجموع فرایندهای ناموفق',
      processing: 'در حال پردازش',
      noData: 'هنوز گزارشی نیست',
    },

    deleteModal: {
      delAgent: 'حذف عامل',
      delDataset: 'حذف مجموعه‌داده',
      delSearch: 'حذف جستجو',
      delFile: 'حذف فایل',
      delFiles: 'حذف فایل‌ها',
      delFilesContent: '{{count}} فایل انتخاب شد',
      delChat: 'حذف گفتگو',
      delMember: 'حذف عضو',
      delMemory: 'حذف حافظه',
    },

    empty: {
      noMCP: 'هیچ سرور MCP در دسترس نیست',
      agentTitle: 'هنوز برنامه عاملی ایجاد نشده است',
      notFoundAgent: 'برنامه عامل یافت نشد',
      datasetTitle: 'هنوز مجموعه‌داده‌ای ایجاد نشده است',
      notFoundDataset: 'مجموعه‌داده یافت نشد',
      chatTitle: 'هنوز برنامه گفتگویی ایجاد نشده است',
      notFoundChat: 'برنامه گفتگو یافت نشد',
      searchTitle: 'هنوز برنامه جستجویی ایجاد نشده است',
      notFoundSearch: 'برنامه جستجو یافت نشد',
      memoryTitle: 'هنوز حافظه‌ای ایجاد نشده است',
      notFoundMemory: 'حافظه یافت نشد',
      skillsTitle: 'هنوز فضای مهارتی ایجاد نشده است',
      notFoundSkills: 'فضای مهارت یافت نشد',
      addNow: 'اکنون اضافه کنید',
    },

    admin: {
      loginTitle: 'کنسول مدیریت',
      title: 'DOCFLOW',
      confirm: 'تأیید',
      close: 'بستن',
      yes: 'بله',
      no: 'خیر',
      delete: 'حذف',
      cancel: 'لغو',
      reset: 'بازنشانی',
      import: 'وارد کردن',
      description: 'توضیحات',
      noDescription: 'بدون توضیحات',
      none: 'هیچ‌کدام',

      resourceType: {
        dataset: 'مجموعه‌داده',
        chat: 'گفتگو',
        agent: 'عامل',
        search: 'جستجو',
        file: 'فایل',
        team: 'تیم',
        memory: 'حافظه',
      },

      permissionType: {
        enable: 'فعال‌سازی',
        read: 'خواندن',
        write: 'نوشتن',
        share: 'اشتراک‌گذاری',
      },

      serviceStatus: 'وضعیت سرویس',
      userManagement: 'مدیریت کاربران',
      sandboxSettings: 'تنظیمات سندباکس',
      registrationWhitelist: 'فهرست سفید ثبت‌نام',
      roles: 'نقش‌ها',
      monitoring: 'پایش',

      sandboxSettingsPage: {
        description:
          'ارائه‌دهنده سندباکس اجرای کد خود را پیکربندی کنید. سندباکس توسط مؤلفه کد در عامل‌ها استفاده می‌شود.',
        providerSelection: 'انتخاب ارائه‌دهنده',
        providerSelectionDescription:
          'یک ارائه‌دهنده سندباکس برای اجرای کد انتخاب کنید',

        namedProviderConfiguration: 'پیکربندی {{name}}',
        namedProviderConfigurationDescription:
          'تنظیمات اتصال برای {{name}} را پیکربندی کنید.',

        saveConfiguration: 'ذخیره پیکربندی',
        saving: 'در حال ذخیره...',

        testConnectionResultModal: {
          title: 'نتیجه آزمایش اتصال',
          testing: 'در حال آزمایش اتصال به ارائه‌دهنده سندباکس...',
          success: 'اتصال به ارائه‌دهنده سندباکس با موفقیت انجام شد',
          failed: 'اتصال به ارائه‌دهنده سندباکس ناموفق بود',

          exitCode: 'کد خروج',
          executionTime: 'زمان اجرا',
          stdout: 'خروجی استاندارد',
          stderr: 'خروجی خطا / ردیابی پشته',
        },

        testConnection: 'آزمایش اتصال',
        testing: 'در حال آزمایش...',
      },

      selectFile: 'انتخاب فایل',
      noFileSelected: 'هیچ فایلی انتخاب نشده است',

      back: 'بازگشت',
      active: 'فعال',
      inactive: 'غیرفعال',
      enable: 'فعال‌سازی',
      disable: 'غیرفعال‌سازی',
      all: 'همه',
      actions: 'اقدامات',
      newUser: 'کاربر جدید',
      email: 'ایمیل',
      name: 'نام',
      nickname: 'نام مستعار',
      status: 'وضعیت',
      id: 'شناسه',
      serviceType: 'نوع سرویس',
      host: 'میزبان',
      port: 'درگاه',

      role: 'نقش',
      user: 'کاربر',
      userType: 'نوع کاربر',
      superuser: 'ابرکاربر',
      normalUser: 'عادی',

      createTime: 'زمان ایجاد',
      lastLoginTime: 'آخرین زمان ورود',
      lastUpdateTime: 'آخرین زمان به‌روزرسانی',

      isAnonymous: 'ناشناس است',
      isSuperuser: 'ابرکاربر است',

      deleteUser: 'حذف کاربر',
      deleteUserConfirmation: 'آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟',

      createNewUser: 'ایجاد کاربر جدید',
      changePassword: 'تغییر گذرواژه',
      newPassword: 'گذرواژه جدید',
      confirmNewPassword: 'تأیید گذرواژه جدید',
      password: 'گذرواژه',
      confirmPassword: 'تأیید گذرواژه',

      invalidEmail: 'لطفاً یک نشانی ایمیل معتبر وارد کنید!',
      passwordRequired: 'لطفاً گذرواژه خود را وارد کنید!',
      passwordMinLength: 'گذرواژه باید بیش از ۸ نویسه باشد.',
      confirmPasswordRequired: 'لطفاً گذرواژه خود را تأیید کنید!',
      confirmPasswordDoNotMatch: 'گذرواژه‌ای که وارد کردید مطابقت ندارد!',

      read: 'خواندن',
      write: 'نوشتن',
      share: 'اشتراک‌گذاری',
      create: 'ایجاد',

      extraInfo: 'اطلاعات اضافی',
      serviceDetail: `جزئیات سرویس {{name}}`,
      taskExecutorDetail: 'جزئیات اجراکننده وظیفه',

      whitelistManagement: 'مدیریت فهرست سفید',
      exportAsExcel: 'برون‌بری Excel',
      importFromExcel: 'وارد کردن Excel',
      createEmail: 'ایجاد ایمیل',
      deleteEmail: 'حذف ایمیل',
      editEmail: 'ویرایش ایمیل',
      deleteWhitelistEmailConfirmation:
        'آیا مطمئن هستید که می‌خواهید این ایمیل را از فهرست سفید حذف کنید؟ این اقدام قابل بازگشت نیست.',

      importWhitelist: 'وارد کردن فهرست سفید (Excel)',
      importSelectExcelFile: 'فایل Excel (.xlsx)',
      importOverwriteExistingEmails: 'بازنویسی ایمیل‌های موجود',
      importInvalidExcelFile: 'لطفاً یک فایل Excel معتبر انتخاب کنید',
      importFileRequired: 'لطفاً فایلی برای وارد کردن انتخاب کنید',
      importFileTips:
        'فایل باید یک ستون سرآیند واحد به نام <code>email</code> داشته باشد.',

      chunkNum: 'تکه‌ها',
      docNum: 'اسناد',
      tokenNum: 'توکن‌های استفاده‌شده',
      language: 'زبان',
      createDate: 'تاریخ ایجاد',
      updateDate: 'تاریخ به‌روزرسانی',
      permission: 'دسترسی',

      agentTitle: 'عنوان عامل',
      canvasCategory: 'دسته بوم',

      newRole: 'نقش جدید',
      addNewRole: 'افزودن نقش جدید',
      roleName: 'نام نقش',
      roleNameRequired: 'نام نقش الزامی است',
      resources: 'منابع',

      editRoleDescription: 'ویرایش توضیحات نقش',
      deleteRole: 'حذف نقش',
      deleteRoleConfirmation:
        'آیا مطمئن هستید که می‌خواهید این نقش را حذف کنید؟ این اقدام قابل بازگشت نیست.',

      alive: 'فعال',
      timeout: 'وقفه زمانی',
      fail: 'شکست',
    },
    explore: {
      title: 'راه‌اندازی',
      canvasList: 'فهرست بوم‌ها',
      sessions: 'نشست‌ها',
      newSession: 'نشست جدید',
      newSessionLabel: 'شروع یک گفتگوی جدید',
      deleteSession: 'حذف نشست',
      searchCanvas: 'جستجوی بوم...',
      searchSessions: 'جستجوی نشست‌ها...',
      noCanvasSelected: 'لطفاً یک بوم انتخاب کنید',
      noSessionSelected: 'لطفاً یک نشست انتخاب کنید یا نشست جدیدی ایجاد کنید',
      noSessionsFound: 'هیچ نشستی یافت نشد',
      createFirstSession: 'اولین نشست خود را ایجاد کنید',
      noCanvasFound: 'هیچ بومی یافت نشد',
      deleteSelectedConfirm:
        'آیا مطمئن هستید که می‌خواهید {{count}} نشست را حذف کنید؟',
      batchDeleteSessions: 'حذف نشست‌ها',
    },
  },
};
